import { useContext, useEffect, useRef, useState } from "react";
import InputField from "./InputField";
import SelectField from "./SelectField";
import toast from "react-hot-toast";
import RegularLoader from "../Loader/RegularLoader";
import BlueButton from "../Common/BlueButton";
import { APPID, BASE_URL, SecretKey, SWAGGER_URL } from "../../config/api";
import esign from "../../asset/images/esign.webp";
import verifiedimg from "../../asset/images/verified.avif";
import FullPageLoader from "../Common/FullPageLoader";
import { AuthContext } from "../../context/AuthContext";

export default function FormBody({ currentStep, form, emailVerified,
  setEmailVerified,
  phoneVerified,
  setPhoneVerified,updateField, selectedPackage, setSelectedPackage,panApiResponse, setPanApiResponse, verifyAadhaar, aadhaarStatus, setAadhaarStatus, setForm, esignStatusLoading, setIsPaymentSuccess, gstVerified,
  setGstVerified, gstResponse, setGstResponse,bankVerified, setBankVerified, bankResponse, setBankResponse, zohoId, setZohoId }) {
  const isUnregistered = form.gstTreatment === "unregistered";

  const { user } = useContext(AuthContext);

  const leads = user?.leads || [];

  const [errors, setErrors] = useState({});

  const [originalPhone, setOriginalPhone] = useState("");
  const [emailOtpSent, setEmailOtpSent] = useState(false);

  const [phoneOtpSent, setPhoneOtpSent] = useState(false);

  const [emailOtp, setEmailOtp] = useState("");
  const [phoneOtp, setPhoneOtp] = useState("");
  const [packages, setPackages] = useState([]);
  // const [selectedPackage, setSelectedPackage] = useState(null);
  const [loading, setLoading] = useState(false);
  const authUser = JSON.parse(localStorage.getItem("authUserData") || "{}");
  const id = authUser?.id;
  const role = authUser?.role;
  const [agreementUrl, setAgreementUrl] = useState(null);
  const [hasScrolledToBottom, setHasScrolledToBottom] = useState(false);
  const [panMessage, setPanMessage] = useState("");
  // const [aadhaarStatus, setAadhaarStatus] = useState("idle"); // idle | loading | verifying | success | error
  const [aadhaarError, setAadhaarError] = useState("");
  const esignPopupRef = useRef(null);
  const esignPollRef = useRef(null);
  const aadhaarInputsRef = useRef([]);

  const [isUploaded, setIsUploaded] = useState(false);

  const [resendEmailTimer, setResendEmailTimer] = useState(0);

  const [sendingEmailOtp, setSendingEmailOtp] = useState(false);
  const [verifyingEmailOtp, setVerifyingEmailOtp] = useState(false);

  const [sendingOtp, setSendingOtp] = useState(false);
  const [resendTimer, setResendTimer] = useState(0); // seconds
  const [verifyingOtp, setVerifyingOtp] = useState(false);
  const [uploading, setUploading] = useState(false);

  const [paymentKeys, setPaymentKeys] = useState({
    key_id: "",
    key_secret: ""
  });

  const [keyLoading, setKeyLoading] = useState(false);
  const [paymentCompleted, setPaymentCompleted] = useState(false);
  const [gstLoading, setGstLoading] = useState(false);
  const [bankLoading, setBankLoading] = useState(false);
  const [paymentSaving, setPaymentSaving] = useState(false);

  const [pageLoading, setPageLoading] = useState(true);
  const isRetailer = role === 5;
  const isNonRetailer = role === 2 || role === 4;

  const handlePhoneChange = (value) => {
    const digitsOnly = value.replace(/\D/g, "").slice(0, 10);

    handleChange("phone", digitsOnly);

    // reset OTP if number changes
    setPhoneOtpSent(false);
    setPhoneVerified(false);
    setPhoneOtp("");
  };

  useEffect(() => {
  const authUser = JSON.parse(localStorage.getItem("authUserData") || "{}");
  const userId = authUser?.id;

  if (!userId) {
    setPageLoading(false);
    return;
  }

  const fetchUserFromApi = async () => {
    try {
      setPageLoading(true);

      const res = await fetch(`${BASE_URL}common/get-users?id=${userId}`);
      const json = await res.json();

      if (!json?.status || !json?.data?.length) return;

      const user = json.data[0];
      const existingUser = JSON.parse(localStorage.getItem("authUserData") || "{}");

        localStorage.setItem(
          "authUserData",
          JSON.stringify({
            ...existingUser,
            ...user,
            leads: Array.isArray(existingUser.leads)
              ? existingUser.leads
              : [],
          })
        );
      if (Number(user?.is_payment_success) === 1 || Number(user?.is_verified) >= 2) {
        setPaymentCompleted(true);
        setIsPaymentSuccess(true);
      }

      // BASIC DETAILS
      setForm(prev => ({
        ...prev,
        businessName: user.business_name || "",
        authorisedName: user.business_name || "",
        email: user.contact_email || "",
        phone: user.contact_phone || "",
        address_line1: user.address_line1 || "",
        address_line2: user.address_line2 || "",
        city: user.city || "",
        district: user.district || "",
        state: user.state || "",
        pincode: user.pincode || "",
        gstTreatment: user.business_type || "",
        gstin: user.gst || user.pan || "",
        accountNumber: user.account_no || "",
        ifsc: user.ifsc_code || "",
        bankName: user.bank_name || "",
        branchname: user.branch_name || "",
        accountType: user.account_type || "",
      }));

      // PAN
      if (Number(user.pan_verified) === 1 && user.pan_json) {
        updateField("panVerified", true);
        setPanApiResponse(JSON.parse(user.pan_json));
        updateField("panNumber", JSON.parse(user.pan_json)?.pan || "");
      }

      // GST
      if (Number(user.gst_verified) === 1 && user.gst_json) {
        const gstData = JSON.parse(user.gst_json);
        setGstVerified(true);
        setGstResponse(gstData);
      }

      // BANK
      if (Number(user.bank_verified) === 1 && user.bank_json) {
        setBankVerified(true);
        setBankResponse(JSON.parse(user.bank_json));
      }

      // EMAIL / PHONE
      if (Number(user.is_mail_verified) === 1) setEmailVerified(true);
      if (Number(user.is_wa_verified) === 1) setPhoneVerified(true);
      setOriginalPhone(user.contact_phone || "");

    } catch (err) {
      console.error("Failed to fetch user from API", err);
    } finally {
      setPageLoading(false); // ✅ STOP LOADER
    }
  };

  fetchUserFromApi();
}, []);

  const fetchPaymentKeys = async () => {
  try {
    setKeyLoading(true);

    const res = await fetch(`${BASE_URL}payment/keys`);
    const data = await res.json();

    if (Array.isArray(data) && data.length > 0) {
      setPaymentKeys({
        key_id: data[0].key_id,
        key_secret: data[0].key_secret
      });
    } else {
      console.error("Invalid keys response", data);
    }
  } catch (err) {
    console.error("Failed to fetch payment keys", err);
  } finally {
    setKeyLoading(false);
  }
};

  useEffect(() => {
  if (currentStep === 2) {
    fetchPaymentKeys();
  }
}, [currentStep]);


  const handleAadhaarBoxChange = (idx, value) => {
    const digit = value.replace(/\D/g, "").slice(0, 1);

    const chars = (form.aadhaarLast4 || "").split("");
    while (chars.length < 4) chars.push("");
    chars[idx] = digit;

    const joined = chars.join("");
    updateField("aadhaarLast4", joined);

    if (digit && aadhaarInputsRef.current[idx + 1]) {
      aadhaarInputsRef.current[idx + 1].focus();
    }
  };

  const handleAadhaarKeyDown = (idx, e) => {
    if (e.key === "Backspace" && !form.aadhaarLast4?.[idx]) {
      if (aadhaarInputsRef.current[idx - 1]) {
        aadhaarInputsRef.current[idx - 1].focus();
      }
    }
    if (e.key === "ArrowLeft" && aadhaarInputsRef.current[idx - 1]) {
      aadhaarInputsRef.current[idx - 1].focus();
    }
    if (e.key === "ArrowRight" && aadhaarInputsRef.current[idx + 1]) {
      aadhaarInputsRef.current[idx + 1].focus();
    }
  };

  const aadhaarValid =
    form.aadhaarLast4 &&
    form.aadhaarLast4.length === 4 &&
    /^\d{4}$/.test(form.aadhaarLast4);

  // NOTE: update verifyAadhaar() to accept last4 and return eSign URL (Promise<string>)
  // const handleEsignClick = async () => {
  //   if (!aadhaarValid) {
  //     toast.error("Enter valid last 4 digits of Aadhaar");
  //     return;
  //   }

  //   setAadhaarError("");
  //   setAadhaarStatus("loading");

  //   try {
  //     // 👇 You must update verifyAadhaar to:
  //     // async function verifyAadhaar(last4) { ... return esignUrl }
  //     const esignUrl = await verifyAadhaar(form.aadhaarLast4);

  //     if (!esignUrl) {
  //       throw new Error("Invalid e-Sign link from server");
  //     }

  //     setAadhaarStatus("verifying");
  //     openEsignPopup(esignUrl);
  //   } catch (err) {
  //     console.error(err);
  //     setAadhaarStatus("error");
  //     setAadhaarError(err?.message || "Failed to start e-Sign");
  //     toast.error("Unable to start e-Sign");
  //   }
  // };

  const cleanupEsignPopup = () => {
    if (esignPollRef.current) {
      clearInterval(esignPollRef.current);
      esignPollRef.current = null;
    }
    if (esignPopupRef.current && !esignPopupRef.current.closed) {
      try {
        esignPopupRef.current.close();
      } catch (e) {
        console.error(e);
      }
    }
    esignPopupRef.current = null;
  };

  const openEsignPopup = (url) => {
    const w = 460;
    const h = 640;
    const dualScreenLeft =
      window.screenLeft !== undefined ? window.screenLeft : window.screenX;
    const dualScreenTop =
      window.screenTop !== undefined ? window.screenTop : window.screenY;
    const width =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      window.screen.width;
    const height =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      window.screen.height;

    const left = width / 2 - w / 2 + dualScreenLeft;
    const top = height / 2 - h / 2 + dualScreenTop;

    const features = `scrollbars=yes,resizable=yes,width=${w},height=${h},top=${top},left=${left}`;
    esignPopupRef.current = window.open(url, "esignPopup", features);

    // Fallback polling – if popup closed manually
    esignPollRef.current = setInterval(() => {
      if (!esignPopupRef.current || esignPopupRef.current.closed) {
        clearInterval(esignPollRef.current);
        esignPollRef.current = null;
        esignPopupRef.current = null;

        // Only reset state if we were waiting
        if (aadhaarStatus === "verifying") {
          setAadhaarStatus("idle");
        }
      } else {
        // OPTIONAL: if your success page is same-origin and has /esign-success in URL
        try {
          const href = esignPopupRef.current.location.href || "";
          if (href.includes("esign-success")) {
            cleanupEsignPopup();
            setAadhaarStatus("success");
            updateField("aadhaarVerified", true);
            toast.success("e-Sign verified successfully");
          }
        } catch {
          // Cross-origin during provider flow – ignore
        }
      }
    }, 800);
  };

  // Listen for postMessage from success page
  useEffect(() => {
    const handler = (e) => {
      // In production, replace "*" with your exact origin and check e.origin
      if (e?.data?.type === "ESIGN_SUCCESS") {
        cleanupEsignPopup();
        setAadhaarStatus("success");
        updateField("aadhaarVerified", true);
        toast.success("e-Sign verified successfully");
      }
      if (e?.data?.type === "ESIGN_CANCELLED") {
        cleanupEsignPopup();
        setAadhaarStatus("idle");
        toast.error("e-Sign cancelled");
      }
    };

    window.addEventListener("message", handler);
    return () => window.removeEventListener("message", handler);
  }, []);

  const scrollRef = useRef(null);

  const handleScroll = () => {
    const el = scrollRef.current;
    if (!el) return;

    if (el.scrollTop + el.clientHeight >= el.scrollHeight - 5) {
      setHasScrolledToBottom(true);
    }
  };

  // Prefill form fields from localStorage on mount
  useEffect(() => {
    const storedUser = localStorage.getItem("authUserData");
    if (storedUser) {
      try {
        const user = JSON.parse(storedUser);

        updateField("address_line1", user.address_line1 || "");
        updateField("address_line2", user.address_line2 || "");
        updateField("state", user.state || "");
        updateField("district", user.district || "");
        updateField("city", user.city || "");
        updateField("pincode", user.pincode || "");
        updateField("email", user.contact_email || "");
        updateField("phone", user.contact_phone || "");
      } catch (err) {
        console.error("Invalid session user data", err);
      }
    }
  }, []);

  // ---------------- Email + Phone OTP Logic ----------------
  const sendEmailOtp = async () => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (!form.email || !emailRegex.test(form.email)) {
    toast.error("Invalid email format");
    return;
  }

  const storedUser = localStorage.getItem("authUserData");
  const user = storedUser ? JSON.parse(storedUser) : null;
  const userId = user?.id;

  if (!userId) {
    toast.error("User session not found");
    return;
  }

  try {
    setSendingEmailOtp(true); // 🔥 START LOADER

    const response = await fetch(`${BASE_URL}send-welcome-email/${userId}`, {
      method: "GET",
      cache: "no-store",
    });

    const result = await response.json();

    if (result?.status) {
      setEmailOtpSent(true);

      const endTime = Date.now() + 5 * 60 * 1000;
      localStorage.setItem("resendEmailOtpEndTime", endTime);
      setResendEmailTimer(5 * 60);

      toast.success("Email OTP sent successfully!");
    } else {
      toast.error(result?.message || "Failed to send OTP");
    }
  } catch (error) {
    toast.error("Something went wrong");
  } finally {
    setSendingEmailOtp(false); // 🔥 STOP LOADER
  }
};

  useEffect(() => {
    const storedEndTime = localStorage.getItem("resendEmailOtpEndTime");
    if (storedEndTime) {
      const remaining = Math.floor((storedEndTime - Date.now()) / 1000);
      if (remaining > 0) setResendEmailTimer(remaining);
      else localStorage.removeItem("resendEmailOtpEndTime");
    }
  }, []);

  useEffect(() => {
    if (resendEmailTimer <= 0) return;

    const interval = setInterval(() => {
      setResendEmailTimer(prev => {
        if (prev <= 1) {
          clearInterval(interval);
          localStorage.removeItem("resendEmailOtpEndTime");
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [resendEmailTimer]);


const verifyEmailOtp = async () => {
  if (!emailOtp) {
    toast.error("Enter OTP");
    return;
  }

  try {
    setVerifyingEmailOtp(true); // 🔥 START LOADER

    const authUser = JSON.parse(localStorage.getItem("authUserData") || "{}");

    const res = await fetch(`${BASE_URL}verify-email-otp`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        email: form.email,
        otp: emailOtp,
        user_id: authUser.id,
        company_id: authUser.company_id || 1,
      }),
    });

    const data = await res.json();

    if (data?.status) {
      setEmailVerified(true);

      if (data.zoho_id) {
        setZohoId(data.zoho_id);
        localStorage.setItem(
          "authUserData",
          JSON.stringify({ ...authUser, zoho_id: data.zoho_id })
        );
      }
      console.log("zoho_id: ", data.zoho_id)

      toast.success("Email verified successfully");
    } else {
      toast.error(data?.error || "Invalid OTP");
    }
  } catch (err) {
    toast.error("Verification failed");
  } finally {
    setVerifyingEmailOtp(false); // 🔥 STOP LOADER
  }
};

  useEffect(() => {
    const savedEmailOtpSent = localStorage.getItem("emailOtpSent");
    const savedEmailVerified = localStorage.getItem("emailVerified");
    const savedEmail = localStorage.getItem("verifiedEmail");

    if (savedEmailOtpSent === "true") setEmailOtpSent(true);
    if (savedEmailVerified === "true") setEmailVerified(true);

    if (savedEmail) {
      setForm(prev => ({ ...prev, email: savedEmail }));
    }
  }, []);
  
  // Automatically mark email as verified if user logged in with verified email
  useEffect(() => {
    const storedUser = localStorage.getItem("authUserData");
    if (storedUser) {
      try {
        const user = JSON.parse(storedUser);

        if (user.is_mail_verified === 1) {
          setEmailVerified(true);
          localStorage.setItem("emailVerified", "true");
          localStorage.setItem("verifiedEmail", user.contact_email || "");
          setForm(prev => ({
            ...prev,
            email: user.contact_email || "",
          }));
        }
      } catch (err) {
        console.error("Error parsing authUserData", err);
      }
    }
  }, []);

  const handleEmailChange = (value) => {
    handleChange("email", value);

    // Reset stored status if email changes
    localStorage.removeItem("emailOtpSent");
    localStorage.removeItem("emailVerified");
    localStorage.removeItem("verifiedEmail");

    setEmailOtpSent(false);
    setEmailVerified(false);
    setEmailOtp("");
  };

  const sendPhoneOtp = async () => {
  console.log("Send Phone OTP button clicked");

  if (!form.phone) return;

  try {
    setSendingOtp(true);

    const payload = {
      old_contact_phone: originalPhone,
      contact_phone: form.phone,
      company_id: authUser.id
    };

    const response = await fetch(`${BASE_URL}send-wa-otp`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    const result = await response.json();

    if (response.ok) {
      setPhoneOtpSent(true);
      localStorage.setItem("phoneOtpSent", "true");
      toast.success("Phone OTP sent successfully!");

      // Start 10 min timer
      const endTime = Date.now() + 5 * 60 * 1000;
      localStorage.setItem("resendOtpEndTime", endTime);
      setResendTimer(5 * 60); // in seconds
    } else {
      toast.error(result.message || "Failed to send OTP");
    }
  } catch (error) {
    toast.error("Failed to send OTP");
  } finally {
    setSendingOtp(false);
  }
};

  useEffect(() => {
  const storedEndTime = localStorage.getItem("resendOtpEndTime");
  if (storedEndTime) {
    const remaining = Math.floor((storedEndTime - Date.now()) / 1000);
    if (remaining > 0) setResendTimer(remaining);
    else localStorage.removeItem("resendOtpEndTime");
  }
}, []);

  useEffect(() => {
    if (resendTimer <= 0) return;

    const interval = setInterval(() => {
      setResendTimer(prev => {
        if (prev <= 1) {
          clearInterval(interval);
          localStorage.removeItem("resendOtpEndTime");
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [resendTimer]);

  const verifyPhoneOtp = async () => {
    if (!phoneOtp) {
      toast.error("Enter OTP");
      return;
    }

    try {
      setVerifyingOtp(true);

      const response = await fetch(`${BASE_URL}verify-wa-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ contact_phone: form.phone, otp: phoneOtp }),
      });
      const result = await response.json();

      if (!response.ok) throw new Error(result.message);

      setPhoneVerified(true);
      localStorage.setItem("phoneVerified", "true");
      localStorage.removeItem("phoneOtp");
      localStorage.removeItem("phoneOtpSent");

      toast.success("Phone Verified Successfully!");
    } catch (error) {
      toast.error(error.message || "Invalid OTP");
    } finally {
      setVerifyingOtp(false);
    }
  };

  useEffect(() => {
    const storedPhoneSent = localStorage.getItem("phoneOtpSent");
    const storedPhoneVerified = localStorage.getItem("phoneVerified");
    const storedPhoneOtp = localStorage.getItem("phoneOtp");

    if (storedPhoneSent === "true") setPhoneOtpSent(true);
    if (storedPhoneVerified === "true") setPhoneVerified(true);
    if (storedPhoneOtp) setPhoneOtp(storedPhoneOtp);
  }, []);

  // Automatically mark phone as verified if user logged in with verified phone
  useEffect(() => {
    const storedUser = localStorage.getItem("authUserData");
    if (storedUser) {
      try {
        const user = JSON.parse(storedUser);

        if (user.is_wa_verified === 1) {
          setPhoneVerified(true);
          localStorage.setItem("phoneVerified", "true");
          localStorage.setItem("verifiedPhone", user.contact_phone || "");
          setForm(prev => ({
            ...prev,
            phone: user.contact_phone || "",
          }));

          setOriginalPhone(user.contact_phone || "");
        }
      } catch (err) {
        console.error("Error parsing authUserData", err);
      }
    }
  }, []);

  // ---------------- Validation ----------------
  const validateField = (field, value, isUnregistered = false) => {
  let error = "";

  switch (field) {
    case "email":
      if (!value) error = "Email is required";
      else {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(value)) error = "Invalid email format";
      }
      break;

    case "phone":
      if (!value) error = "Phone is required";
      else {
        const phoneRegex = /^[6-9][0-9]{9}$/;
        if (!phoneRegex.test(value)) error = "Invalid phone number format";
      }
      break;

    case "panNumber": 
      if (!value) error = "Enter PAN Number";
      else {
        const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
        if (!panRegex.test(value)) error = "Invalid PAN format (e.g. ABCDE1234F)";
      }
      break;

    case "gstTreatment":
      if (!value) error = "Select GST treatment";
      break;

    case "gstin":
      if (!value) {
        error = isUnregistered ? "Enter PAN number" : "Enter GSTIN / UIN";
      } else {
        if (isUnregistered) {
          const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
          if (!panRegex.test(value)) error = "Invalid PAN format";
        } else {
          const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/;
          if (!gstRegex.test(value)) error = "Invalid GSTIN format";
        }
      }
      break;

    case "businessName":
      if (!value) error = "Enter legal business name";
      break;

    case "accountNumber":
      if (!value) error = "Enter account number";
      break;

    case "ifsc":
      if (!value) error = "Enter IFSC code";
      // else {
      //   const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
      //   if (!ifscRegex.test(value)) error = "Invalid IFSC format";
      // }
      break;

    case "bankName":
      if (!value) error = "Enter bank name";
      break;

    case "authorisedName":
      if (!value) error = "Authorised person is required";
      break;

    case "agreed":
      if (!value) error = "You must accept the agreement to continue";
      break;

    default:
      break;
  }

  setErrors((prev) => ({ ...prev, [field]: error }));
  return error === "";
};

// ---------------- PAN VALIDATION FUNCTION ----------------
const isValidPAN = (pan) => {
  const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
  return panRegex.test(pan);
};

  useEffect(() => {
    const sessionData = localStorage.getItem("authUserData");
    if (!sessionData) return;

    const user = JSON.parse(sessionData);

    if (Number(user?.pan_verified) === 1) {
      const panFromSession =
        user?.pan_number ||
        user?.pan ||
        (user?.pan_json ? JSON.parse(user.pan_json)?.pan : "");

      setForm(prev => ({
        ...prev,
        panNumber: panFromSession,
        panVerified: true,
      }));

      if (user?.pan_json) {
        setPanApiResponse(JSON.parse(user.pan_json));
      }
    }
  }, []);

  const generateVerificationId = (pan) => {
  const now = new Date();

  const yyyy = now.getFullYear();
  const mm = String(now.getMonth() + 1).padStart(2, "0");
  const dd = String(now.getDate()).padStart(2, "0");

  const hh = String(now.getHours()).padStart(2, "0");
  const min = String(now.getMinutes()).padStart(2, "0");
  const ss = String(now.getSeconds()).padStart(2, "0");

  return `${pan}-${yyyy}${mm}${dd}-${hh}${min}${ss}`;
};


// ---------------- PAN VERIFY API CALL ----------------
  const verifyPAN = async () => {
    if (!form.panNumber) return;
    if (!isValidPAN(form.panNumber)) {
      validateField("panNumber", form.panNumber);
      return;
    }

    try {
      setLoading(true);

      const payload = {
        pan: form.panNumber,
        // verification_id: authUser?.company_code,
        // verification_id: `${form.panNumber}_${authUser?.leads?.[0]?.lead_code}`,
        verification_id: generateVerificationId(form.panNumber),
        name: authUser?.contact_person,
      };

      const response = await fetch(`${SWAGGER_URL}/Cashfree/pan-advance`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          AppId: APPID,
          SecretKey: SecretKey,
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (response.ok && data?.status === "VALID") {

        updateField("panVerified", true);

        // 🔥 store full response in parent onboarding
        setPanApiResponse(data);

        toast.success(data?.message || "PAN Verified Successfully!");

        await fetch(`${BASE_URL}common/update`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            contact_email: authUser?.contact_email,
            pan_verified: 1,
            pan_json: data,
            // is_verified: 2,
            role: authUser?.role,
            pincode:authUser?.pincode,
          }),
        });

      } else {
        toast.error(data?.message || "Verification Failed.");
      }
    } catch (error) {
      toast.error("Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
  const sessionData = localStorage.getItem("authUserData");
  if (sessionData) {
    const user = JSON.parse(sessionData);

    // Pre-fill GST / Business details
    setForm(prev => ({
      ...prev,
      gstTreatment: user.business_type || "",       // regular, composition, unregistered
      gstin: user.gst || user.pan || "",         // GSTIN or PAN if unregistered
      businessName: user.business_name || "",
      tradeName: user.trade_name || "",
    }));
  }
}, []);

useEffect(() => {
  const sessionData = localStorage.getItem("authUserData");
  if (!sessionData) return;

  const user = JSON.parse(sessionData);

  // ---------------- UNREGISTERED ----------------
  if (form.gstTreatment === "unregistered") {
    setForm(prev => ({
      ...prev,
      gstin: prev.panNumber || "",
    }));

    setGstVerified(true); // no verification needed
    setGstResponse(null);
    return;
  }

  // ---------------- REGISTERED ----------------
  if (form.gstTreatment === "registered") {
    // ✅ If GST already verified in session → auto restore
    if (user?.gst_verified === 1 && user?.gst_json) {
      const gstData = JSON.parse(user.gst_json);

      setGstVerified(true);
      setGstResponse(gstData);

      setForm(prev => ({
        ...prev,
        gstin: user.gst,
        businessName: user.business_name,
        tradeName: user.trade_name,
        taxpayerType: gstData.taxpayer_type || "",
      }));
    } else {
      // ❌ Only reset if NOT verified earlier
      setGstVerified(false);
      setGstResponse(null);

      setForm(prev => ({
        ...prev,
        gstin: "",
        businessName: "",
        tradeName: "",
        taxpayerType: "",
      }));
    }
  }
}, [form.gstTreatment]);




const verifyGST = async () => {
  if (!form.gstin) {
    toast.error("Enter GSTIN and Business Name");
    return;
  }

  try {
    setGstLoading(true);

    const res = await fetch(`${SWAGGER_URL}/Cashfree/gstin-verify`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        AppId: APPID,
        SecretKey: SecretKey,
      },
      body: JSON.stringify({
        gstin: form.gstin,
        name: form.businessName,
      }),
    });

    const data = await res.json();

    if (res.ok && data?.valid === true && data?.message === "GSTIN Exists") {
      toast.success("GST Verified Successfully");

      await fetch(`${BASE_URL}common/update`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            contact_email: authUser?.contact_email,
            gst_verified: 1,
            gst_json: data,
            business_type:form.gstTreatment,
            // is_verified: 2,
            role: authUser?.role,
            pincode:authUser?.pincode,
          }),
        });

      setGstVerified(true);
      setGstResponse(data);

      // 🔥 Auto-fill names from GST
      setForm(prev => ({
        ...prev,
        gstin: data.GSTIN,
        businessName: data.trade_name_of_business,
        tradeName: data.trade_name_of_business || "",
        taxpayerType: data.taxpayer_type || "",
      }));
    } else {
      toast.error(data?.message || "GST Verification Failed");
      setGstVerified(false);
    }

  } catch (err) {
    toast.error("GST verification failed");
  } finally {
    setGstLoading(false);
  }
};

const verifyBankAccount = async () => {
  if (!form.accountNumber || !form.ifsc) {
    toast.error("Enter account number and IFSC");
    return;
  }

  try {
    setBankLoading(true);

    const res = await fetch(`${SWAGGER_URL}/Cashfree/bank-verify-v2`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        AppId: APPID,
        SecretKey: SecretKey,
      },
      body: JSON.stringify({
        bank_account: form.accountNumber,
        ifsc: form.ifsc,
        name: form.businessName,
        phone: form.phone,
      }),
    });

    const data = await res.json();

    if (res.ok && data.account_status_code === "ACCOUNT_IS_VALID") {
      toast.success("Bank account verified successfully");

      await fetch(`${BASE_URL}common/update`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            contact_email: form.email,
            account_type: form.accountType,
            account_no: form.accountNumber,
            ifsc_code: data?.ifsc_details?.ifsc || form.ifsc,
            bank_name: data?.bank_name,
            branch_name: data?.branch,
            authorised_name: form.authorisedName,

            bank_verified: 1,
            bank_json: data || null,
            role: authUser?.role,
            pincode:authUser?.pincode,
          }),
        });

      setBankVerified(true);
      setBankResponse(data);
      // 🔥 Autofill
      setForm(prev => ({
        ...prev,
        bankName: data.bank_name || data.ifsc_details?.bank || "",
        branchname: data.branch || data.ifsc_details?.branch || "",
        ifsc: data.ifsc_details?.ifsc || prev.ifsc,
      }));
    } else {
      toast.error(data.message);
      setBankVerified(false);
      setBankResponse(null);
    }
  } catch (err) {
    toast.error("Bank verification failed");
  } finally {
    setBankLoading(false);
  }
};



useEffect(() => {
  if (form.gstTreatment === "unregistered" && form.panNumber) {
    setForm(prev => ({
      ...prev,
      gstin: form.panNumber,
    }));
    setGstVerified(true); // no verification needed
  }
}, [form.gstTreatment, form.panNumber]);

useEffect(() => {
  const sessionData = localStorage.getItem("authUserData");
  if (!sessionData) return;

  const user = JSON.parse(sessionData);

  if (user?.gst_verified === 1 && user?.gst_json) {
    setGstVerified(true);
    setGstResponse(JSON.parse(user.gst_json));

    setForm(prev => ({
      ...prev,
      gstin: user.gst,
      businessName: user.business_name,
      tradeName: user.trade_name,
    }));
  }
}, []);


  useEffect(() => {
  const sessionData = localStorage.getItem("authUserData");
  if (!sessionData) return;

  const user = JSON.parse(sessionData);

  if (user?.bank_verified === 1 && user?.bank_json) {
    const bankData = JSON.parse(user.bank_json);

    setBankVerified(true);
    setBankResponse(bankData);

    setForm(prev => ({
      ...prev,
      accountNumber: user.account_no,
      ifsc: user.ifsc_code,
      bankName: user.bank_name,
      branchname: user.branch_name,
    }));
  }
}, []);



useEffect(() => {
  const sessionData = localStorage.getItem("authUserData");
  if (sessionData) {
    const user = JSON.parse(sessionData);

    setForm(prev => ({
      ...prev,
      accountType: user.account_type || "",
      accountNumber: user.account_no || "",
      ifsc: user.ifsc_code || "",
      branchname: user.branch_name || "",
      bankName: user.bank_name || "",
      authorisedName: user.business_name || "",
      // Optional: you can pre-fill bankProofType if you store it
    }));
  }
}, []);



  const handleChange = (field, value) => {
    if (field === "gstin" || field === "ifsc") value = value.toUpperCase();

    // 🔥 Autofill logic: when business name is entered, set authorisedName same
    if (field === "businessName") {
      updateField("authorisedName", value);
    }

    updateField(field, value);
    validateField(field, value);
  };


  // const handlePayment = () => {
  //   if (!selectedPackage) return;

  //   if (!paymentKeys.key_id) {
  //     alert("Payment keys not loaded!");
  //     return;
  //   }

  //   const options = {
  //     key: paymentKeys.key_id,
  //     key_secret: paymentKeys.key_secret, // Razorpay does NOT use this on frontend
  //     amount: selectedPackage.amount * 100,
  //     id:"order_LKsdf98asfa",
  //     currency: "INR",
  //     name: "GO Electronix",
  //     description: selectedPackage.package_name,
  //     handler: function (response) {
  //       alert("Payment Successful 🎉");
  //       console.log("Payment ID:", response.razorpay_payment_id);
  //       console.log("Order ID:", response.razorpay_order_id);
  //       console.log("Signature:", response.razorpay_signature);
  //     },
  //     prefill: {
  //       name: authUser?.name || "",
  //       email: authUser?.email || "",
  //       contact: authUser?.mobile || "",
  //     },
  //     theme: { color: "#2563eb" },
  //   };

  //   const rzp = new window.Razorpay(options);
  //   rzp.open();
  // };

const uiStep = isRetailer
  ? currentStep
  : currentStep > 1
    ? currentStep - 1
    : currentStep;

  const displayStep = isRetailer ? currentStep : uiStep;

  const notesData = {
  role: authUser?.role,
  service: "onboarding",
  user_code: authUser?.company_code,
  user_id: authUser?.id,
  retailer_id: authUser?.id,
  name: authUser?.business_name,
  company_id: authUser?.company_id,
  zoho_id: authUser?.zoho_id || null,
  invoice_id: null,
};

  const handlePayment = () => {
  if (!selectedPackage) return;

  if (!paymentKeys.key_id) {
    alert("Payment keys not loaded!");
    return;
  }

  const options = {
    key: paymentKeys.key_id,
    amount: selectedPackage.amount * 100, 
    currency: "INR",
    name: "GO Electronix",
    description: selectedPackage.package_name,
    notes: notesData,

    handler: async function (response) {
  setPaymentCompleted(true);
  setPaymentSaving(true); // 🔒 FULL PAGE LOCK

  const payload = {
    company_id: authUser?.company_id,
    user_id: authUser?.id,
    payment_id: response.razorpay_payment_id,
    amount: selectedPackage.amount,
    status: response,
    payment_date: new Date().toISOString().slice(0, 19).replace("T", " "),
    customer_id: zohoId || null,
    payment_from: "WARRANTY",
    notes: selectedPackage.package_name,
    role: authUser?.role,
  };

  try {
    const res = await fetch(`${BASE_URL}zoho/create-online-payment`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    const data = await res.json();

    if (!res.ok) {
      toast.error("Payment saved but server rejected callback!");
      return;
    }

    toast.success("Payment Successful & Saved in Zoho 🎉");
    setIsPaymentSuccess(true);

    await fetch(`${BASE_URL}common/update`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        contact_email: authUser?.contact_email,
        is_payment_success: 1,
        // is_verified: 2,
        role: authUser?.role,
        pincode:authUser?.pincode,
      }),
    });
  } catch (err) {
    console.error(err);
    toast.error("Payment succeeded but failed to update Zoho!");
  } finally {
    setPaymentSaving(false); // 🔓 UNLOCK PAGE
  }
},


      prefill: {
        name: authUser?.name || "",
        email: authUser?.contact_email || "",
        contact: authUser?.contact_phone || "",
      },

      theme: { color: "#2563eb" },
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
  };


  // const handlePaymentSuccess = async () => {
  //   const payload = {
  //     retailer_id: authUser?.id,
  //     status: "payment_done",
  //     package_id: selectedPackage.id,
  //   };

  //   await postStepUpdate(payload, "Payment Step");
  // };

  useEffect(() => {
    if (currentStep === 2) fetchPackages();
  }, [currentStep]);

  const fetchPackages = async () => {
    try {
      setLoading(true);
      const res = await fetch(`${BASE_URL}packages`);
      const data = await res.json();
      setPackages(data || []);
    } catch (err) {
      toast.error("Failed to load packages");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
  const storedId = localStorage.getItem("selectedPackageId");
  if (!storedId || !packages.length) return;

  const found = packages.find(
    (p) => Number(p.id) === Number(storedId)
  );

  if (found) {
    setSelectedPackage(found);
  }
}, [packages]);


  // useEffect(() => {
  //   if (
  //     !loading &&
  //     packages.length > 0 &&
  //     authUser?.leads?.length > 0 &&
  //     !selectedPackage  // <-- Prevent overwriting user selection
  //   ) {
  //     const assignedPackageId = authUser.leads[0].package_id;
  //     const foundPackage = packages.find(p => p.id === assignedPackageId);

  //     if (foundPackage) setSelectedPackage(foundPackage);
  //   }
  // }, [loading, packages, authUser, selectedPackage]);

  useEffect(() => {
  if (!packages.length) return;
  if (selectedPackage) return; // prevent overriding manual selection

  const assignedPackageId = user?.leads?.[0]?.package_id;

  if (assignedPackageId) {
    const found = packages.find(
      (pkg) => Number(pkg.id) === Number(assignedPackageId)
    );

    if (found) {
      setSelectedPackage(found);
    }
  }
}, [packages, user, selectedPackage]);


  const handleUpload = async () => {
  if (!form.bankProofFile || !form.bankProofType) {
    toast.error("Please select file and type");
    return;
  }

  try {
    setUploading(true); // start loading

    const formData = new FormData();
    formData.append("flag", form.bankProofType);
    formData.append("file", form.bankProofFile);
    formData.append("email", form.email);

    const res = await fetch(`${BASE_URL}user/upload-file`, {
      method: "POST",
      body: formData,
    });

    const data = await res.json();

    if (data.status) {
      toast.success("File uploaded successfully!");
      setIsUploaded(true);
    } else {
      toast.error(data.message || "Upload failed");
    }
  } catch (error) {
    console.error(error);
    toast.error("Something went wrong.");
  } finally {
    setUploading(false); // stop loading
  }
};

  const fetchAgreement = async () => {
    try {
      const response = await fetch(`${BASE_URL}agreement/${role}/${id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          // Authorization: `Bearer ${token}`,/ // include only if API needs it
        },
      });

      const data = await response.json();

      if (data?.status && data?.download_url) {
        setAgreementUrl(data.download_url);
      } else {
        toast.error("Failed to fetch agreement.");
      }
    } catch (err) {
      console.error(err);
      toast.error("Server error while fetching agreement.");
    }
  };

  useEffect(() => {
    if (currentStep === 6 && !agreementUrl) {
      fetchAgreement();
    }
  }, [currentStep]);

  const handleAgreementCheck = (checked) => {
    handleChange("agreed", checked);

    if (checked && hasScrolledToBottom) {
      updateField("esignVerified", 1);
    } else {
      updateField("esignVerified", 0);
    }
  };

  useEffect(() => {
    if (bankResponse?.name_at_bank && !form.name_at_bank) {
      updateField("authorisedName", bankResponse.name_at_bank);
    }
  }, [bankResponse]);

  const handleEsignClick = async () => {
    const link = await verifyAadhaar();

    if (link) {
      window.open(
        link,
        "_blank",
        "width=600,height=900,resizable=yes,scrollbars=yes"
      );
    }
  };

  if (pageLoading) {
      return <FullPageLoader text="Loading your onboarding details..." />;
    }

  // ---------------- Render ----------------
  return (
    <>
      {paymentSaving && (
        <FullPageLoader text="Saving payment details, please wait…" />
      )}
      <div className="space-y-6">
        {/* STEP 1 : EMAIL + PHONE VERIFICATION */}
        {uiStep === 1 && (
          <section className="space-y-8">
            {/* ---------------- Store Address ---------------- */}
            <div className="space-y-4">
              <h2 className="text-lg font-semibold text-slate-900">Store Address</h2>
              <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                <InputField
                  label="State"
                  value={form.state}
                  disabled
                  onChange={(value) => handleChange("state", value)}
                  placeholder="Enter state"
                />
                <InputField
                  label="District"
                  value={form.district}
                  disabled
                  onChange={(value) => handleChange("district", value)}
                  placeholder="Enter district"
                />
                <InputField
                  label="City"
                  value={form.city}
                  disabled
                  onChange={(value) => handleChange("city", value)}
                  placeholder="Enter city"
                />
                <InputField
                  label="Pincode"
                  required
                  value={form.pincode}
                  disabled
                  onChange={(value) => handleChange("pincode", value)}
                  placeholder="Enter pincode"
                />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <InputField
                  label="Address Line 1"
                  required
                  value={form.address_line1}
                  onChange={(value) => handleChange("address_line1", value)}
                  placeholder="Shop / Building / Street"
                />
                <InputField
                  label="Address Line 2"
                  value={form.address_line2}
                  onChange={(value) => handleChange("address_line2", value)}
                  placeholder="Landmark (Optional)"
                />
              </div>
            </div>

            {/* ---------------- Contact Verification ---------------- */}
            <div className="space-y-4">
              <h2 className="text-lg font-semibold text-slate-900">Verify Email & Phone</h2>

              {/* EMAIL */}
              <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-end">
                {emailVerified ? (
                <div className="col-span-4 md:col-span-2 flex flex-col gap-2 p-2 bg-green-50 border border-green-300 rounded-md">
                    <p className="text-green-700 font-medium">
                        ✔ Email Verified: <span className="font-semibold">{form.email}</span>
                      </p>
                    </div>
                ) : (
                  <>
                    <InputField
                      label="Email"
                      required
                      value={form.email}
                      disabled
                      onChange={(value) => handleEmailChange(value)}
                      placeholder="Enter your email"
                      error={errors.email}
                    />

                    {/* ⏳ UPDATED BUTTON WITH TIMER */}
                    <button
                      onClick={sendEmailOtp}
                      disabled={sendingEmailOtp || resendEmailTimer > 0}
                      className={`h-[42px] md:w-[120px] rounded-lg text-sm text-white flex items-center justify-center
                        ${
                          sendingEmailOtp || resendEmailTimer > 0
                            ? "bg-gray-400 cursor-not-allowed"
                            : "bg-blue-600 hover:bg-blue-700"
                        }`}
                    >
                      {sendingEmailOtp ? (
                        <span className="flex items-center gap-2">
                          <svg className="w-4 h-4 animate-spin" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
                          </svg>
                          Sending…
                        </span>
                      ) : resendEmailTimer > 0 ? (
                        `Resend in ${Math.floor(resendEmailTimer / 60)}:${String(resendEmailTimer % 60).padStart(2, "0")}`
                      ) : emailOtpSent ? (
                        "Resend OTP"
                      ) : (
                        "Send OTP"
                      )}
                    </button>


                    {emailOtpSent && (
                      <>
                        <InputField
                          label="Email OTP"
                          value={emailOtp}
                          onChange={(v) => setEmailOtp(v)}
                          placeholder="Enter OTP"
                        />
                        <button
                          onClick={verifyEmailOtp}
                          disabled={verifyingEmailOtp}
                          className={`h-[42px] md:w-[120px] rounded-lg text-sm text-white flex items-center justify-center
                            ${
                              verifyingEmailOtp
                                ? "bg-gray-400 cursor-not-allowed"
                                : "bg-green-600 hover:bg-green-700"
                            }`}
                        >
                          {verifyingEmailOtp ? (
                            <span className="flex items-center gap-2">
                              <svg className="w-4 h-4 animate-spin" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
                              </svg>
                              Verifying…
                            </span>
                          ) : (
                            "Verify"
                          )}
                        </button>

                      </>
                    )}
                  </>
                )}

              </div>
              {/* {emailVerified && <p className="text-green-600 text-sm">✔ Email verified successfully</p>} */}

              {/* PHONE */}
              <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-end">
                {!phoneVerified && (
                <InputField
                  label="Phone"
                  required
                  value={form.phone}
                  onChange={(value) => handlePhoneChange(value)}
                  placeholder="Enter phone number"
                  error={errors.phone}
                  disabled={phoneOtpSent && resendTimer > 0}
                />
                )}
                {/* If phone already verified */}
                {phoneVerified ? (
                  <div className="col-span-4 md:col-span-1 flex flex-col gap-2 p-2 bg-green-50 border border-green-300 rounded-md">
                    <p className="text-green-700 font-medium">
                      ✔ Phone verified successfully : <span className="font-semibold">{form.phone}</span>
                    </p>
                  </div>
                ) : (
                  <>
                    {!phoneVerified && (
                      <button
                        type="button"
                        onClick={() => {
                          console.log("Send OTP button pressed");
                          sendPhoneOtp();
                        }}
                        disabled={!emailVerified || resendTimer > 0 || sendingOtp}
                        className={`h-[42px] md:w-[120px] rounded-lg text-sm text-white
                          ${!emailVerified || resendTimer > 0 || sendingOtp ? "bg-gray-300 cursor-not-allowed" : "bg-blue-600"}`}
                      >
                        {sendingOtp
                          ? "Sending..."
                          : resendTimer > 0
                          ? `Resend in ${Math.floor(resendTimer / 60)}:${String(resendTimer % 60).padStart(2, "0")}`
                          : phoneOtpSent
                          ? "Resend OTP"
                          : "Send OTP"}
                      </button>
                    )}
                    {phoneOtpSent && !phoneVerified && (
                      <InputField
                        label="Phone OTP"
                        value={phoneOtp}
                        onChange={(v) => {
                          setPhoneOtp(v);
                          localStorage.setItem("phoneOtp", v); // persist typed OTP
                        }}
                        placeholder="Enter OTP"
                      />

                    )}
                    {phoneOtpSent && !phoneVerified && (
                      <button
                        onClick={verifyPhoneOtp}
                        disabled={verifyingOtp}
                        className={`h-[42px] md:w-[120px] rounded-lg text-sm text-white
                          ${verifyingOtp ? "bg-gray-300 cursor-not-allowed" : "bg-green-600"}`}
                      >
                        {verifyingOtp ? "Verifying..." : "Verify"}
                      </button>

                    )}
                  </>
                )}
              </div>

              {/* {phoneVerified && <p className="text-green-600 text-sm">✔ Phone verified successfully</p>} */}
            </div>
          </section>
        )}

        {/* STEP 2 - Payment */}
        {isRetailer && uiStep === 2 && (
          <section className="p-4">
            <h2 className="text-lg font-semibold text-slate-900 mb-4 text-left">
              Choose Your Package
            </h2>

            {loading || keyLoading ? (
              <RegularLoader />
            ) : (
              <>
                {packages.length === 0 && (
                  <p className="text-center text-red-600">No packages available.</p>
                )}

                {packages.length > 0 && (
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-3 max-h-[70vh] overflow-y-auto">

                    {packages.map((pkg) => (
                      <div
                        key={pkg.id}
                        onClick={() => {
                            setSelectedPackage(pkg);
                            localStorage.setItem("selectedPackageId", pkg.id);
                          }}
                        className={`cursor-pointer border rounded-xl p-4 shadow-sm transition duration-200 
                          ${
                            selectedPackage?.id === pkg.id
                              ? "border-blue-600 bg-blue-50"
                              : "border-gray-300 hover:border-blue-400 hover:bg-blue-50"
                          }
                        `}
                      >
                        
                        {user?.leads?.[0]?.package_id=== pkg.id && (
                          <span className="text-[10px] ml-2 text-blue-600 font-semibold">(Assigned)</span>
                        )}
                        {/* Title */}
                        <h4 className="text-lg font-semibold text-gray-800">
                          {pkg.package_name}
                          <span className="text-blue-700"> (₹{pkg.amount})</span>
                        </h4>

                        {/* Validity */}
                        <p className="text-xs text-gray-500">Validity: {pkg.validity_days} Days</p>

                        {/* Badge Section */}
                        {pkg.badge && (
                          <div className="mt-3 p-2 rounded-lg border border-gray-200">

                            <span className="text-xs font-semibold bg-blue-200 text-blue-800 px-2 py-1 rounded">
                              {pkg.badge.name}
                            </span>

                            <p className="text-xs text-gray-700 mt-2">
                              {pkg.badge.description}
                            </p>

                            <div className="text-xs text-gray-700 mt-2 space-y-1">
                              <p><span className="font-semibold">Eligibility:</span> {pkg.badge.eligibility} Users</p>
                              <p><span className="font-semibold">Benefits:</span> {pkg.badge.benefits}% Extra</p>
                            </div>

                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}

                {/* Payment Button Centered */}
                <div className="flex justify-center mt-6">
                  <button
                    disabled={!authUser?.zoho_id || paymentCompleted || paymentSaving}
                    onClick={handlePayment}
                    className={`px-6 py-2.5 rounded-lg text-sm font-medium transition
                      ${
                        !selectedPackage || paymentCompleted || paymentSaving || !authUser?.zoho_id
                          ? "bg-slate-300 text-slate-500 cursor-not-allowed"
                          : "bg-blue-600 text-white hover:bg-blue-700"
                      }`}
                  >
                    {paymentSaving
                        ? "Saving payment..."
                        : paymentCompleted
                        ? "Payment Completed ✔"
                        : selectedPackage
                        ? `Proceed to Pay ₹${selectedPackage.amount}`
                        : "Select a Package to Continue"}

                  </button>

                  
                </div>

                {!authUser?.zoho_id && (
                    <p className="text-red-500 text-sm mt-2 text-center">
                      You can't make payment until Zoho account is created.
                    </p>
                  )}
              </>
            )}
          </section>
        )}

        {/* ------- The rest of your steps remain UNCHANGED ------- */}

        {uiStep === (isRetailer ? 3 : 2) && (
          <section>
            <h2 className="text-lg font-semibold text-slate-900 mb-4">
              Authorized Person PAN Verification
            </h2>

            <div className="grid gap-4 md:grid-cols-2">
              <InputField
                label="PAN Number"
                value={form.panNumber}
                disabled={form.panVerified} // ✅ disable if already verified
                readOnly={form.panVerified}
                className={`${form.panVerified ? "bg-gray-100 text-gray-500 cursor-not-allowed" : ""}`}
                onChange={(val) => !form.panVerified && updateField("panNumber", val.toUpperCase())}
                onBlur={() => validateField("panNumber", form.panNumber)}
                placeholder="ABCDE1234F"
                error={errors.panNumber}
              />

              <div className="flex items-end">
                <button
                  onClick={verifyPAN}
                  disabled={
                    form.panVerified || // ✅ already verified
                    !form.panNumber ||
                    !isValidPAN(form.panNumber) ||
                    loading
                  }
                  className={`px-4 py-2 rounded-lg transition text-white w-full md:w-auto
                    ${form.panVerified ? "bg-green-600 cursor-default" : "bg-blue-600 hover:bg-blue-700 disabled:bg-gray-400"}
                  `}
                >
                  {form.panVerified ? "Verified ✓" : loading ? "Verifying..." : "Verify PAN"}
                </button>
              </div>
            </div>

            {/* PAN verification message */}
            {panMessage && (
              <p className={`text-xs mt-2 font-medium ${form.panVerified ? "text-green-600" : "text-red-500"}`}>
                {panMessage}
              </p>
            )}

            {/* Show verified PAN details if available */}
            {form.panVerified && panApiResponse && (
              <div className="mt-6 border rounded-lg p-4 bg-green-50">
                <h3 className="text-md font-semibold text-green-700 mb-3">
                  PAN Details Verified ✓
                </h3>

                <div className="grid md:grid-cols-2 gap-3 text-sm">
                  <p><strong>PAN:</strong> {panApiResponse.pan}</p>
                  <p><strong>Name:</strong> {panApiResponse.name_pan_card}</p>
                  <p><strong>Gender:</strong> {panApiResponse.gender}</p>
                  <p><strong>DOB:</strong> {panApiResponse.date_of_birth}</p>
                  <p><strong>Mobile:</strong> {panApiResponse.mobile_number}</p>
                  <p><strong>Email:</strong> {panApiResponse.email}</p>
                  <p><strong>Aadhaar Linked:</strong> {panApiResponse.aadhaar_linked ? "Yes" : "No"}</p>
                  <p><strong>City:</strong> {panApiResponse.address?.city}</p>
                  <p><strong>State:</strong> {panApiResponse.address?.state}</p>
                  <p><strong>Pincode:</strong> {panApiResponse.address?.pincode}</p>
                  <p><strong>Type:</strong> {panApiResponse.type}</p>
                </div>

                <p className="mt-2 text-xs text-gray-600">
                  <strong>Full Address:</strong> {panApiResponse.address?.full_address}
                </p>
              </div>
            )}
          </section>
        )}

        {uiStep === (isRetailer ? 4 : 3) && (
          <section>
            <h2 className="text-lg font-semibold text-slate-900 mb-4">GST details</h2>
            <div className="grid gap-4 md:grid-cols-2">
              <SelectField
                label="GST Type"
                required
                value={form.gstTreatment }
                onChange={(value) => handleChange("gstTreatment", value)}
                options={[
                  { value: "registered", label: "Registered" },
                  { value: "unregistered", label: "Unregistered" },
                ]}
                error={errors.gstTreatment}
              />


              <InputField
                label={form.gstTreatment === "unregistered" ? "PAN Number" : "GSTIN"}
                required
                value={form.gstin || gstResponse?.GSTIN}
                readOnly={form.gstTreatment === "unregistered"}
                onChange={(value) => handleChange("gstin", value)}
                placeholder={
                  form.gstTreatment === "unregistered"
                    ? "PAN auto-filled"
                    : "22AAAAA0000A1Z5"
                }
              />


            </div>

            {gstVerified && gstResponse && (
              <div className="mt-4 grid gap-4 md:grid-cols-3">
                <InputField
                  label="Business Legal Name"
                  value={form.businessName}
                  readOnly
                />

                <InputField
                  label="Trade Name"
                  value={form.tradeName || gstResponse?.trade_name_of_business}
                  readOnly
                />

                <InputField
                  label="Taxpayer Type"
                  value={form.taxpayerType}
                  readOnly
                />
              </div>
            )}


            {form.gstTreatment === "registered" && (
              <button
                type="button"
                onClick={verifyGST}
                disabled={gstVerified || gstLoading}
                className={`mt-2 px-4 py-2 rounded-lg text-sm text-white
                  ${gstVerified ? "bg-green-600" : "bg-blue-600 hover:bg-blue-700"}
                `}
              >
                {gstVerified ? "Verified ✓" : gstLoading ? "Verifying..." : "Verify GST"}
              </button>
            )}


            {gstVerified && gstResponse && (
              <div className="mt-4 border rounded-lg p-4 bg-green-50 text-sm">
                <h3 className="font-semibold text-green-700 mb-2">
                  GST Details Verified ✓
                </h3>

                <div className="grid md:grid-cols-2 gap-2">
                  <p><strong>GSTIN:</strong> {gstResponse.GSTIN}</p>
                  <p><strong>Status:</strong> {gstResponse.gst_in_status}</p>
                  <p><strong>Taxpayer Type:</strong> {gstResponse.taxpayer_type}</p>
                  <p><strong>Legal Name:</strong> {gstResponse.legal_name_of_business}</p>
                  <p><strong>Trade Name:</strong> {gstResponse.trade_name_of_business}</p>
                  <p><strong>Registration Date:</strong> {gstResponse.date_of_registration}</p>
                  <p><strong>State Jurisdiction:</strong> {gstResponse.state_jurisdiction}</p>
                  <p><strong>Center Jurisdiction:</strong> {gstResponse.center_jurisdiction}</p>
                </div>

                {/* Address */}
                <div className="mt-3">
                  <p className="font-semibold">Principal Place of Business</p>
                  <p className="text-gray-700">
                    {gstResponse.principal_place_address}
                  </p>
                </div>

                {/* Nature of Business */}
                {Array.isArray(gstResponse.nature_of_business_activities) && (
                  <div className="mt-3">
                    <p className="font-semibold">Nature of Business</p>
                    <ul className="list-disc ml-5 text-gray-700">
                      {gstResponse.nature_of_business_activities.map((item, idx) => (
                        <li key={idx}>{item}</li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            )}
          </section>
        )}

        {uiStep === (isRetailer ? 5 : 4) && (
          <section>
            <h2 className="text-lg font-semibold text-slate-900 mb-4">
              Bank account details
            </h2>

            <div className="grid gap-4 md:grid-cols-3">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Account Type
                </label>
                <select
                  className="border rounded-lg p-2 w-full"
                  value={form.accountType}
                  onChange={(e) => handleChange("accountType", e.target.value)}
                  // disabled={!!form.accountType} // optional read-only if already present
                >
                  <option value="">Select Account Type</option>
                  <option value="current">Current</option>
                  <option value="saving">Saving</option>
                </select>
              </div>

              <InputField
                label="Account Number"
                required
                value={form.accountNumber}
                onChange={(value) => handleChange("accountNumber", value)}
                placeholder="Enter account number"
                error={errors.accountNumber}
                readOnly={bankVerified} // optional
              />

              <InputField
                label="IFSC Code"
                required
                value={form.ifsc}
                onChange={(value) => handleChange("ifsc", value)}
                placeholder="e.g. HDFC0001234"
                error={errors.ifsc}
                readOnly={bankVerified} // optional
              />
            </div>

            {bankVerified && bankResponse && (
              <div className="grid gap-4 md:grid-cols-3 mt-4">
                <InputField
                  label="Branch Name"
                  value={form.branchname}
                  readOnly
                />

                <InputField
                  label="Bank Name"
                  value={form.bankName}
                  readOnly
                />

                <InputField
                  label="Authorized Person Name"
                  value={form.authorisedName}
                  readOnly
                />
              </div>
            )}
            
            {/* <div className="grid gap-4 md:grid-cols-2 mt-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Upload Proof (Select One)
                </label>
                <select
                  className="border rounded-lg p-2 w-full"
                  value={form.bankProofType}
                  onChange={(e) => handleChange("bankProofType", e.target.value)}
                >
                  <option value="">Select Document Type</option>
                  <option value="passbook">Passbook Photo</option>
                  <option value="cheque">Cancelled Cheque</option>
                </select>
              </div>

              {form.bankProofType && (
                <div className="p-4 border border-gray-300 rounded-lg">
                  <p className="text-sm text-gray-600 mb-3">
                    Upload:{" "}
                    <span className="font-semibold">
                      {form.bankProofType === "passbook" ? "Passbook Photo" : "Cancelled Cheque"}
                    </span>
                  </p>

                  <div className="flex items-center gap-3 mt-2">
                    <input
                      type="file"
                      accept="image/*,application/pdf"
                      onChange={(e) => handleChange("bankProofFile", e.target.files[0])}
                      className="w-full text-sm"
                    />
                    <BlueButton
                      onClick={handleUpload}
                      disabled={
                        !form.bankProofFile ||
                        !form.bankProofType ||
                        uploading ||
                        isUploaded   // ⬅️ disabled after success
                      }
                    >
                      {isUploaded ? "Uploaded" : uploading ? "Uploading..." : "Upload"}
                    </BlueButton>


                  </div>

                  {form.bankProofFile && (
                    <p className="text-green-600 text-sm mt-2">
                      File selected: {form.bankProofFile.name}
                    </p>
                  )}
                </div>
              )}

            </div> */}

            <button
              type="button"
              onClick={verifyBankAccount}
              disabled={bankVerified || bankLoading}
              className={`mt-5 px-4 py-2 rounded-lg text-sm text-white
                ${bankVerified ? "bg-green-600" : "bg-blue-600 hover:bg-blue-700"}
              `}
            >
              {bankVerified ? "Verified ✓" : bankLoading ? "Verifying..." : "Verify Account"}
            </button>

            {bankVerified && bankResponse && (
              <div className="mt-4 border rounded-lg p-4 bg-green-50 text-sm">
                <h3 className="font-semibold text-green-700 mb-2">
                  Bank Account Verified ✓
                </h3>

                <div className="grid md:grid-cols-2 gap-2">
                  <p><strong>Account Status:</strong> {bankResponse.account_status}</p>
                  <p><strong>Bank Name:</strong> {bankResponse.bank_name}</p>
                  <p><strong>Branch:</strong> {bankResponse.branch}</p>
                  <p><strong>City:</strong> {bankResponse.city}</p>
                  <p><strong>IFSC:</strong> {bankResponse.ifsc_details?.ifsc}</p>
                  <p><strong>MICR:</strong> {bankResponse.micr}</p>
                  <p><strong>UTR:</strong> {bankResponse.utr}</p>
                  <p><strong>Name at Bank:</strong> {bankResponse.name_at_bank}</p>
                </div>
              </div>
            )}

          </section>
        )}

        {uiStep === (isRetailer ? 6 : 5) && (
          <section>
            <h2 className="text-lg font-semibold text-slate-900 mb-4">
              Sign User Agreement
            </h2>

            {agreementUrl ? (
              <div className="flex justify-center min-h-screen bg-white">
                <div className="bg-slate-50 border p-2 rounded-xl text-xs text-slate-600 flex flex-col gap-3 max-w-[800px] w-full items-center shadow-md">
                  <div
                    ref={scrollRef}
                    onScroll={handleScroll}
                    className="border rounded-xl bg-white shadow-inner p-2 w-full h-[700px] overflow-y-auto"
                  >
                    <iframe
                      src={`https://docs.google.com/viewer?url=${agreementUrl}&embedded=true`}
                      title="Agreement PDF"
                      className="w-full h-[1400px]"
                    />
                  </div>

                  <a
                    href={agreementUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 underline font-medium text-sm"
                  >
                    Download Agreement PDF
                  </a>
                </div>
              </div>
            ) : (
              <RegularLoader />
            )}

            {/* Agreement Checkbox */}
            <label className="mt-4 flex items-start gap-2">
              <input
                type="checkbox"
                className="mt-1 w-4 h-4"
                checked={form.agreed}
                disabled={!hasScrolledToBottom}
                onChange={(e) => handleAgreementCheck(e.target.checked)}
              />
              <span
                className={`text-sm ${
                  !hasScrolledToBottom ? "text-gray-400" : "text-slate-700"
                }`}
              >
                I agree to the user agreement.
              </span>
            </label>

            {!hasScrolledToBottom && (
              <p className="text-xs text-red-500 mt-1">
                Scroll to the bottom to enable agreement.
              </p>
            )}
          </section>
        )}

        {/* {currentStep === 7 && (
            <section className="flex justify-center">
              <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white/80 shadow-sm backdrop-blur p-6 flex flex-col items-center gap-5">

                
                {!form.aadhaarVerified && (
                  <>
                    
                    <div className="flex items-center gap-3 w-full">
                      <div className="shrink-0 rounded-xl p-3 bg-gradient-to-br from-sky-500/10 to-indigo-500/10">
                        <img
                          src={esign}
                          alt="Aadhaar e-Sign"
                          className="w-10 h-10 object-contain"
                        />
                      </div>
                      <div className="flex-1">
                        <h2 className="text-base md:text-lg font-semibold text-slate-900">
                          Aadhaar e-Sign Verification
                        </h2>
                        <p className="text-xs text-slate-500">
                          Enter the last 4 digits of your Aadhaar. We’ll open a secure e-Sign window.
                        </p>
                      </div>
                    </div>

                  
                    <div className="mt-2 flex justify-center w-full">
                      <div className="flex gap-2">
                        {Array.from({ length: 4 }).map((_, idx) => (
                          <input
                            key={idx}
                            ref={(el) => (aadhaarInputsRef.current[idx] = el)}
                            inputMode="numeric"
                            pattern="[0-9]*"
                            type="text"
                            maxLength={1}
                            value={form?.aadhaarLast4?.[idx] || ""}
                            onChange={(e) => handleAadhaarBoxChange(idx, e.target.value)}
                            onKeyDown={(e) => handleAadhaarKeyDown(idx, e)}
                            disabled={form.aadhaarVerified}
                            className="w-12 h-12 text-center text-lg font-semibold rounded-xl border border-slate-300 bg-white focus:outline-none focus:ring-2 focus:ring-sky-400 disabled:bg-slate-100"
                          />
                        ))}
                      </div>
                    </div>
                  </>
                )}

                
                <div className="min-h-[18px] text-center text-xs">
                  {aadhaarError ? (
                    <span className="text-red-600">{aadhaarError}</span>
                  ) : form.aadhaarVerified || aadhaarStatus === "success" ? (
                    <>
                  <div className="w-full max-w-md rounded-2xl shadow-sm p-6 flex flex-col items-center gap-5">
                      <img
                        src={verifiedimg} // make sure this points to your verified.avif file
                        alt="e-Sign Verified"
                        className="w-40 h-40 object-contain bg-transparent"
                      />

                    </div>


                    <span className="text-green-600">Verified ✅ e-Sign completed</span>
                    </>
                    
                  ) : aadhaarStatus === "verifying" ? (
                    <span className="text-slate-500">
                      Waiting for you to complete e-Sign in the popup...
                    </span>
                  ) : (
                    <span className="text-slate-500">
                      We’ll redirect you to a secure UIDAI-compliant e-Sign partner.
                    </span>
                  )}
                </div>

              
                {!form.aadhaarVerified && (
                  <button
                    type="button"
                    onClick={verifyAadhaar}
                    disabled={
                      !aadhaarValid ||
                      form.aadhaarVerified ||
                      aadhaarStatus === "loading" ||
                      aadhaarStatus === "verifying"
                    }
                    className="w-full max-w-xs rounded-xl py-2.5 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 disabled:bg-slate-400"
                  >
                    {form.aadhaarVerified ? "e-Sign Verified" : "Verify & Open e-Sign"}
                  </button>
                )}

                {!form.aadhaarVerified && (
                <p className="text-[11px] text-center text-slate-500">
                  By continuing, you consent to Aadhaar-based e-Sign for this agreement.
                </p>
                )}
              </div>
            </section>
          )} */}

        {displayStep === 7 && (
          <section className="flex justify-center">
            <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white/80 shadow-sm backdrop-blur p-6 flex flex-col items-center gap-5">

              {/* Only show header & input boxes if NOT verified */}
              {!form.aadhaarVerified && (
                <>
                  {/* Header */}
                  <div className="flex items-center gap-3 w-full">
                    <div className="shrink-0 rounded-xl p-3 bg-gradient-to-br from-sky-500/10 to-indigo-500/10">
                      <img
                        src={esign}
                        alt="Aadhaar e-Sign"
                        className="w-10 h-10 object-contain"
                      />
                    </div>
                    <div className="flex-1">
                      <h2 className="text-base md:text-lg font-semibold text-slate-900">
                        Aadhaar e-Sign Verification
                      </h2>
                      <p className="text-xs text-slate-500">
                        Enter the last 4 digits of your Aadhaar. We’ll open a secure e-Sign window.
                      </p>
                    </div>
                  </div>

                  {/* 4 Input Boxes */}
                  <div className="mt-2 flex justify-center w-full">
                    <div className="flex gap-2">
                      {Array.from({ length: 4 }).map((_, idx) => (
                        <input
                          key={idx}
                          ref={(el) => (aadhaarInputsRef.current[idx] = el)}
                          inputMode="numeric"
                          pattern="[0-9]*"
                          type="text"
                          maxLength={1}
                          value={form?.aadhaarLast4?.[idx] || ""}
                          onChange={(e) => handleAadhaarBoxChange(idx, e.target.value)}
                          onKeyDown={(e) => handleAadhaarKeyDown(idx, e)}
                          disabled={form.aadhaarVerified}
                          className="w-12 h-12 text-center text-lg font-semibold rounded-xl border border-slate-300 bg-white focus:outline-none focus:ring-2 focus:ring-sky-400 disabled:bg-slate-100"
                        />
                      ))}
                    </div>
                  </div>
                </>
              )}

              {/* Helper / Error / Success */}
              <div className="min-h-[18px] text-center text-xs">

                {/* 🔵 Loader for get-esign-status */}
                {esignStatusLoading && (
                  <div className="flex justify-center items-center gap-2 text-blue-600 py-2">
                    <svg className="w-4 h-4 animate-spin" viewBox="0 0 24 24">
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                      ></path>
                    </svg>
                    Checking e-Sign status...
                  </div>
                )}

                {/* 🔻 Hide all other messages when loader is running */}
                {!esignStatusLoading && (
                  <>
                    {aadhaarError ? (
                      <span className="text-red-600">{aadhaarError}</span>
                    ) : form.aadhaarVerified || aadhaarStatus === "success" ? (
                      <>
                        <div className="w-full max-w-md rounded-2xl shadow-sm p-6 flex flex-col items-center gap-5">
                          <img
                            src={verifiedimg}
                            alt="e-Sign Verified"
                            className="w-40 h-40 object-contain bg-transparent"
                          />
                        </div>
                        <span className="text-green-600">
                          Verified ✅ e-Sign completed
                        </span>
                      </>
                    ) : aadhaarStatus === "verifying" ? (
                      <span className="text-slate-500">
                        Waiting for you to complete e-Sign in the popup...
                      </span>
                    ) : (
                      <span className="text-slate-500">
                        We’ll redirect you to a secure UIDAI-compliant e-Sign partner.
                      </span>
                    )}
                  </>
                )}
              </div>

              {/* Button */}
              {!form.aadhaarVerified && (
                <button
                  type="button"
                  onClick={verifyAadhaar}
                  disabled={
                    !aadhaarValid ||
                    aadhaarStatus === "loading" ||
                    aadhaarStatus === "verifying" ||
                    esignStatusLoading
                  }
                  className="w-full max-w-xs rounded-xl py-2.5 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 disabled:bg-slate-400"
                >
                  {esignStatusLoading
                    ? "Checking Status..."
                    : form.aadhaarVerified
                    ? "e-Sign Verified"
                    : "Verify & Open e-Sign"}
                </button>
              )}

              {/* Small note */}
              {!form.aadhaarVerified && (
                <p className="text-[11px] text-center text-slate-500">
                  By continuing, you consent to Aadhaar-based e-Sign for this agreement.
                </p>
              )}
            </div>
          </section>
        )}
      </div>
    </>
  );
}



// import { useEffect, useRef, useState } from "react";
// import InputField from "./InputField";
// import SelectField from "./SelectField";
// import toast from "react-hot-toast";
// import RegularLoader from "../Loader/RegularLoader";
// import BlueButton from "../Common/BlueButton";
// import { APPID, BASE_URL, SecretKey, SWAGGER_URL } from "../../config/api";
// import esign from "../../asset/images/esign.webp";
// import verifiedimg from "../../asset/images/verified.avif";
// import FullPageLoader from "../Common/FullPageLoader";

// export default function FormBody({ currentStep, form, updateField, selectedPackage, setSelectedPackage,panApiResponse, setPanApiResponse, verifyAadhaar, aadhaarStatus, setAadhaarStatus, setForm, esignStatusLoading, setIsPaymentSuccess, gstVerified,
//   setGstVerified, gstResponse, setGstResponse,bankVerified, setBankVerified, bankResponse, setBankResponse,zohoId, setZohoId }) {
//   const isUnregistered = form.gstTreatment === "unregistered";

//   const [errors, setErrors] = useState({});
//   const [emailOtpSent, setEmailOtpSent] = useState(false);
//   const [emailVerified, setEmailVerified] = useState(false);
//   const [phoneOtpSent, setPhoneOtpSent] = useState(false);
//   const [phoneVerified, setPhoneVerified] = useState(false);
//   const [emailOtp, setEmailOtp] = useState("");
//   const [phoneOtp, setPhoneOtp] = useState("");
//   const [packages, setPackages] = useState([]);
//   // const [selectedPackage, setSelectedPackage] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const authUser = JSON.parse(localStorage.getItem("authUserData") || "{}");
//   const id = authUser?.id;
//   const role = authUser?.role;
//   const [agreementUrl, setAgreementUrl] = useState(null);
//   const [hasScrolledToBottom, setHasScrolledToBottom] = useState(false);
//   const [panMessage, setPanMessage] = useState("");
//   // const [aadhaarStatus, setAadhaarStatus] = useState("idle"); // idle | loading | verifying | success | error
//   const [aadhaarError, setAadhaarError] = useState("");
//   const esignPopupRef = useRef(null);
//   const esignPollRef = useRef(null);
//   const aadhaarInputsRef = useRef([]);

//   const [isUploaded, setIsUploaded] = useState(false);

//   const [resendEmailTimer, setResendEmailTimer] = useState(0);

//   const [sendingEmailOtp, setSendingEmailOtp] = useState(false);
// const [verifyingEmailOtp, setVerifyingEmailOtp] = useState(false);


//   const [sendingOtp, setSendingOtp] = useState(false);
//   const [resendTimer, setResendTimer] = useState(0); // seconds
//   const [verifyingOtp, setVerifyingOtp] = useState(false);
//   const [uploading, setUploading] = useState(false);

//   const [paymentKeys, setPaymentKeys] = useState({
//     key_id: "",
//     key_secret: ""
//   });
//   const [keyLoading, setKeyLoading] = useState(false);
//   const [paymentCompleted, setPaymentCompleted] = useState(false);
//   const [gstLoading, setGstLoading] = useState(false);
//   const [bankLoading, setBankLoading] = useState(false);
//   const [paymentSaving, setPaymentSaving] = useState(false);

//   const [pageLoading, setPageLoading] = useState(true);
//   const isRetailer = role === 5;
//   const isNonRetailer = role === 2 || role === 4;


//   useEffect(() => {
//   const authUser = JSON.parse(localStorage.getItem("authUserData") || "{}");
//   const userId = authUser?.id;

//   if (!userId) {
//     setPageLoading(false);
//     return;
//   }

//   const fetchUserFromApi = async () => {
//     try {
//       setPageLoading(true);

//       const res = await fetch(`${BASE_URL}common/get-users?id=${userId}`);
//       const json = await res.json();

//       if (!json?.status || !json?.data?.length) return;

//       const user = json.data[0];

//       // BASIC DETAILS
//       setForm(prev => ({
//         ...prev,
//         businessName: user.business_name || "",
//         authorisedName: user.business_name || "",
//         email: user.contact_email || "",
//         phone: user.contact_phone || "",
//         address_line1: user.address_line1 || "",
//         address_line2: user.address_line2 || "",
//         city: user.city || "",
//         district: user.district || "",
//         state: user.state || "",
//         pincode: user.pincode || "",
//         gstTreatment: user.business_type || "",
//         gstin: user.gst || user.pan || "",
//         accountNumber: user.account_no || "",
//         ifsc: user.ifsc_code || "",
//         bankName: user.bank_name || "",
//         branchname: user.branch_name || "",
//         accountType: user.account_type || "",
//       }));

//       // PAN
//       if (Number(user.pan_verified) === 1 && user.pan_json) {
//         updateField("panVerified", true);
//         setPanApiResponse(JSON.parse(user.pan_json));
//         updateField("panNumber", JSON.parse(user.pan_json)?.pan || "");
//       }

//       // GST
//       if (Number(user.gst_verified) === 1 && user.gst_json) {
//         const gstData = JSON.parse(user.gst_json);
//         setGstVerified(true);
//         setGstResponse(gstData);
//       }

//       // BANK
//       if (Number(user.bank_verified) === 1 && user.bank_json) {
//         setBankVerified(true);
//         setBankResponse(JSON.parse(user.bank_json));
//       }

//       // EMAIL / PHONE
//       if (Number(user.is_mail_verified) === 1) setEmailVerified(true);
//       if (Number(user.is_wa_verified) === 1) setPhoneVerified(true);

//     } catch (err) {
//       console.error("Failed to fetch user from API", err);
//     } finally {
//       setPageLoading(false); // ✅ STOP LOADER
//     }
//   };

//   fetchUserFromApi();
// }, []);



//   const fetchPaymentKeys = async () => {
//   try {
//     setKeyLoading(true);

//     const res = await fetch(`${BASE_URL}payment/keys`);
//     const data = await res.json();

//     if (Array.isArray(data) && data.length > 0) {
//       setPaymentKeys({
//         key_id: data[0].key_id,
//         key_secret: data[0].key_secret
//       });
//     } else {
//       console.error("Invalid keys response", data);
//     }
//   } catch (err) {
//     console.error("Failed to fetch payment keys", err);
//   } finally {
//     setKeyLoading(false);
//   }
// };


//   useEffect(() => {
//   if (currentStep === 2) {
//     fetchPaymentKeys();
//   }
// }, [currentStep]);




//   const handleAadhaarBoxChange = (idx, value) => {
//     const digit = value.replace(/\D/g, "").slice(0, 1);

//     const chars = (form.aadhaarLast4 || "").split("");
//     while (chars.length < 4) chars.push("");
//     chars[idx] = digit;

//     const joined = chars.join("");
//     updateField("aadhaarLast4", joined);

//     if (digit && aadhaarInputsRef.current[idx + 1]) {
//       aadhaarInputsRef.current[idx + 1].focus();
//     }
//   };

//   const handleAadhaarKeyDown = (idx, e) => {
//     if (e.key === "Backspace" && !form.aadhaarLast4?.[idx]) {
//       if (aadhaarInputsRef.current[idx - 1]) {
//         aadhaarInputsRef.current[idx - 1].focus();
//       }
//     }
//     if (e.key === "ArrowLeft" && aadhaarInputsRef.current[idx - 1]) {
//       aadhaarInputsRef.current[idx - 1].focus();
//     }
//     if (e.key === "ArrowRight" && aadhaarInputsRef.current[idx + 1]) {
//       aadhaarInputsRef.current[idx + 1].focus();
//     }
//   };

//   const aadhaarValid =
//     form.aadhaarLast4 &&
//     form.aadhaarLast4.length === 4 &&
//     /^\d{4}$/.test(form.aadhaarLast4);

//   // NOTE: update verifyAadhaar() to accept last4 and return eSign URL (Promise<string>)
//   // const handleEsignClick = async () => {
//   //   if (!aadhaarValid) {
//   //     toast.error("Enter valid last 4 digits of Aadhaar");
//   //     return;
//   //   }

//   //   setAadhaarError("");
//   //   setAadhaarStatus("loading");

//   //   try {
//   //     // 👇 You must update verifyAadhaar to:
//   //     // async function verifyAadhaar(last4) { ... return esignUrl }
//   //     const esignUrl = await verifyAadhaar(form.aadhaarLast4);

//   //     if (!esignUrl) {
//   //       throw new Error("Invalid e-Sign link from server");
//   //     }

//   //     setAadhaarStatus("verifying");
//   //     openEsignPopup(esignUrl);
//   //   } catch (err) {
//   //     console.error(err);
//   //     setAadhaarStatus("error");
//   //     setAadhaarError(err?.message || "Failed to start e-Sign");
//   //     toast.error("Unable to start e-Sign");
//   //   }
//   // };

//   const cleanupEsignPopup = () => {
//     if (esignPollRef.current) {
//       clearInterval(esignPollRef.current);
//       esignPollRef.current = null;
//     }
//     if (esignPopupRef.current && !esignPopupRef.current.closed) {
//       try {
//         esignPopupRef.current.close();
//       } catch (e) {
//         console.error(e);
//       }
//     }
//     esignPopupRef.current = null;
//   };

//   const openEsignPopup = (url) => {
//     const w = 460;
//     const h = 640;
//     const dualScreenLeft =
//       window.screenLeft !== undefined ? window.screenLeft : window.screenX;
//     const dualScreenTop =
//       window.screenTop !== undefined ? window.screenTop : window.screenY;
//     const width =
//       window.innerWidth ||
//       document.documentElement.clientWidth ||
//       window.screen.width;
//     const height =
//       window.innerHeight ||
//       document.documentElement.clientHeight ||
//       window.screen.height;

//     const left = width / 2 - w / 2 + dualScreenLeft;
//     const top = height / 2 - h / 2 + dualScreenTop;

//     const features = `scrollbars=yes,resizable=yes,width=${w},height=${h},top=${top},left=${left}`;
//     esignPopupRef.current = window.open(url, "esignPopup", features);

//     // Fallback polling – if popup closed manually
//     esignPollRef.current = setInterval(() => {
//       if (!esignPopupRef.current || esignPopupRef.current.closed) {
//         clearInterval(esignPollRef.current);
//         esignPollRef.current = null;
//         esignPopupRef.current = null;

//         // Only reset state if we were waiting
//         if (aadhaarStatus === "verifying") {
//           setAadhaarStatus("idle");
//         }
//       } else {
//         // OPTIONAL: if your success page is same-origin and has /esign-success in URL
//         try {
//           const href = esignPopupRef.current.location.href || "";
//           if (href.includes("esign-success")) {
//             cleanupEsignPopup();
//             setAadhaarStatus("success");
//             updateField("aadhaarVerified", true);
//             toast.success("e-Sign verified successfully");
//           }
//         } catch {
//           // Cross-origin during provider flow – ignore
//         }
//       }
//     }, 800);
//   };

//   // Listen for postMessage from success page
//   useEffect(() => {
//     const handler = (e) => {
//       // In production, replace "*" with your exact origin and check e.origin
//       if (e?.data?.type === "ESIGN_SUCCESS") {
//         cleanupEsignPopup();
//         setAadhaarStatus("success");
//         updateField("aadhaarVerified", true);
//         toast.success("e-Sign verified successfully");
//       }
//       if (e?.data?.type === "ESIGN_CANCELLED") {
//         cleanupEsignPopup();
//         setAadhaarStatus("idle");
//         toast.error("e-Sign cancelled");
//       }
//     };

//     window.addEventListener("message", handler);
//     return () => window.removeEventListener("message", handler);
//   }, []);

//   const scrollRef = useRef(null);

//   const handleScroll = () => {
//     const el = scrollRef.current;
//     if (!el) return;

//     if (el.scrollTop + el.clientHeight >= el.scrollHeight - 5) {
//       setHasScrolledToBottom(true);
//     }
//   };

//   // Prefill form fields from localStorage on mount
//   useEffect(() => {
//     const storedUser = localStorage.getItem("authUserData");
//     if (storedUser) {
//       try {
//         const user = JSON.parse(storedUser);

//         updateField("address_line1", user.address_line1 || "");
//         updateField("address_line2", user.address_line2 || "");
//         updateField("state", user.state || "");
//         updateField("district", user.district || "");
//         updateField("city", user.city || "");
//         updateField("pincode", user.pincode || "");
//         updateField("email", user.contact_email || "");
//         updateField("phone", user.contact_phone || "");
//       } catch (err) {
//         console.error("Invalid session user data", err);
//       }
//     }
//   }, []);

//   // ---------------- Email + Phone OTP Logic ----------------
//   const sendEmailOtp = async () => {
//   const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

//   if (!form.email || !emailRegex.test(form.email)) {
//     toast.error("Invalid email format");
//     return;
//   }

//   const storedUser = localStorage.getItem("authUserData");
//   const user = storedUser ? JSON.parse(storedUser) : null;
//   const userId = user?.id;

//   if (!userId) {
//     toast.error("User session not found");
//     return;
//   }

//   try {
//     setSendingEmailOtp(true); // 🔥 START LOADER

//     const response = await fetch(`${BASE_URL}send-welcome-email/${userId}`, {
//       method: "GET",
//       cache: "no-store",
//     });

//     const result = await response.json();

//     if (result?.status) {
//       setEmailOtpSent(true);

//       const endTime = Date.now() + 5 * 60 * 1000;
//       localStorage.setItem("resendEmailOtpEndTime", endTime);
//       setResendEmailTimer(5 * 60);

//       toast.success("Email OTP sent successfully!");
//     } else {
//       toast.error(result?.message || "Failed to send OTP");
//     }
//   } catch (error) {
//     toast.error("Something went wrong");
//   } finally {
//     setSendingEmailOtp(false); // 🔥 STOP LOADER
//   }
// };


//   useEffect(() => {
//     const storedEndTime = localStorage.getItem("resendEmailOtpEndTime");
//     if (storedEndTime) {
//       const remaining = Math.floor((storedEndTime - Date.now()) / 1000);
//       if (remaining > 0) setResendEmailTimer(remaining);
//       else localStorage.removeItem("resendEmailOtpEndTime");
//     }
//   }, []);

//   useEffect(() => {
//     if (resendEmailTimer <= 0) return;

//     const interval = setInterval(() => {
//       setResendEmailTimer(prev => {
//         if (prev <= 1) {
//           clearInterval(interval);
//           localStorage.removeItem("resendEmailOtpEndTime");
//           return 0;
//         }
//         return prev - 1;
//       });
//     }, 1000);

//     return () => clearInterval(interval);
//   }, [resendEmailTimer]);


// const verifyEmailOtp = async () => {
//   if (!emailOtp) {
//     toast.error("Enter OTP");
//     return;
//   }

//   try {
//     setVerifyingEmailOtp(true); // 🔥 START LOADER

//     const authUser = JSON.parse(localStorage.getItem("authUserData") || "{}");

//     const res = await fetch(`${BASE_URL}verify-email-otp`, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({
//         email: form.email,
//         otp: emailOtp,
//         user_id: authUser.id,
//         company_id: authUser.company_id || 1,
//       }),
//     });

//     const data = await res.json();

//     if (data?.status) {
//       setEmailVerified(true);

//       if (data.zoho_id) {
//         setZohoId(data.zoho_id);
//         localStorage.setItem(
//           "authUserData",
//           JSON.stringify({ ...authUser, zoho_id: data.zoho_id })
//         );
//       }

//       toast.success("Email verified successfully");
//     } else {
//       toast.error(data?.message || "Invalid OTP");
//     }
//   } catch (err) {
//     toast.error("Verification failed");
//   } finally {
//     setVerifyingEmailOtp(false); // 🔥 STOP LOADER
//   }
// };




//   useEffect(() => {
//     const savedEmailOtpSent = localStorage.getItem("emailOtpSent");
//     const savedEmailVerified = localStorage.getItem("emailVerified");
//     const savedEmail = localStorage.getItem("verifiedEmail");

//     if (savedEmailOtpSent === "true") setEmailOtpSent(true);
//     if (savedEmailVerified === "true") setEmailVerified(true);

//     if (savedEmail) {
//       setForm(prev => ({ ...prev, email: savedEmail }));
//     }
//   }, []);
  
//   // Automatically mark email as verified if user logged in with verified email
//   useEffect(() => {
//     const storedUser = localStorage.getItem("authUserData");
//     if (storedUser) {
//       try {
//         const user = JSON.parse(storedUser);

//         if (user.is_mail_verified === 1) {
//           setEmailVerified(true);
//           localStorage.setItem("emailVerified", "true");
//           localStorage.setItem("verifiedEmail", user.contact_email || "");
//           setForm(prev => ({
//             ...prev,
//             email: user.contact_email || "",
//           }));
//         }
//       } catch (err) {
//         console.error("Error parsing authUserData", err);
//       }
//     }
//   }, []);

//   const handleEmailChange = (value) => {
//     handleChange("email", value);

//     // Reset stored status if email changes
//     localStorage.removeItem("emailOtpSent");
//     localStorage.removeItem("emailVerified");
//     localStorage.removeItem("verifiedEmail");

//     setEmailOtpSent(false);
//     setEmailVerified(false);
//     setEmailOtp("");
//   };

//   const sendPhoneOtp = async () => {
//   if (!form.phone) return;

//   try {
//     setSendingOtp(true);

//     const response = await fetch(`${BASE_URL}send-wa-otp`, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ contact_phone: form.phone, company_id: authUser.id }),
//     });
//     const result = await response.json();

//     if (response.ok) {
//       setPhoneOtpSent(true);
//       localStorage.setItem("phoneOtpSent", "true");
//       toast.success("Phone OTP sent successfully!");

//       // Start 10 min timer
//       const endTime = Date.now() + 5 * 60 * 1000;
//       localStorage.setItem("resendOtpEndTime", endTime);
//       setResendTimer(5 * 60); // in seconds
//     } else {
//       toast.error(result.message || "Failed to send OTP");
//     }
//   } catch (error) {
//     toast.error("Failed to send OTP");
//   } finally {
//     setSendingOtp(false);
//   }
// };

//   useEffect(() => {
//   const storedEndTime = localStorage.getItem("resendOtpEndTime");
//   if (storedEndTime) {
//     const remaining = Math.floor((storedEndTime - Date.now()) / 1000);
//     if (remaining > 0) setResendTimer(remaining);
//     else localStorage.removeItem("resendOtpEndTime");
//   }
// }, []);

//   useEffect(() => {
//     if (resendTimer <= 0) return;

//     const interval = setInterval(() => {
//       setResendTimer(prev => {
//         if (prev <= 1) {
//           clearInterval(interval);
//           localStorage.removeItem("resendOtpEndTime");
//           return 0;
//         }
//         return prev - 1;
//       });
//     }, 1000);

//     return () => clearInterval(interval);
//   }, [resendTimer]);

//   const verifyPhoneOtp = async () => {
//     if (!phoneOtp) {
//       toast.error("Enter OTP");
//       return;
//     }

//     try {
//       setVerifyingOtp(true);

//       const response = await fetch(`${BASE_URL}verify-wa-otp`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ contact_phone: form.phone, otp: phoneOtp }),
//       });
//       const result = await response.json();

//       if (!response.ok) throw new Error(result.message);

//       setPhoneVerified(true);
//       localStorage.setItem("phoneVerified", "true");
//       localStorage.removeItem("phoneOtp");
//       localStorage.removeItem("phoneOtpSent");

//       toast.success("Phone Verified Successfully!");
//     } catch (error) {
//       toast.error(error.message || "Invalid OTP");
//     } finally {
//       setVerifyingOtp(false);
//     }
//   };

//   useEffect(() => {
//     const storedPhoneSent = localStorage.getItem("phoneOtpSent");
//     const storedPhoneVerified = localStorage.getItem("phoneVerified");
//     const storedPhoneOtp = localStorage.getItem("phoneOtp");

//     if (storedPhoneSent === "true") setPhoneOtpSent(true);
//     if (storedPhoneVerified === "true") setPhoneVerified(true);
//     if (storedPhoneOtp) setPhoneOtp(storedPhoneOtp);
//   }, []);

//   // Automatically mark phone as verified if user logged in with verified phone
//   useEffect(() => {
//     const storedUser = localStorage.getItem("authUserData");
//     if (storedUser) {
//       try {
//         const user = JSON.parse(storedUser);

//         if (user.is_wa_verified === 1) {
//           setPhoneVerified(true);
//           localStorage.setItem("phoneVerified", "true");
//           localStorage.setItem("verifiedPhone", user.contact_phone || "");
//           setForm(prev => ({
//             ...prev,
//             phone: user.contact_phone || "",
//           }));
//         }
//       } catch (err) {
//         console.error("Error parsing authUserData", err);
//       }
//     }
//   }, []);

//   // ---------------- Validation ----------------
//   const validateField = (field, value, isUnregistered = false) => {
//   let error = "";

//   switch (field) {
//     case "email":
//       if (!value) error = "Email is required";
//       else {
//         const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//         if (!emailRegex.test(value)) error = "Invalid email format";
//       }
//       break;

//     case "phone":
//       if (!value) error = "Phone is required";
//       else {
//         const phoneRegex = /^[6-9][0-9]{9}$/;
//         if (!phoneRegex.test(value)) error = "Invalid phone number format";
//       }
//       break;

//     case "panNumber": 
//       if (!value) error = "Enter PAN Number";
//       else {
//         const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
//         if (!panRegex.test(value)) error = "Invalid PAN format (e.g. ABCDE1234F)";
//       }
//       break;

//     case "gstTreatment":
//       if (!value) error = "Select GST treatment";
//       break;

//     case "gstin":
//       if (!value) {
//         error = isUnregistered ? "Enter PAN number" : "Enter GSTIN / UIN";
//       } else {
//         if (isUnregistered) {
//           const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
//           if (!panRegex.test(value)) error = "Invalid PAN format";
//         } else {
//           const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/;
//           if (!gstRegex.test(value)) error = "Invalid GSTIN format";
//         }
//       }
//       break;

//     case "businessName":
//       if (!value) error = "Enter legal business name";
//       break;

//     case "accountNumber":
//       if (!value) error = "Enter account number";
//       break;

//     case "ifsc":
//       if (!value) error = "Enter IFSC code";
//       // else {
//       //   const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
//       //   if (!ifscRegex.test(value)) error = "Invalid IFSC format";
//       // }
//       break;

//     case "bankName":
//       if (!value) error = "Enter bank name";
//       break;

//     case "authorisedName":
//       if (!value) error = "Authorised person is required";
//       break;

//     case "agreed":
//       if (!value) error = "You must accept the agreement to continue";
//       break;

//     default:
//       break;
//   }

//   setErrors((prev) => ({ ...prev, [field]: error }));
//   return error === "";
// };

// // ---------------- PAN VALIDATION FUNCTION ----------------
// const isValidPAN = (pan) => {
//   const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
//   return panRegex.test(pan);
// };

//   useEffect(() => {
//     const sessionData = localStorage.getItem("authUserData");
//     if (!sessionData) return;

//     const user = JSON.parse(sessionData);

//     if (Number(user?.pan_verified) === 1) {
//       const panFromSession =
//         user?.pan_number ||
//         user?.pan ||
//         (user?.pan_json ? JSON.parse(user.pan_json)?.pan : "");

//       setForm(prev => ({
//         ...prev,
//         panNumber: panFromSession,
//         panVerified: true,
//       }));

//       if (user?.pan_json) {
//         setPanApiResponse(JSON.parse(user.pan_json));
//       }
//     }
//   }, []);

//   const generateVerificationId = (pan) => {
//   const now = new Date();

//   const yyyy = now.getFullYear();
//   const mm = String(now.getMonth() + 1).padStart(2, "0");
//   const dd = String(now.getDate()).padStart(2, "0");

//   const hh = String(now.getHours()).padStart(2, "0");
//   const min = String(now.getMinutes()).padStart(2, "0");
//   const ss = String(now.getSeconds()).padStart(2, "0");

//   return `${pan}-${yyyy}${mm}${dd}-${hh}${min}${ss}`;
// };


// // ---------------- PAN VERIFY API CALL ----------------
//   const verifyPAN = async () => {
//     if (!form.panNumber) return;
//     if (!isValidPAN(form.panNumber)) {
//       validateField("panNumber", form.panNumber);
//       return;
//     }

//     try {
//       setLoading(true);

//       const payload = {
//         pan: form.panNumber,
//         // verification_id: authUser?.company_code,
//         // verification_id: `${form.panNumber}_${authUser?.leads?.[0]?.lead_code}`,
//         verification_id: generateVerificationId(form.panNumber),
//         name: authUser?.contact_person,
//       };

//       const response = await fetch(`${SWAGGER_URL}/Cashfree/pan-advance`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           AppId: APPID,
//           SecretKey: SecretKey,
//         },
//         body: JSON.stringify(payload),
//       });

//       const data = await response.json();

//       if (response.ok && data?.status === "VALID") {

//         updateField("panVerified", true);

//         // 🔥 store full response in parent onboarding
//         setPanApiResponse(data);

//         toast.success(data?.message || "PAN Verified Successfully!");
//       } else {
//         toast.error(data?.message || "Verification Failed.");
//       }
//     } catch (error) {
//       toast.error("Something went wrong.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//   const sessionData = localStorage.getItem("authUserData");
//   if (sessionData) {
//     const user = JSON.parse(sessionData);

//     // Pre-fill GST / Business details
//     setForm(prev => ({
//       ...prev,
//       gstTreatment: user.business_type || "",       // regular, composition, unregistered
//       gstin: user.gst || user.pan || "",         // GSTIN or PAN if unregistered
//       businessName: user.business_name || "",
//       tradeName: user.trade_name || "",
//     }));
//   }
// }, []);

// useEffect(() => {
//   const sessionData = localStorage.getItem("authUserData");
//   if (!sessionData) return;

//   const user = JSON.parse(sessionData);

//   // ---------------- UNREGISTERED ----------------
//   if (form.gstTreatment === "unregistered") {
//     setForm(prev => ({
//       ...prev,
//       gstin: prev.panNumber || "",
//     }));

//     setGstVerified(true); // no verification needed
//     setGstResponse(null);
//     return;
//   }

//   // ---------------- REGISTERED ----------------
//   if (form.gstTreatment === "registered") {
//     // ✅ If GST already verified in session → auto restore
//     if (user?.gst_verified === 1 && user?.gst_json) {
//       const gstData = JSON.parse(user.gst_json);

//       setGstVerified(true);
//       setGstResponse(gstData);

//       setForm(prev => ({
//         ...prev,
//         gstin: user.gst,
//         businessName: user.business_name,
//         tradeName: user.trade_name,
//         taxpayerType: gstData.taxpayer_type || "",
//       }));
//     } else {
//       // ❌ Only reset if NOT verified earlier
//       setGstVerified(false);
//       setGstResponse(null);

//       setForm(prev => ({
//         ...prev,
//         gstin: "",
//         businessName: "",
//         tradeName: "",
//         taxpayerType: "",
//       }));
//     }
//   }
// }, [form.gstTreatment]);




// const verifyGST = async () => {
//   if (!form.gstin) {
//     toast.error("Enter GSTIN and Business Name");
//     return;
//   }

//   try {
//     setGstLoading(true);

//     const res = await fetch(`${SWAGGER_URL}/Cashfree/gstin-verify`, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         AppId: APPID,
//         SecretKey: SecretKey,
//       },
//       body: JSON.stringify({
//         gstin: form.gstin,
//         name: form.businessName,
//       }),
//     });

//     const data = await res.json();

//     if (res.ok && data?.valid === true && data?.message === "GSTIN Exists") {
//       toast.success("GST Verified Successfully");

//       setGstVerified(true);
//       setGstResponse(data);

//       // 🔥 Auto-fill names from GST
//       setForm(prev => ({
//         ...prev,
//         gstin: data.GSTIN,
//         businessName: data.legal_name_of_business,
//         tradeName: data.trade_name_of_business || "",
//         taxpayerType: data.taxpayer_type || "",
//       }));
//     } else {
//       toast.error(data?.message || "GST Verification Failed");
//       setGstVerified(false);
//     }

//   } catch (err) {
//     toast.error("GST verification failed");
//   } finally {
//     setGstLoading(false);
//   }
// };

// const verifyBankAccount = async () => {
//   if (!form.accountNumber || !form.ifsc) {
//     toast.error("Enter account number and IFSC");
//     return;
//   }

//   try {
//     setBankLoading(true);

//     const res = await fetch(`${SWAGGER_URL}/Cashfree/bank-verify-v2`, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         AppId: APPID,
//         SecretKey: SecretKey,
//       },
//       body: JSON.stringify({
//         bank_account: form.accountNumber,
//         ifsc: form.ifsc,
//         name: form.businessName,
//         phone: form.phone,
//       }),
//     });

//     const data = await res.json();

//     if (res.ok && data.account_status_code === "ACCOUNT_IS_VALID") {
//       toast.success("Bank account verified successfully");

//       setBankVerified(true);
//       setBankResponse(data);

//       // 🔥 Autofill
//       setForm(prev => ({
//         ...prev,
//         bankName: data.bank_name || data.ifsc_details?.bank || "",
//         branchname: data.branch || data.ifsc_details?.branch || "",
//         ifsc: data.ifsc_details?.ifsc || prev.ifsc,
//       }));
//     } else {
//       toast.error("Enter valid account details");
//       setBankVerified(false);
//       setBankResponse(null);
//     }
//   } catch (err) {
//     toast.error("Bank verification failed");
//   } finally {
//     setBankLoading(false);
//   }
// };



// useEffect(() => {
//   if (form.gstTreatment === "unregistered" && form.panNumber) {
//     setForm(prev => ({
//       ...prev,
//       gstin: form.panNumber,
//     }));
//     setGstVerified(true); // no verification needed
//   }
// }, [form.gstTreatment, form.panNumber]);

// useEffect(() => {
//   const sessionData = localStorage.getItem("authUserData");
//   if (!sessionData) return;

//   const user = JSON.parse(sessionData);

//   if (user?.gst_verified === 1 && user?.gst_json) {
//     setGstVerified(true);
//     setGstResponse(JSON.parse(user.gst_json));

//     setForm(prev => ({
//       ...prev,
//       gstin: user.gst,
//       businessName: user.business_name,
//       tradeName: user.trade_name,
//     }));
//   }
// }, []);


//   useEffect(() => {
//   const sessionData = localStorage.getItem("authUserData");
//   if (!sessionData) return;

//   const user = JSON.parse(sessionData);

//   if (user?.bank_verified === 1 && user?.bank_json) {
//     const bankData = JSON.parse(user.bank_json);

//     setBankVerified(true);
//     setBankResponse(bankData);

//     setForm(prev => ({
//       ...prev,
//       accountNumber: user.account_no,
//       ifsc: user.ifsc_code,
//       bankName: user.bank_name,
//       branchname: user.branch_name,
//     }));
//   }
// }, []);



// useEffect(() => {
//   const sessionData = localStorage.getItem("authUserData");
//   if (sessionData) {
//     const user = JSON.parse(sessionData);

//     setForm(prev => ({
//       ...prev,
//       accountType: user.account_type || "",
//       accountNumber: user.account_no || "",
//       ifsc: user.ifsc_code || "",
//       branchname: user.branch_name || "",
//       bankName: user.bank_name || "",
//       authorisedName: user.business_name || "",
//       // Optional: you can pre-fill bankProofType if you store it
//     }));
//   }
// }, []);



//   const handleChange = (field, value) => {
//     if (field === "gstin" || field === "ifsc") value = value.toUpperCase();

//     // 🔥 Autofill logic: when business name is entered, set authorisedName same
//     if (field === "businessName") {
//       updateField("authorisedName", value);
//     }

//     updateField(field, value);
//     validateField(field, value);
//   };


//   // const handlePayment = () => {
//   //   if (!selectedPackage) return;

//   //   if (!paymentKeys.key_id) {
//   //     alert("Payment keys not loaded!");
//   //     return;
//   //   }

//   //   const options = {
//   //     key: paymentKeys.key_id,
//   //     key_secret: paymentKeys.key_secret, // Razorpay does NOT use this on frontend
//   //     amount: selectedPackage.amount * 100,
//   //     id:"order_LKsdf98asfa",
//   //     currency: "INR",
//   //     name: "GO Electronix",
//   //     description: selectedPackage.package_name,
//   //     handler: function (response) {
//   //       alert("Payment Successful 🎉");
//   //       console.log("Payment ID:", response.razorpay_payment_id);
//   //       console.log("Order ID:", response.razorpay_order_id);
//   //       console.log("Signature:", response.razorpay_signature);
//   //     },
//   //     prefill: {
//   //       name: authUser?.name || "",
//   //       email: authUser?.email || "",
//   //       contact: authUser?.mobile || "",
//   //     },
//   //     theme: { color: "#2563eb" },
//   //   };

//   //   const rzp = new window.Razorpay(options);
//   //   rzp.open();
//   // };

// const uiStep = isRetailer
//   ? currentStep
//   : currentStep > 1
//     ? currentStep - 1
//     : currentStep;

//   const displayStep = isRetailer ? currentStep : uiStep;

//   const notesData = {
//   role: authUser?.role,
//   type: "onboarding",
//   user_code: authUser?.company_code,
//   user_id: authUser?.id,
//   name: authUser?.business_name,
//   company_id: authUser?.company_id,
//   zoho_id: authUser?.zoho_id || null,
//   invoice_id: null,
// };

//   const handlePayment = () => {
//   if (!selectedPackage) return;

//   if (!paymentKeys.key_id) {
//     alert("Payment keys not loaded!");
//     return;
//   }

//   const options = {
//     key: paymentKeys.key_id,
//     amount: selectedPackage.amount * 100, 
//     currency: "INR",
//     name: "GO Electronix",
//     description: selectedPackage.package_name,
//     notes: notesData,

//     handler: async function (response) {
//   setPaymentCompleted(true);
//   setPaymentSaving(true); // 🔒 FULL PAGE LOCK

//   const payload = {
//     company_id: authUser?.company_id,
//     user_id: authUser?.id,
//     payment_id: response.razorpay_payment_id,
//     amount: selectedPackage.amount,
//     status: response,
//     payment_date: new Date().toISOString().slice(0, 19).replace("T", " "),
//     customer_id: zohoId || authUser?.zoho_id || authUser?.id,
//     payment_from: "WARRANTY",
//     notes: selectedPackage.package_name,
//     role: authUser?.role,
//   };

//   try {
//     const res = await fetch(`${BASE_URL}zoho/create-online-payment`, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify(payload),
//     });

//     const data = await res.json();

//     if (!res.ok) {
//       toast.error("Payment saved but server rejected callback!");
//       return;
//     }

//     toast.success("Payment Successful & Saved in Zoho 🎉");
//     setIsPaymentSuccess(true);
//   } catch (err) {
//     console.error(err);
//     toast.error("Payment succeeded but failed to update Zoho!");
//   } finally {
//     setPaymentSaving(false); // 🔓 UNLOCK PAGE
//   }
// },


//       prefill: {
//         name: authUser?.name || "",
//         email: authUser?.contact_email || "",
//         contact: authUser?.contact_phone || "",
//       },

//       theme: { color: "#2563eb" },
//     };

//     const rzp = new window.Razorpay(options);
//     rzp.open();
//   };


//   // const handlePaymentSuccess = async () => {
//   //   const payload = {
//   //     retailer_id: authUser?.id,
//   //     status: "payment_done",
//   //     package_id: selectedPackage.id,
//   //   };

//   //   await postStepUpdate(payload, "Payment Step");
//   // };

//   useEffect(() => {
//     if (currentStep === 2) fetchPackages();
//   }, [currentStep]);

//   const fetchPackages = async () => {
//     try {
//       setLoading(true);
//       const res = await fetch(`${BASE_URL}packages`);
//       const data = await res.json();
//       setPackages(data || []);
//     } catch (err) {
//       toast.error("Failed to load packages");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (
//       !loading &&
//       packages.length > 0 &&
//       authUser?.leads?.length > 0 &&
//       !selectedPackage  // <-- Prevent overwriting user selection
//     ) {
//       const assignedPackageId = authUser.leads[0].package_id;
//       const foundPackage = packages.find(p => p.id === assignedPackageId);

//       if (foundPackage) setSelectedPackage(foundPackage);
//     }
//   }, [loading, packages, authUser, selectedPackage]);

//   const handleUpload = async () => {
//   if (!form.bankProofFile || !form.bankProofType) {
//     toast.error("Please select file and type");
//     return;
//   }

//   try {
//     setUploading(true); // start loading

//     const formData = new FormData();
//     formData.append("flag", form.bankProofType);
//     formData.append("file", form.bankProofFile);
//     formData.append("email", form.email);

//     const res = await fetch(`${BASE_URL}user/upload-file`, {
//       method: "POST",
//       body: formData,
//     });

//     const data = await res.json();

//     if (data.status) {
//       toast.success("File uploaded successfully!");
//       setIsUploaded(true);
//     } else {
//       toast.error(data.message || "Upload failed");
//     }
//   } catch (error) {
//     console.error(error);
//     toast.error("Something went wrong.");
//   } finally {
//     setUploading(false); // stop loading
//   }
// };

//   const fetchAgreement = async () => {
//     try {
//       const response = await fetch(`${BASE_URL}agreement/${role}/${id}`, {
//         method: "GET",
//         headers: {
//           "Content-Type": "application/json",
//           // Authorization: `Bearer ${token}`,/ // include only if API needs it
//         },
//       });

//       const data = await response.json();

//       if (data?.status && data?.download_url) {
//         setAgreementUrl(data.download_url);
//       } else {
//         toast.error("Failed to fetch agreement.");
//       }
//     } catch (err) {
//       console.error(err);
//       toast.error("Server error while fetching agreement.");
//     }
//   };

//   useEffect(() => {
//     if (currentStep === 6 && !agreementUrl) {
//       fetchAgreement();
//     }
//   }, [currentStep]);

//   const handleAgreementCheck = (checked) => {
//     handleChange("agreed", checked);

//     if (checked && hasScrolledToBottom) {
//       updateField("esignVerified", 1);
//     } else {
//       updateField("esignVerified", 0);
//     }
//   };

//   useEffect(() => {
//     if (bankResponse?.name_at_bank && !form.name_at_bank) {
//       updateField("authorisedName", bankResponse.name_at_bank);
//     }
//   }, [bankResponse]);

//   const handleEsignClick = async () => {
//     const link = await verifyAadhaar();

//     if (link) {
//       window.open(
//         link,
//         "_blank",
//         "width=600,height=900,resizable=yes,scrollbars=yes"
//       );
//     }
//   };

//   if (pageLoading) {
//       return <FullPageLoader text="Loading your onboarding details..." />;
//     }

//   // ---------------- Render ----------------
//   return (
//     <>
//       {paymentSaving && (
//         <FullPageLoader text="Saving payment details, please wait…" />
//       )}
//       <div className="space-y-6">
//         {/* STEP 1 : EMAIL + PHONE VERIFICATION */}
//         {uiStep === 1 && (
//           <section className="space-y-8">
//             {/* ---------------- Store Address ---------------- */}
//             <div className="space-y-4">
//               <h2 className="text-lg font-semibold text-slate-900">Store Address</h2>
//               <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
//                 <InputField
//                   label="State"
//                   value={form.state}
//                   onChange={(value) => handleChange("state", value)}
//                   placeholder="Enter state"
//                 />
//                 <InputField
//                   label="District"
//                   value={form.district}
//                   onChange={(value) => handleChange("district", value)}
//                   placeholder="Enter district"
//                 />
//                 <InputField
//                   label="City"
//                   value={form.city}
//                   onChange={(value) => handleChange("city", value)}
//                   placeholder="Enter city"
//                 />
//                 <InputField
//                   label="Pincode"
//                   required
//                   value={form.pincode}
//                   onChange={(value) => handleChange("pincode", value)}
//                   placeholder="Enter pincode"
//                 />
//               </div>

//               <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                 <InputField
//                   label="Address Line 1"
//                   required
//                   value={form.address_line1}
//                   onChange={(value) => handleChange("address_line1", value)}
//                   placeholder="Shop / Building / Street"
//                 />
//                 <InputField
//                   label="Address Line 2"
//                   value={form.address_line2}
//                   onChange={(value) => handleChange("address_line2", value)}
//                   placeholder="Landmark (Optional)"
//                 />
//               </div>
//             </div>

//             {/* ---------------- Contact Verification ---------------- */}
//             <div className="space-y-4">
//               <h2 className="text-lg font-semibold text-slate-900">Verify Email & Phone</h2>

//               {/* EMAIL */}
//               <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-end">
//                 {emailVerified ? (
//                 <div className="col-span-4 md:col-span-1 flex flex-col gap-2 p-2 bg-green-50 border border-green-300 rounded-md">
//                     <p className="text-green-700 font-medium">
//                         ✔ Email Verified: <span className="font-semibold">{form.email}</span>
//                       </p>
//                     </div>
//                 ) : (
//                   <>
//                     <InputField
//                       label="Email"
//                       required
//                       value={form.email}
//                       onChange={(value) => handleEmailChange(value)}
//                       placeholder="Enter your email"
//                       error={errors.email}
//                     />

//                     {/* ⏳ UPDATED BUTTON WITH TIMER */}
//                     <button
//                       onClick={sendEmailOtp}
//                       disabled={sendingEmailOtp || resendEmailTimer > 0}
//                       className={`h-[42px] md:w-[120px] rounded-lg text-sm text-white flex items-center justify-center
//                         ${
//                           sendingEmailOtp || resendEmailTimer > 0
//                             ? "bg-gray-400 cursor-not-allowed"
//                             : "bg-blue-600 hover:bg-blue-700"
//                         }`}
//                     >
//                       {sendingEmailOtp ? (
//                         <span className="flex items-center gap-2">
//                           <svg className="w-4 h-4 animate-spin" viewBox="0 0 24 24">
//                             <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
//                             <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
//                           </svg>
//                           Sending…
//                         </span>
//                       ) : resendEmailTimer > 0 ? (
//                         `Resend in ${Math.floor(resendEmailTimer / 60)}:${String(resendEmailTimer % 60).padStart(2, "0")}`
//                       ) : emailOtpSent ? (
//                         "Resend OTP"
//                       ) : (
//                         "Send OTP"
//                       )}
//                     </button>


//                     {emailOtpSent && (
//                       <>
//                         <InputField
//                           label="Email OTP"
//                           value={emailOtp}
//                           onChange={(v) => setEmailOtp(v)}
//                           placeholder="Enter OTP"
//                         />
//                         <button
//                           onClick={verifyEmailOtp}
//                           disabled={verifyingEmailOtp}
//                           className={`h-[42px] md:w-[120px] rounded-lg text-sm text-white flex items-center justify-center
//                             ${
//                               verifyingEmailOtp
//                                 ? "bg-gray-400 cursor-not-allowed"
//                                 : "bg-green-600 hover:bg-green-700"
//                             }`}
//                         >
//                           {verifyingEmailOtp ? (
//                             <span className="flex items-center gap-2">
//                               <svg className="w-4 h-4 animate-spin" viewBox="0 0 24 24">
//                                 <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
//                                 <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
//                               </svg>
//                               Verifying…
//                             </span>
//                           ) : (
//                             "Verify"
//                           )}
//                         </button>

//                       </>
//                     )}
//                   </>
//                 )}

//               </div>
//               {/* {emailVerified && <p className="text-green-600 text-sm">✔ Email verified successfully</p>} */}

//               {/* PHONE */}
//               <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-end">
//                 {!phoneVerified && (
//                 <InputField
//                   label="Phone"
//                   required
//                   value={form.phone}
//                   onChange={(value) => handleChange("phone", value)}
//                   placeholder="Enter phone number"
//                   error={errors.phone}
//                 />
//                 )}
//                 {/* If phone already verified */}
//                 {phoneVerified ? (
//                   <div className="col-span-4 md:col-span-1 flex flex-col gap-2 p-2 bg-green-50 border border-green-300 rounded-md">
//                     <p className="text-green-700 font-medium">
//                       ✔ Phone verified successfully : <span className="font-semibold">{form.phone}</span>
//                     </p>
//                   </div>
//                 ) : (
//                   <>
//                     {!phoneVerified && (
//                       <button
//                         onClick={sendPhoneOtp}
//                         disabled={!emailVerified || resendTimer > 0 || sendingOtp}
//                         className={`h-[42px] md:w-[120px] rounded-lg text-sm text-white
//                           ${!emailVerified || resendTimer > 0 || sendingOtp ? "bg-gray-300 cursor-not-allowed" : "bg-blue-600"}`}
//                       >
//                         {sendingOtp
//                           ? "Sending..."
//                           : resendTimer > 0
//                           ? `Resend in ${Math.floor(resendTimer / 60)}:${String(resendTimer % 60).padStart(2, "0")}`
//                           : phoneOtpSent
//                           ? "Resend OTP"
//                           : "Send OTP"}
//                       </button>
//                     )}
//                     {phoneOtpSent && !phoneVerified && (
//                       <InputField
//                         label="Phone OTP"
//                         value={phoneOtp}
//                         onChange={(v) => {
//                           setPhoneOtp(v);
//                           localStorage.setItem("phoneOtp", v); // persist typed OTP
//                         }}
//                         placeholder="Enter OTP"
//                       />

//                     )}
//                     {phoneOtpSent && !phoneVerified && (
//                       <button
//                         onClick={verifyPhoneOtp}
//                         disabled={verifyingOtp}
//                         className={`h-[42px] md:w-[120px] rounded-lg text-sm text-white
//                           ${verifyingOtp ? "bg-gray-300 cursor-not-allowed" : "bg-green-600"}`}
//                       >
//                         {verifyingOtp ? "Verifying..." : "Verify"}
//                       </button>

//                     )}
//                   </>
//                 )}
//               </div>

//               {/* {phoneVerified && <p className="text-green-600 text-sm">✔ Phone verified successfully</p>} */}
//             </div>
//           </section>
//         )}

//         {/* STEP 2 - Payment */}
//         {isRetailer && uiStep === 2 && (
//           <section className="p-4">
//             <h2 className="text-lg font-semibold text-slate-900 mb-4 text-left">
//               Choose Your Package
//             </h2>

//             {loading || keyLoading ? (
//               <RegularLoader />
//             ) : (
//               <>
//                 {packages.length === 0 && (
//                   <p className="text-center text-red-600">No packages available.</p>
//                 )}

//                 {packages.length > 0 && (
//                   <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-3 max-h-[70vh] overflow-y-auto">

//                     {packages.map((pkg) => (
//                       <div
//                         key={pkg.id}
//                         onClick={() => setSelectedPackage(pkg)}
//                         className={`cursor-pointer border rounded-xl p-4 shadow-sm transition duration-200 
//                           ${
//                             selectedPackage?.id === pkg.id
//                               ? "border-blue-600 bg-blue-50"
//                               : "border-gray-300 hover:border-blue-400 hover:bg-blue-50"
//                           }
//                         `}
//                       >
                        
//                         {authUser?.leads?.[0]?.package_id === pkg.id && (
//                           <span className="text-[10px] ml-2 text-blue-600 font-semibold">(Assigned)</span>
//                         )}
//                         {/* Title */}
//                         <h4 className="text-lg font-semibold text-gray-800">
//                           {pkg.package_name}
//                           <span className="text-blue-700"> (₹{pkg.amount})</span>
//                         </h4>

//                         {/* Validity */}
//                         <p className="text-xs text-gray-500">Validity: {pkg.validity_days} Days</p>

//                         {/* Badge Section */}
//                         {pkg.badge && (
//                           <div className="mt-3 p-2 rounded-lg border border-gray-200">

//                             <span className="text-xs font-semibold bg-blue-200 text-blue-800 px-2 py-1 rounded">
//                               {pkg.badge.name}
//                             </span>

//                             <p className="text-xs text-gray-700 mt-2">
//                               {pkg.badge.description}
//                             </p>

//                             <div className="text-xs text-gray-700 mt-2 space-y-1">
//                               <p><span className="font-semibold">Eligibility:</span> {pkg.badge.eligibility} Users</p>
//                               <p><span className="font-semibold">Benefits:</span> {pkg.badge.benefits}% Extra</p>
//                             </div>

//                           </div>
//                         )}
//                       </div>
//                     ))}
//                   </div>
//                 )}

//                 {/* Payment Button Centered */}
//                 <div className="flex justify-center mt-6">
//                   <button
//                     disabled={!selectedPackage || paymentCompleted || paymentSaving}
//                     onClick={handlePayment}
//                     className={`px-6 py-2.5 rounded-lg text-sm font-medium transition
//                       ${
//                         !selectedPackage || paymentCompleted || paymentSaving
//                           ? "bg-slate-300 text-slate-500 cursor-not-allowed"
//                           : "bg-blue-600 text-white hover:bg-blue-700"
//                       }`}
//                   >
//                     {paymentSaving
//                       ? "Saving payment..."
//                       : paymentCompleted
//                       ? "Payment Completed ✔"
//                       : selectedPackage
//                       ? `Proceed to Pay ₹${selectedPackage.amount}`
//                       : "Select a Package to Continue"}
//                   </button>
//                 </div>
//               </>
//             )}
//           </section>
//         )}

//         {/* ------- The rest of your steps remain UNCHANGED ------- */}

//         {uiStep === (isRetailer ? 3 : 2) && (
//           <section>
//             <h2 className="text-lg font-semibold text-slate-900 mb-4">
//               Authorized Person PAN Verification
//             </h2>

//             <div className="grid gap-4 md:grid-cols-2">
//               <InputField
//                 label="PAN Number"
//                 value={form.panNumber}
//                 disabled={form.panVerified} // ✅ disable if already verified
//                 readOnly={form.panVerified}
//                 className={`${form.panVerified ? "bg-gray-100 text-gray-500 cursor-not-allowed" : ""}`}
//                 onChange={(val) => !form.panVerified && updateField("panNumber", val.toUpperCase())}
//                 onBlur={() => validateField("panNumber", form.panNumber)}
//                 placeholder="ABCDE1234F"
//                 error={errors.panNumber}
//               />

//               <div className="flex items-end">
//                 <button
//                   onClick={verifyPAN}
//                   disabled={
//                     form.panVerified || // ✅ already verified
//                     !form.panNumber ||
//                     !isValidPAN(form.panNumber) ||
//                     loading
//                   }
//                   className={`px-4 py-2 rounded-lg transition text-white w-full md:w-auto
//                     ${form.panVerified ? "bg-green-600 cursor-default" : "bg-blue-600 hover:bg-blue-700 disabled:bg-gray-400"}
//                   `}
//                 >
//                   {form.panVerified ? "Verified ✓" : loading ? "Verifying..." : "Verify PAN"}
//                 </button>
//               </div>
//             </div>

//             {/* PAN verification message */}
//             {panMessage && (
//               <p className={`text-xs mt-2 font-medium ${form.panVerified ? "text-green-600" : "text-red-500"}`}>
//                 {panMessage}
//               </p>
//             )}

//             {/* Show verified PAN details if available */}
//             {form.panVerified && panApiResponse && (
//               <div className="mt-6 border rounded-lg p-4 bg-green-50">
//                 <h3 className="text-md font-semibold text-green-700 mb-3">
//                   PAN Details Verified ✓
//                 </h3>

//                 <div className="grid md:grid-cols-2 gap-3 text-sm">
//                   <p><strong>PAN:</strong> {panApiResponse.pan}</p>
//                   <p><strong>Name:</strong> {panApiResponse.name_pan_card}</p>
//                   <p><strong>Gender:</strong> {panApiResponse.gender}</p>
//                   <p><strong>DOB:</strong> {panApiResponse.date_of_birth}</p>
//                   <p><strong>Mobile:</strong> {panApiResponse.mobile_number}</p>
//                   <p><strong>Email:</strong> {panApiResponse.email}</p>
//                   <p><strong>Aadhaar Linked:</strong> {panApiResponse.aadhaar_linked ? "Yes" : "No"}</p>
//                   <p><strong>City:</strong> {panApiResponse.address?.city}</p>
//                   <p><strong>State:</strong> {panApiResponse.address?.state}</p>
//                   <p><strong>Pincode:</strong> {panApiResponse.address?.pincode}</p>
//                   <p><strong>Type:</strong> {panApiResponse.type}</p>
//                 </div>

//                 <p className="mt-2 text-xs text-gray-600">
//                   <strong>Full Address:</strong> {panApiResponse.address?.full_address}
//                 </p>
//               </div>
//             )}
//           </section>
//         )}

//         {uiStep === (isRetailer ? 4 : 3) && (
//           <section>
//             <h2 className="text-lg font-semibold text-slate-900 mb-4">GST details</h2>
//             <div className="grid gap-4 md:grid-cols-2">
//               <SelectField
//                 label="GST Type"
//                 required
//                 value={form.gstTreatment}
//                 onChange={(value) => handleChange("gstTreatment", value)}
//                 options={[
//                   { value: "registered", label: "Registered" },
//                   { value: "unregistered", label: "Unregistered" },
//                 ]}
//                 error={errors.gstTreatment}
//               />


//               <InputField
//                 label={form.gstTreatment === "unregistered" ? "PAN Number" : "GSTIN"}
//                 required
//                 value={form.gstin}
//                 readOnly={form.gstTreatment === "unregistered"}
//                 onChange={(value) => handleChange("gstin", value)}
//                 placeholder={
//                   form.gstTreatment === "unregistered"
//                     ? "PAN auto-filled"
//                     : "22AAAAA0000A1Z5"
//                 }
//               />


//             </div>

//             {gstVerified && gstResponse && (
//               <div className="mt-4 grid gap-4 md:grid-cols-3">
//                 <InputField
//                   label="Business Legal Name"
//                   value={form.businessName}
//                   readOnly
//                 />

//                 <InputField
//                   label="Trade Name"
//                   value={form.tradeName}
//                   readOnly
//                 />

//                 <InputField
//                   label="Taxpayer Type"
//                   value={form.taxpayerType}
//                   readOnly
//                 />
//               </div>
//             )}


//             {form.gstTreatment === "registered" && (
//               <button
//                 type="button"
//                 onClick={verifyGST}
//                 disabled={gstVerified || gstLoading}
//                 className={`mt-2 px-4 py-2 rounded-lg text-sm text-white
//                   ${gstVerified ? "bg-green-600" : "bg-blue-600 hover:bg-blue-700"}
//                 `}
//               >
//                 {gstVerified ? "Verified ✓" : gstLoading ? "Verifying..." : "Verify GST"}
//               </button>
//             )}


//             {gstVerified && gstResponse && (
//               <div className="mt-4 border rounded-lg p-4 bg-green-50 text-sm">
//                 <h3 className="font-semibold text-green-700 mb-2">
//                   GST Details Verified ✓
//                 </h3>

//                 <div className="grid md:grid-cols-2 gap-2">
//                   <p><strong>GSTIN:</strong> {gstResponse.GSTIN}</p>
//                   <p><strong>Status:</strong> {gstResponse.gst_in_status}</p>
//                   <p><strong>Taxpayer Type:</strong> {gstResponse.taxpayer_type}</p>
//                   <p><strong>Legal Name:</strong> {gstResponse.legal_name_of_business}</p>
//                   <p><strong>Trade Name:</strong> {gstResponse.trade_name_of_business}</p>
//                   <p><strong>Registration Date:</strong> {gstResponse.date_of_registration}</p>
//                   <p><strong>State Jurisdiction:</strong> {gstResponse.state_jurisdiction}</p>
//                   <p><strong>Center Jurisdiction:</strong> {gstResponse.center_jurisdiction}</p>
//                 </div>

//                 {/* Address */}
//                 <div className="mt-3">
//                   <p className="font-semibold">Principal Place of Business</p>
//                   <p className="text-gray-700">
//                     {gstResponse.principal_place_address}
//                   </p>
//                 </div>

//                 {/* Nature of Business */}
//                 {Array.isArray(gstResponse.nature_of_business_activities) && (
//                   <div className="mt-3">
//                     <p className="font-semibold">Nature of Business</p>
//                     <ul className="list-disc ml-5 text-gray-700">
//                       {gstResponse.nature_of_business_activities.map((item, idx) => (
//                         <li key={idx}>{item}</li>
//                       ))}
//                     </ul>
//                   </div>
//                 )}
//               </div>
//             )}
//           </section>
//         )}

//         {uiStep === (isRetailer ? 5 : 4) && (
//           <section>
//             <h2 className="text-lg font-semibold text-slate-900 mb-4">
//               Bank account details
//             </h2>

//             <div className="grid gap-4 md:grid-cols-3">
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">
//                   Account Type
//                 </label>
//                 <select
//                   className="border rounded-lg p-2 w-full"
//                   value={form.accountType}
//                   onChange={(e) => handleChange("accountType", e.target.value)}
//                   // disabled={!!form.accountType} // optional read-only if already present
//                 >
//                   <option value="">Select Account Type</option>
//                   <option value="current">Current</option>
//                   <option value="saving">Saving</option>
//                 </select>
//               </div>

//               <InputField
//                 label="Account Number"
//                 required
//                 value={form.accountNumber}
//                 onChange={(value) => handleChange("accountNumber", value)}
//                 placeholder="Enter account number"
//                 error={errors.accountNumber}
//                 readOnly={bankVerified} // optional
//               />

//               <InputField
//                 label="IFSC Code"
//                 required
//                 value={form.ifsc}
//                 onChange={(value) => handleChange("ifsc", value)}
//                 placeholder="e.g. HDFC0001234"
//                 error={errors.ifsc}
//                 readOnly={bankVerified} // optional
//               />
//             </div>

//             {bankVerified && bankResponse && (
//               <div className="grid gap-4 md:grid-cols-3 mt-4">
//                 <InputField
//                   label="Branch Name"
//                   value={form.branchname}
//                   readOnly
//                 />

//                 <InputField
//                   label="Bank Name"
//                   value={form.bankName}
//                   readOnly
//                 />

//                 <InputField
//                   label="Authorized Person Name"
//                   value={form.authorisedName}
//                   readOnly
//                 />
//               </div>
//             )}
            
//             {/* <div className="grid gap-4 md:grid-cols-2 mt-6">
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">
//                   Upload Proof (Select One)
//                 </label>
//                 <select
//                   className="border rounded-lg p-2 w-full"
//                   value={form.bankProofType}
//                   onChange={(e) => handleChange("bankProofType", e.target.value)}
//                 >
//                   <option value="">Select Document Type</option>
//                   <option value="passbook">Passbook Photo</option>
//                   <option value="cheque">Cancelled Cheque</option>
//                 </select>
//               </div>

//               {form.bankProofType && (
//                 <div className="p-4 border border-gray-300 rounded-lg">
//                   <p className="text-sm text-gray-600 mb-3">
//                     Upload:{" "}
//                     <span className="font-semibold">
//                       {form.bankProofType === "passbook" ? "Passbook Photo" : "Cancelled Cheque"}
//                     </span>
//                   </p>

//                   <div className="flex items-center gap-3 mt-2">
//                     <input
//                       type="file"
//                       accept="image/*,application/pdf"
//                       onChange={(e) => handleChange("bankProofFile", e.target.files[0])}
//                       className="w-full text-sm"
//                     />
//                     <BlueButton
//                       onClick={handleUpload}
//                       disabled={
//                         !form.bankProofFile ||
//                         !form.bankProofType ||
//                         uploading ||
//                         isUploaded   // ⬅️ disabled after success
//                       }
//                     >
//                       {isUploaded ? "Uploaded" : uploading ? "Uploading..." : "Upload"}
//                     </BlueButton>


//                   </div>

//                   {form.bankProofFile && (
//                     <p className="text-green-600 text-sm mt-2">
//                       File selected: {form.bankProofFile.name}
//                     </p>
//                   )}
//                 </div>
//               )}

//             </div> */}

//             <button
//               type="button"
//               onClick={verifyBankAccount}
//               disabled={bankVerified || bankLoading}
//               className={`mt-5 px-4 py-2 rounded-lg text-sm text-white
//                 ${bankVerified ? "bg-green-600" : "bg-blue-600 hover:bg-blue-700"}
//               `}
//             >
//               {bankVerified ? "Verified ✓" : bankLoading ? "Verifying..." : "Verify Account"}
//             </button>

//             {bankVerified && bankResponse && (
//               <div className="mt-4 border rounded-lg p-4 bg-green-50 text-sm">
//                 <h3 className="font-semibold text-green-700 mb-2">
//                   Bank Account Verified ✓
//                 </h3>

//                 <div className="grid md:grid-cols-2 gap-2">
//                   <p><strong>Account Status:</strong> {bankResponse.account_status}</p>
//                   <p><strong>Bank Name:</strong> {bankResponse.bank_name}</p>
//                   <p><strong>Branch:</strong> {bankResponse.branch}</p>
//                   <p><strong>City:</strong> {bankResponse.city}</p>
//                   <p><strong>IFSC:</strong> {bankResponse.ifsc_details?.ifsc}</p>
//                   <p><strong>MICR:</strong> {bankResponse.micr}</p>
//                   <p><strong>UTR:</strong> {bankResponse.utr}</p>
//                   <p><strong>Name at Bank:</strong> {bankResponse.name_at_bank}</p>
//                 </div>
//               </div>
//             )}

//           </section>
//         )}

//         {uiStep === (isRetailer ? 6 : 5) && (
//           <section>
//             <h2 className="text-lg font-semibold text-slate-900 mb-4">
//               Sign User Agreement
//             </h2>

//             {agreementUrl ? (
//               <div className="flex justify-center min-h-screen bg-white">
//                 <div className="bg-slate-50 border p-2 rounded-xl text-xs text-slate-600 flex flex-col gap-3 max-w-[800px] w-full items-center shadow-md">
//                   <div
//                     ref={scrollRef}
//                     onScroll={handleScroll}
//                     className="border rounded-xl bg-white shadow-inner p-2 w-full h-[700px] overflow-y-auto"
//                   >
//                     <iframe
//                       src={`https://docs.google.com/viewer?url=${agreementUrl}&embedded=true`}
//                       title="Agreement PDF"
//                       className="w-full h-[1400px]"
//                     />
//                   </div>

//                   <a
//                     href={agreementUrl}
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="text-blue-600 underline font-medium text-sm"
//                   >
//                     Download Agreement PDF
//                   </a>
//                 </div>
//               </div>
//             ) : (
//               <RegularLoader />
//             )}

//             {/* Agreement Checkbox */}
//             <label className="mt-4 flex items-start gap-2">
//               <input
//                 type="checkbox"
//                 className="mt-1 w-4 h-4"
//                 checked={form.agreed}
//                 disabled={!hasScrolledToBottom}
//                 onChange={(e) => handleAgreementCheck(e.target.checked)}
//               />
//               <span
//                 className={`text-sm ${
//                   !hasScrolledToBottom ? "text-gray-400" : "text-slate-700"
//                 }`}
//               >
//                 I agree to the user agreement.
//               </span>
//             </label>

//             {!hasScrolledToBottom && (
//               <p className="text-xs text-red-500 mt-1">
//                 Scroll to the bottom to enable agreement.
//               </p>
//             )}
//           </section>
//         )}

//         {/* {currentStep === 7 && (
//             <section className="flex justify-center">
//               <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white/80 shadow-sm backdrop-blur p-6 flex flex-col items-center gap-5">

                
//                 {!form.aadhaarVerified && (
//                   <>
                    
//                     <div className="flex items-center gap-3 w-full">
//                       <div className="shrink-0 rounded-xl p-3 bg-gradient-to-br from-sky-500/10 to-indigo-500/10">
//                         <img
//                           src={esign}
//                           alt="Aadhaar e-Sign"
//                           className="w-10 h-10 object-contain"
//                         />
//                       </div>
//                       <div className="flex-1">
//                         <h2 className="text-base md:text-lg font-semibold text-slate-900">
//                           Aadhaar e-Sign Verification
//                         </h2>
//                         <p className="text-xs text-slate-500">
//                           Enter the last 4 digits of your Aadhaar. We’ll open a secure e-Sign window.
//                         </p>
//                       </div>
//                     </div>

                  
//                     <div className="mt-2 flex justify-center w-full">
//                       <div className="flex gap-2">
//                         {Array.from({ length: 4 }).map((_, idx) => (
//                           <input
//                             key={idx}
//                             ref={(el) => (aadhaarInputsRef.current[idx] = el)}
//                             inputMode="numeric"
//                             pattern="[0-9]*"
//                             type="text"
//                             maxLength={1}
//                             value={form?.aadhaarLast4?.[idx] || ""}
//                             onChange={(e) => handleAadhaarBoxChange(idx, e.target.value)}
//                             onKeyDown={(e) => handleAadhaarKeyDown(idx, e)}
//                             disabled={form.aadhaarVerified}
//                             className="w-12 h-12 text-center text-lg font-semibold rounded-xl border border-slate-300 bg-white focus:outline-none focus:ring-2 focus:ring-sky-400 disabled:bg-slate-100"
//                           />
//                         ))}
//                       </div>
//                     </div>
//                   </>
//                 )}

                
//                 <div className="min-h-[18px] text-center text-xs">
//                   {aadhaarError ? (
//                     <span className="text-red-600">{aadhaarError}</span>
//                   ) : form.aadhaarVerified || aadhaarStatus === "success" ? (
//                     <>
//                   <div className="w-full max-w-md rounded-2xl shadow-sm p-6 flex flex-col items-center gap-5">
//                       <img
//                         src={verifiedimg} // make sure this points to your verified.avif file
//                         alt="e-Sign Verified"
//                         className="w-40 h-40 object-contain bg-transparent"
//                       />

//                     </div>


//                     <span className="text-green-600">Verified ✅ e-Sign completed</span>
//                     </>
                    
//                   ) : aadhaarStatus === "verifying" ? (
//                     <span className="text-slate-500">
//                       Waiting for you to complete e-Sign in the popup...
//                     </span>
//                   ) : (
//                     <span className="text-slate-500">
//                       We’ll redirect you to a secure UIDAI-compliant e-Sign partner.
//                     </span>
//                   )}
//                 </div>

              
//                 {!form.aadhaarVerified && (
//                   <button
//                     type="button"
//                     onClick={verifyAadhaar}
//                     disabled={
//                       !aadhaarValid ||
//                       form.aadhaarVerified ||
//                       aadhaarStatus === "loading" ||
//                       aadhaarStatus === "verifying"
//                     }
//                     className="w-full max-w-xs rounded-xl py-2.5 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 disabled:bg-slate-400"
//                   >
//                     {form.aadhaarVerified ? "e-Sign Verified" : "Verify & Open e-Sign"}
//                   </button>
//                 )}

//                 {!form.aadhaarVerified && (
//                 <p className="text-[11px] text-center text-slate-500">
//                   By continuing, you consent to Aadhaar-based e-Sign for this agreement.
//                 </p>
//                 )}
//               </div>
//             </section>
//           )} */}

//         {displayStep === 7 && (
//           <section className="flex justify-center">
//             <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white/80 shadow-sm backdrop-blur p-6 flex flex-col items-center gap-5">

//               {/* Only show header & input boxes if NOT verified */}
//               {!form.aadhaarVerified && (
//                 <>
//                   {/* Header */}
//                   <div className="flex items-center gap-3 w-full">
//                     <div className="shrink-0 rounded-xl p-3 bg-gradient-to-br from-sky-500/10 to-indigo-500/10">
//                       <img
//                         src={esign}
//                         alt="Aadhaar e-Sign"
//                         className="w-10 h-10 object-contain"
//                       />
//                     </div>
//                     <div className="flex-1">
//                       <h2 className="text-base md:text-lg font-semibold text-slate-900">
//                         Aadhaar e-Sign Verification
//                       </h2>
//                       <p className="text-xs text-slate-500">
//                         Enter the last 4 digits of your Aadhaar. We’ll open a secure e-Sign window.
//                       </p>
//                     </div>
//                   </div>

//                   {/* 4 Input Boxes */}
//                   <div className="mt-2 flex justify-center w-full">
//                     <div className="flex gap-2">
//                       {Array.from({ length: 4 }).map((_, idx) => (
//                         <input
//                           key={idx}
//                           ref={(el) => (aadhaarInputsRef.current[idx] = el)}
//                           inputMode="numeric"
//                           pattern="[0-9]*"
//                           type="text"
//                           maxLength={1}
//                           value={form?.aadhaarLast4?.[idx] || ""}
//                           onChange={(e) => handleAadhaarBoxChange(idx, e.target.value)}
//                           onKeyDown={(e) => handleAadhaarKeyDown(idx, e)}
//                           disabled={form.aadhaarVerified}
//                           className="w-12 h-12 text-center text-lg font-semibold rounded-xl border border-slate-300 bg-white focus:outline-none focus:ring-2 focus:ring-sky-400 disabled:bg-slate-100"
//                         />
//                       ))}
//                     </div>
//                   </div>
//                 </>
//               )}

//               {/* Helper / Error / Success */}
//               <div className="min-h-[18px] text-center text-xs">

//                 {/* 🔵 Loader for get-esign-status */}
//                 {esignStatusLoading && (
//                   <div className="flex justify-center items-center gap-2 text-blue-600 py-2">
//                     <svg className="w-4 h-4 animate-spin" viewBox="0 0 24 24">
//                       <circle
//                         className="opacity-25"
//                         cx="12"
//                         cy="12"
//                         r="10"
//                         stroke="currentColor"
//                         strokeWidth="4"
//                       ></circle>
//                       <path
//                         className="opacity-75"
//                         fill="currentColor"
//                         d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
//                       ></path>
//                     </svg>
//                     Checking e-Sign status...
//                   </div>
//                 )}

//                 {/* 🔻 Hide all other messages when loader is running */}
//                 {!esignStatusLoading && (
//                   <>
//                     {aadhaarError ? (
//                       <span className="text-red-600">{aadhaarError}</span>
//                     ) : form.aadhaarVerified || aadhaarStatus === "success" ? (
//                       <>
//                         <div className="w-full max-w-md rounded-2xl shadow-sm p-6 flex flex-col items-center gap-5">
//                           <img
//                             src={verifiedimg}
//                             alt="e-Sign Verified"
//                             className="w-40 h-40 object-contain bg-transparent"
//                           />
//                         </div>
//                         <span className="text-green-600">
//                           Verified ✅ e-Sign completed
//                         </span>
//                       </>
//                     ) : aadhaarStatus === "verifying" ? (
//                       <span className="text-slate-500">
//                         Waiting for you to complete e-Sign in the popup...
//                       </span>
//                     ) : (
//                       <span className="text-slate-500">
//                         We’ll redirect you to a secure UIDAI-compliant e-Sign partner.
//                       </span>
//                     )}
//                   </>
//                 )}
//               </div>

//               {/* Button */}
//               {!form.aadhaarVerified && (
//                 <button
//                   type="button"
//                   onClick={verifyAadhaar}
//                   disabled={
//                     !aadhaarValid ||
//                     aadhaarStatus === "loading" ||
//                     aadhaarStatus === "verifying" ||
//                     esignStatusLoading
//                   }
//                   className="w-full max-w-xs rounded-xl py-2.5 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 disabled:bg-slate-400"
//                 >
//                   {esignStatusLoading
//                     ? "Checking Status..."
//                     : form.aadhaarVerified
//                     ? "e-Sign Verified"
//                     : "Verify & Open e-Sign"}
//                 </button>
//               )}

//               {/* Small note */}
//               {!form.aadhaarVerified && (
//                 <p className="text-[11px] text-center text-slate-500">
//                   By continuing, you consent to Aadhaar-based e-Sign for this agreement.
//                 </p>
//               )}
//             </div>
//           </section>
//         )}
//       </div>
//     </>
//   );
// }


// import { useEffect, useRef, useState } from "react";
// import InputField from "./InputField";
// import SelectField from "./SelectField";
// import toast from "react-hot-toast";
// import RegularLoader from "../Loader/RegularLoader";
// import BlueButton from "../Common/BlueButton";
// import { APPID, BASE_URL, SecretKey, SWAGGER_URL } from "../../config/api";
// import esign from "../../asset/images/esign.webp";
// import verifiedimg from "../../asset/images/verified.avif";
// import FullPageLoader from "../Common/FullPageLoader";

// export default function FormBody({ currentStep, form, updateField, selectedPackage, setSelectedPackage,panApiResponse, setPanApiResponse, verifyAadhaar, aadhaarStatus, setAadhaarStatus, setForm, esignStatusLoading, setIsPaymentSuccess, gstVerified,
//   setGstVerified, gstResponse, setGstResponse,bankVerified, setBankVerified, bankResponse, setBankResponse,zohoId, setZohoId }) {
//   const isUnregistered = form.gstTreatment === "unregistered";

//   const [errors, setErrors] = useState({});
//   const [emailOtpSent, setEmailOtpSent] = useState(false);
//   const [emailVerified, setEmailVerified] = useState(false);
//   const [phoneOtpSent, setPhoneOtpSent] = useState(false);
//   const [phoneVerified, setPhoneVerified] = useState(false);
//   const [emailOtp, setEmailOtp] = useState("");
//   const [phoneOtp, setPhoneOtp] = useState("");
//   const [packages, setPackages] = useState([]);
//   // const [selectedPackage, setSelectedPackage] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const authUser = JSON.parse(localStorage.getItem("authUserData") || "{}");
//   const id = authUser?.id;
//   const role = authUser?.role;
//   const [agreementUrl, setAgreementUrl] = useState(null);
//   const [hasScrolledToBottom, setHasScrolledToBottom] = useState(false);
//   const [panMessage, setPanMessage] = useState("");
//   // const [aadhaarStatus, setAadhaarStatus] = useState("idle"); // idle | loading | verifying | success | error
//   const [aadhaarError, setAadhaarError] = useState("");
//   const esignPopupRef = useRef(null);
//   const esignPollRef = useRef(null);
//   const aadhaarInputsRef = useRef([]);

//   const [isUploaded, setIsUploaded] = useState(false);

//   const [resendEmailTimer, setResendEmailTimer] = useState(0);

//   const [sendingOtp, setSendingOtp] = useState(false);
//   const [resendTimer, setResendTimer] = useState(0); // seconds
//   const [verifyingOtp, setVerifyingOtp] = useState(false);
//   const [uploading, setUploading] = useState(false);

//   const [paymentKeys, setPaymentKeys] = useState({
//     key_id: "",
//     key_secret: ""
//   });
//   const [keyLoading, setKeyLoading] = useState(false);
//   const [paymentCompleted, setPaymentCompleted] = useState(false);
//   const [gstLoading, setGstLoading] = useState(false);
//   const [bankLoading, setBankLoading] = useState(false);
//   const [paymentSaving, setPaymentSaving] = useState(false);
//   const isRetailer = role === 5;




//   const fetchPaymentKeys = async () => {
//   try {
//     setKeyLoading(true);

//     const res = await fetch(`${BASE_URL}payment/keys`);
//     const data = await res.json();

//     if (Array.isArray(data) && data.length > 0) {
//       setPaymentKeys({
//         key_id: data[0].key_id,
//         key_secret: data[0].key_secret
//       });
//     } else {
//       console.error("Invalid keys response", data);
//     }
//   } catch (err) {
//     console.error("Failed to fetch payment keys", err);
//   } finally {
//     setKeyLoading(false);
//   }
// };


//   useEffect(() => {
//   if (currentStep === 2) {
//     fetchPaymentKeys();
//   }
// }, [currentStep]);




//    const handleAadhaarBoxChange = (idx, value) => {
//     const digit = value.replace(/\D/g, "").slice(0, 1);

//     const chars = (form.aadhaarLast4 || "").split("");
//     while (chars.length < 4) chars.push("");
//     chars[idx] = digit;

//     const joined = chars.join("");
//     updateField("aadhaarLast4", joined);

//     if (digit && aadhaarInputsRef.current[idx + 1]) {
//       aadhaarInputsRef.current[idx + 1].focus();
//     }
//   };

//   const handleAadhaarKeyDown = (idx, e) => {
//     if (e.key === "Backspace" && !form.aadhaarLast4?.[idx]) {
//       if (aadhaarInputsRef.current[idx - 1]) {
//         aadhaarInputsRef.current[idx - 1].focus();
//       }
//     }
//     if (e.key === "ArrowLeft" && aadhaarInputsRef.current[idx - 1]) {
//       aadhaarInputsRef.current[idx - 1].focus();
//     }
//     if (e.key === "ArrowRight" && aadhaarInputsRef.current[idx + 1]) {
//       aadhaarInputsRef.current[idx + 1].focus();
//     }
//   };

//   const aadhaarValid =
//     form.aadhaarLast4 &&
//     form.aadhaarLast4.length === 4 &&
//     /^\d{4}$/.test(form.aadhaarLast4);

//   // NOTE: update verifyAadhaar() to accept last4 and return eSign URL (Promise<string>)
//   // const handleEsignClick = async () => {
//   //   if (!aadhaarValid) {
//   //     toast.error("Enter valid last 4 digits of Aadhaar");
//   //     return;
//   //   }

//   //   setAadhaarError("");
//   //   setAadhaarStatus("loading");

//   //   try {
//   //     // 👇 You must update verifyAadhaar to:
//   //     // async function verifyAadhaar(last4) { ... return esignUrl }
//   //     const esignUrl = await verifyAadhaar(form.aadhaarLast4);

//   //     if (!esignUrl) {
//   //       throw new Error("Invalid e-Sign link from server");
//   //     }

//   //     setAadhaarStatus("verifying");
//   //     openEsignPopup(esignUrl);
//   //   } catch (err) {
//   //     console.error(err);
//   //     setAadhaarStatus("error");
//   //     setAadhaarError(err?.message || "Failed to start e-Sign");
//   //     toast.error("Unable to start e-Sign");
//   //   }
//   // };

//   const cleanupEsignPopup = () => {
//     if (esignPollRef.current) {
//       clearInterval(esignPollRef.current);
//       esignPollRef.current = null;
//     }
//     if (esignPopupRef.current && !esignPopupRef.current.closed) {
//       try {
//         esignPopupRef.current.close();
//       } catch (e) {
//         console.error(e);
//       }
//     }
//     esignPopupRef.current = null;
//   };

//   const openEsignPopup = (url) => {
//     const w = 460;
//     const h = 640;
//     const dualScreenLeft =
//       window.screenLeft !== undefined ? window.screenLeft : window.screenX;
//     const dualScreenTop =
//       window.screenTop !== undefined ? window.screenTop : window.screenY;
//     const width =
//       window.innerWidth ||
//       document.documentElement.clientWidth ||
//       window.screen.width;
//     const height =
//       window.innerHeight ||
//       document.documentElement.clientHeight ||
//       window.screen.height;

//     const left = width / 2 - w / 2 + dualScreenLeft;
//     const top = height / 2 - h / 2 + dualScreenTop;

//     const features = `scrollbars=yes,resizable=yes,width=${w},height=${h},top=${top},left=${left}`;
//     esignPopupRef.current = window.open(url, "esignPopup", features);

//     // Fallback polling – if popup closed manually
//     esignPollRef.current = setInterval(() => {
//       if (!esignPopupRef.current || esignPopupRef.current.closed) {
//         clearInterval(esignPollRef.current);
//         esignPollRef.current = null;
//         esignPopupRef.current = null;

//         // Only reset state if we were waiting
//         if (aadhaarStatus === "verifying") {
//           setAadhaarStatus("idle");
//         }
//       } else {
//         // OPTIONAL: if your success page is same-origin and has /esign-success in URL
//         try {
//           const href = esignPopupRef.current.location.href || "";
//           if (href.includes("esign-success")) {
//             cleanupEsignPopup();
//             setAadhaarStatus("success");
//             updateField("aadhaarVerified", true);
//             toast.success("e-Sign verified successfully");
//           }
//         } catch {
//           // Cross-origin during provider flow – ignore
//         }
//       }
//     }, 800);
//   };

//   // Listen for postMessage from success page
//   useEffect(() => {
//     const handler = (e) => {
//       // In production, replace "*" with your exact origin and check e.origin
//       if (e?.data?.type === "ESIGN_SUCCESS") {
//         cleanupEsignPopup();
//         setAadhaarStatus("success");
//         updateField("aadhaarVerified", true);
//         toast.success("e-Sign verified successfully");
//       }
//       if (e?.data?.type === "ESIGN_CANCELLED") {
//         cleanupEsignPopup();
//         setAadhaarStatus("idle");
//         toast.error("e-Sign cancelled");
//       }
//     };

//     window.addEventListener("message", handler);
//     return () => window.removeEventListener("message", handler);
//   }, []);

//   const scrollRef = useRef(null);

//   const handleScroll = () => {
//     const el = scrollRef.current;
//     if (!el) return;

//     if (el.scrollTop + el.clientHeight >= el.scrollHeight - 5) {
//       setHasScrolledToBottom(true);
//     }
//   };

//   // Prefill form fields from localStorage on mount
//   useEffect(() => {
//     const storedUser = localStorage.getItem("authUserData");
//     if (storedUser) {
//       try {
//         const user = JSON.parse(storedUser);

//         updateField("address_line1", user.address_line1 || "");
//         updateField("address_line2", user.address_line2 || "");
//         updateField("state", user.state || "");
//         updateField("district", user.district || "");
//         updateField("city", user.city || "");
//         updateField("pincode", user.pincode || "");
//         updateField("email", user.contact_email || "");
//         updateField("phone", user.contact_phone || "");
//       } catch (err) {
//         console.error("Invalid session user data", err);
//       }
//     }
//   }, []);

//   // ---------------- Email + Phone OTP Logic ----------------
//   const sendEmailOtp = async () => {
//   const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

//   if (!form.email || !emailRegex.test(form.email)) {
//     setErrors(prev => ({ ...prev, email: "Enter a valid email address" }));
//     toast.error("Invalid email format");
//     return;
//   }

//   const storedUser = localStorage.getItem("authUserData");
//   const user = storedUser ? JSON.parse(storedUser) : null;
//   const userId = user?.id;

//   if (!userId) {
//     toast.error("User session not found");
//     return;
//   }

//   try {
//     const response = await fetch(`${BASE_URL}send-welcome-email/${userId}`, {
//       method: "GET",
//       cache: "no-store",
//     });

//     const result = await response.json();
//     console.log("API Response:", result);

//     if (result?.status) {
//       setEmailOtpSent(true);
//       localStorage.setItem("emailOtpSent", "true");

//       // ⏱️ Start 5 min timer for resend
//       const endTime = Date.now() + 5 * 60 * 1000;
//       localStorage.setItem("resendEmailOtpEndTime", endTime);
//       setResendEmailTimer(5 * 60); // seconds

//       toast.success("Email OTP sent successfully!");
//     } else {
//       toast.error("Failed to send email OTP");
//     }
//   } catch (error) {
//     console.error(error);
//     toast.error("Something went wrong. Try again!");
//   }
// };

//   useEffect(() => {
//     const storedEndTime = localStorage.getItem("resendEmailOtpEndTime");
//     if (storedEndTime) {
//       const remaining = Math.floor((storedEndTime - Date.now()) / 1000);
//       if (remaining > 0) setResendEmailTimer(remaining);
//       else localStorage.removeItem("resendEmailOtpEndTime");
//     }
//   }, []);

//   useEffect(() => {
//     if (resendEmailTimer <= 0) return;

//     const interval = setInterval(() => {
//       setResendEmailTimer(prev => {
//         if (prev <= 1) {
//           clearInterval(interval);
//           localStorage.removeItem("resendEmailOtpEndTime");
//           return 0;
//         }
//         return prev - 1;
//       });
//     }, 1000);

//     return () => clearInterval(interval);
//   }, [resendEmailTimer]);


//  const verifyEmailOtp = async () => {
//   try {
//     const authUser = JSON.parse(localStorage.getItem("authUserData") || "{}");

//     const role = Number(authUser.role);
//     const userId = authUser.id;

//     const companyId =
//       role === 2 ? 1 : authUser.company_id || authUser.id;

//     const res = await fetch(`${BASE_URL}verify-email-otp`, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({
//         email: form.email,
//         otp: emailOtp,
//         user_id: userId,
//         company_id: companyId,
//       }),
//     });

//     const data = await res.json();

//     if (data?.status) {
//       setEmailVerified(true);

//       // ✅ SAVE ZOHO ID
//       if (data.zoho_id) {
//         setZohoId(data.zoho_id);
        
//         // 🔥 persist in session for refresh safety
//         const updatedUser = {
//           ...authUser,
//           zoho_id: data.zoho_id,
//         };
//         localStorage.setItem("authUserData", JSON.stringify(updatedUser));
//       }

//       localStorage.setItem("emailVerified", "true");
//       localStorage.setItem("verifiedEmail", form.email);

//       toast.success("Email Verified Successfully");
//     } else {
//       toast.error(data?.message || "Invalid OTP");
//     }
//   } catch (err) {
//     console.error(err);
//     toast.error("Something went wrong!");
//   }
// };



//   useEffect(() => {
//     const savedEmailOtpSent = localStorage.getItem("emailOtpSent");
//     const savedEmailVerified = localStorage.getItem("emailVerified");
//     const savedEmail = localStorage.getItem("verifiedEmail");

//     if (savedEmailOtpSent === "true") setEmailOtpSent(true);
//     if (savedEmailVerified === "true") setEmailVerified(true);

//     if (savedEmail) {
//       setForm(prev => ({ ...prev, email: savedEmail }));
//     }
//   }, []);
  
//   // Automatically mark email as verified if user logged in with verified email
//   useEffect(() => {
//     const storedUser = localStorage.getItem("authUserData");
//     if (storedUser) {
//       try {
//         const user = JSON.parse(storedUser);

//         if (user.is_mail_verified === 1) {
//           setEmailVerified(true);
//           localStorage.setItem("emailVerified", "true");
//           localStorage.setItem("verifiedEmail", user.contact_email || "");
//           setForm(prev => ({
//             ...prev,
//             email: user.contact_email || "",
//           }));
//         }
//       } catch (err) {
//         console.error("Error parsing authUserData", err);
//       }
//     }
//   }, []);

//   const handleEmailChange = (value) => {
//     handleChange("email", value);

//     // Reset stored status if email changes
//     localStorage.removeItem("emailOtpSent");
//     localStorage.removeItem("emailVerified");
//     localStorage.removeItem("verifiedEmail");

//     setEmailOtpSent(false);
//     setEmailVerified(false);
//     setEmailOtp("");
//   };

//   const sendPhoneOtp = async () => {
//   if (!form.phone) return;

//   try {
//     setSendingOtp(true);

//     const response = await fetch(`${BASE_URL}send-wa-otp`, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ contact_phone: form.phone, company_id: authUser.id }),
//     });
//     const result = await response.json();

//     if (response.ok) {
//       setPhoneOtpSent(true);
//       localStorage.setItem("phoneOtpSent", "true");
//       toast.success("Phone OTP sent successfully!");

//       // Start 10 min timer
//       const endTime = Date.now() + 5 * 60 * 1000;
//       localStorage.setItem("resendOtpEndTime", endTime);
//       setResendTimer(5 * 60); // in seconds
//     } else {
//       toast.error(result.message || "Failed to send OTP");
//     }
//   } catch (error) {
//     toast.error("Failed to send OTP");
//   } finally {
//     setSendingOtp(false);
//   }
// };

//   useEffect(() => {
//   const storedEndTime = localStorage.getItem("resendOtpEndTime");
//   if (storedEndTime) {
//     const remaining = Math.floor((storedEndTime - Date.now()) / 1000);
//     if (remaining > 0) setResendTimer(remaining);
//     else localStorage.removeItem("resendOtpEndTime");
//   }
// }, []);

//   useEffect(() => {
//     if (resendTimer <= 0) return;

//     const interval = setInterval(() => {
//       setResendTimer(prev => {
//         if (prev <= 1) {
//           clearInterval(interval);
//           localStorage.removeItem("resendOtpEndTime");
//           return 0;
//         }
//         return prev - 1;
//       });
//     }, 1000);

//     return () => clearInterval(interval);
//   }, [resendTimer]);

//   const verifyPhoneOtp = async () => {
//     if (!phoneOtp) {
//       toast.error("Enter OTP");
//       return;
//     }

//     try {
//       setVerifyingOtp(true);

//       const response = await fetch(`${BASE_URL}verify-wa-otp`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ contact_phone: form.phone, otp: phoneOtp }),
//       });
//       const result = await response.json();

//       if (!response.ok) throw new Error(result.message);

//       setPhoneVerified(true);
//       localStorage.setItem("phoneVerified", "true");
//       localStorage.removeItem("phoneOtp");
//       localStorage.removeItem("phoneOtpSent");

//       toast.success("Phone Verified Successfully!");
//     } catch (error) {
//       toast.error(error.message || "Invalid OTP");
//     } finally {
//       setVerifyingOtp(false);
//     }
//   };

//   useEffect(() => {
//     const storedPhoneSent = localStorage.getItem("phoneOtpSent");
//     const storedPhoneVerified = localStorage.getItem("phoneVerified");
//     const storedPhoneOtp = localStorage.getItem("phoneOtp");

//     if (storedPhoneSent === "true") setPhoneOtpSent(true);
//     if (storedPhoneVerified === "true") setPhoneVerified(true);
//     if (storedPhoneOtp) setPhoneOtp(storedPhoneOtp);
//   }, []);

//   // Automatically mark phone as verified if user logged in with verified phone
//   useEffect(() => {
//     const storedUser = localStorage.getItem("authUserData");
//     if (storedUser) {
//       try {
//         const user = JSON.parse(storedUser);

//         if (user.is_wa_verified === 1) {
//           setPhoneVerified(true);
//           localStorage.setItem("phoneVerified", "true");
//           localStorage.setItem("verifiedPhone", user.contact_phone || "");
//           setForm(prev => ({
//             ...prev,
//             phone: user.contact_phone || "",
//           }));
//         }
//       } catch (err) {
//         console.error("Error parsing authUserData", err);
//       }
//     }
//   }, []);

//   // ---------------- Validation ----------------
//   const validateField = (field, value, isUnregistered = false) => {
//   let error = "";

//   switch (field) {
//     case "email":
//       if (!value) error = "Email is required";
//       else {
//         const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//         if (!emailRegex.test(value)) error = "Invalid email format";
//       }
//       break;

//     case "phone":
//       if (!value) error = "Phone is required";
//       else {
//         const phoneRegex = /^[6-9][0-9]{9}$/;
//         if (!phoneRegex.test(value)) error = "Invalid phone number format";
//       }
//       break;

//     case "panNumber": 
//       if (!value) error = "Enter PAN Number";
//       else {
//         const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
//         if (!panRegex.test(value)) error = "Invalid PAN format (e.g. ABCDE1234F)";
//       }
//       break;

//     case "gstTreatment":
//       if (!value) error = "Select GST treatment";
//       break;

//     case "gstin":
//       if (!value) {
//         error = isUnregistered ? "Enter PAN number" : "Enter GSTIN / UIN";
//       } else {
//         if (isUnregistered) {
//           const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
//           if (!panRegex.test(value)) error = "Invalid PAN format";
//         } else {
//           const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/;
//           if (!gstRegex.test(value)) error = "Invalid GSTIN format";
//         }
//       }
//       break;

//     case "businessName":
//       if (!value) error = "Enter legal business name";
//       break;

//     case "accountNumber":
//       if (!value) error = "Enter account number";
//       break;

//     case "ifsc":
//       if (!value) error = "Enter IFSC code";
//       // else {
//       //   const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
//       //   if (!ifscRegex.test(value)) error = "Invalid IFSC format";
//       // }
//       break;

//     case "bankName":
//       if (!value) error = "Enter bank name";
//       break;

//     case "authorisedName":
//       if (!value) error = "Authorised person is required";
//       break;

//     case "agreed":
//       if (!value) error = "You must accept the agreement to continue";
//       break;

//     default:
//       break;
//   }

//   setErrors((prev) => ({ ...prev, [field]: error }));
//   return error === "";
// };

// // ---------------- PAN VALIDATION FUNCTION ----------------
// const isValidPAN = (pan) => {
//   const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
//   return panRegex.test(pan);
// };

//   useEffect(() => {
//     const sessionData = localStorage.getItem("authUserData");
//     if (!sessionData) return;

//     const user = JSON.parse(sessionData);

//     if (Number(user?.pan_verified) === 1) {
//       const panFromSession =
//         user?.pan_number ||
//         user?.pan ||
//         (user?.pan_json ? JSON.parse(user.pan_json)?.pan : "");

//       setForm(prev => ({
//         ...prev,
//         panNumber: panFromSession,
//         panVerified: true,
//       }));

//       if (user?.pan_json) {
//         setPanApiResponse(JSON.parse(user.pan_json));
//       }
//     }
//   }, []);


// // ---------------- PAN VERIFY API CALL ----------------
//   const verifyPAN = async () => {
//     if (!form.panNumber) return;
//     if (!isValidPAN(form.panNumber)) {
//       validateField("panNumber", form.panNumber);
//       return;
//     }

//     try {
//       setLoading(true);

//       const payload = {
//         pan: form.panNumber,
//         verification_id: authUser?.company_code,
//         name: authUser?.contact_person,
//       };

//       const response = await fetch(`${SWAGGER_URL}/Cashfree/pan-advance`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           AppId: APPID,
//           SecretKey: SecretKey,
//         },
//         body: JSON.stringify(payload),
//       });

//       const data = await response.json();

//       if (response.ok && data?.status === "VALID") {

//         updateField("panVerified", true);

//         // 🔥 store full response in parent onboarding
//         setPanApiResponse(data);

//         toast.success(data?.message || "PAN Verified Successfully!");
//       } else {
//         toast.error(data?.message || "Verification Failed.");
//       }
//     } catch (error) {
//       toast.error("Something went wrong.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//   const sessionData = localStorage.getItem("authUserData");
//   if (sessionData) {
//     const user = JSON.parse(sessionData);

//     // Pre-fill GST / Business details
//     setForm(prev => ({
//       ...prev,
//       gstTreatment: user.business_type || "",       // regular, composition, unregistered
//       gstin: user.gst || user.pan || "",         // GSTIN or PAN if unregistered
//       businessName: user.business_name || "",
//       tradeName: user.trade_name || "",
//     }));
//   }
// }, []);

// useEffect(() => {
//   const sessionData = localStorage.getItem("authUserData");
//   if (!sessionData) return;

//   const user = JSON.parse(sessionData);

//   // ---------------- UNREGISTERED ----------------
//   if (form.gstTreatment === "unregistered") {
//     setForm(prev => ({
//       ...prev,
//       gstin: prev.panNumber || "",
//     }));

//     setGstVerified(true); // no verification needed
//     setGstResponse(null);
//     return;
//   }

//   // ---------------- REGISTERED ----------------
//   if (form.gstTreatment === "registered") {
//     // ✅ If GST already verified in session → auto restore
//     if (user?.gst_verified === 1 && user?.gst_json) {
//       const gstData = JSON.parse(user.gst_json);

//       setGstVerified(true);
//       setGstResponse(gstData);

//       setForm(prev => ({
//         ...prev,
//         gstin: user.gst,
//         businessName: user.business_name,
//         tradeName: user.trade_name,
//         taxpayerType: gstData.taxpayer_type || "",
//       }));
//     } else {
//       // ❌ Only reset if NOT verified earlier
//       setGstVerified(false);
//       setGstResponse(null);

//       setForm(prev => ({
//         ...prev,
//         gstin: "",
//         businessName: "",
//         tradeName: "",
//         taxpayerType: "",
//       }));
//     }
//   }
// }, [form.gstTreatment]);




// const verifyGST = async () => {
//   if (!form.gstin) {
//     toast.error("Enter GSTIN and Business Name");
//     return;
//   }

//   try {
//     setGstLoading(true);

//     const res = await fetch(`${SWAGGER_URL}/Cashfree/gstin-verify`, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         AppId: APPID,
//         SecretKey: SecretKey,
//       },
//       body: JSON.stringify({
//         gstin: form.gstin,
//         name: form.businessName,
//       }),
//     });

//     const data = await res.json();

//     if (res.ok && data?.valid === true && data?.message === "GSTIN Exists") {
//       toast.success("GST Verified Successfully");

//       setGstVerified(true);
//       setGstResponse(data);

//       // 🔥 Auto-fill names from GST
//       setForm(prev => ({
//         ...prev,
//         gstin: data.GSTIN,
//         businessName: data.legal_name_of_business,
//         tradeName: data.trade_name_of_business || "",
//         taxpayerType: data.taxpayer_type || "",
//       }));
//     } else {
//       toast.error(data?.message || "GST Verification Failed");
//       setGstVerified(false);
//     }

//   } catch (err) {
//     toast.error("GST verification failed");
//   } finally {
//     setGstLoading(false);
//   }
// };

// const verifyBankAccount = async () => {
//   if (!form.accountNumber || !form.ifsc) {
//     toast.error("Enter account number and IFSC");
//     return;
//   }

//   try {
//     setBankLoading(true);

//     const res = await fetch(`${SWAGGER_URL}/Cashfree/bank-verify-v2`, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         AppId: APPID,
//         SecretKey: SecretKey,
//       },
//       body: JSON.stringify({
//         bank_account: form.accountNumber,
//         ifsc: form.ifsc,
//         name: form.businessName,
//         phone: form.phone,
//       }),
//     });

//     const data = await res.json();

//     if (res.ok && data.account_status_code === "ACCOUNT_IS_VALID") {
//       toast.success("Bank account verified successfully");

//       setBankVerified(true);
//       setBankResponse(data);

//       // 🔥 Autofill
//       setForm(prev => ({
//         ...prev,
//         bankName: data.bank_name || data.ifsc_details?.bank || "",
//         branchname: data.branch || data.ifsc_details?.branch || "",
//         ifsc: data.ifsc_details?.ifsc || prev.ifsc,
//       }));
//     } else {
//       toast.error("Enter valid account details");
//       setBankVerified(false);
//       setBankResponse(null);
//     }
//   } catch (err) {
//     toast.error("Bank verification failed");
//   } finally {
//     setBankLoading(false);
//   }
// };



// useEffect(() => {
//   if (form.gstTreatment === "unregistered" && form.panNumber) {
//     setForm(prev => ({
//       ...prev,
//       gstin: form.panNumber,
//     }));
//     setGstVerified(true); // no verification needed
//   }
// }, [form.gstTreatment, form.panNumber]);

// useEffect(() => {
//   const sessionData = localStorage.getItem("authUserData");
//   if (!sessionData) return;

//   const user = JSON.parse(sessionData);

//   if (user?.gst_verified === 1 && user?.gst_json) {
//     setGstVerified(true);
//     setGstResponse(JSON.parse(user.gst_json));

//     setForm(prev => ({
//       ...prev,
//       gstin: user.gst,
//       businessName: user.business_name,
//       tradeName: user.trade_name,
//     }));
//   }
// }, []);


//   useEffect(() => {
//   const sessionData = localStorage.getItem("authUserData");
//   if (!sessionData) return;

//   const user = JSON.parse(sessionData);

//   if (user?.bank_verified === 1 && user?.bank_json) {
//     const bankData = JSON.parse(user.bank_json);

//     setBankVerified(true);
//     setBankResponse(bankData);

//     setForm(prev => ({
//       ...prev,
//       accountNumber: user.account_no,
//       ifsc: user.ifsc_code,
//       bankName: user.bank_name,
//       branchname: user.branch_name,
//     }));
//   }
// }, []);



// useEffect(() => {
//   const sessionData = localStorage.getItem("authUserData");
//   if (sessionData) {
//     const user = JSON.parse(sessionData);

//     setForm(prev => ({
//       ...prev,
//       accountType: user.account_type || "",
//       accountNumber: user.account_no || "",
//       ifsc: user.ifsc_code || "",
//       branchname: user.branch_name || "",
//       bankName: user.bank_name || "",
//       authorisedName: user.business_name || "",
//       // Optional: you can pre-fill bankProofType if you store it
//     }));
//   }
// }, []);



//   const handleChange = (field, value) => {
//     if (field === "gstin" || field === "ifsc") value = value.toUpperCase();

//     // 🔥 Autofill logic: when business name is entered, set authorisedName same
//     if (field === "businessName") {
//       updateField("authorisedName", value);
//     }

//     updateField(field, value);
//     validateField(field, value);
//   };


//   // const handlePayment = () => {
//   //   if (!selectedPackage) return;

//   //   if (!paymentKeys.key_id) {
//   //     alert("Payment keys not loaded!");
//   //     return;
//   //   }

//   //   const options = {
//   //     key: paymentKeys.key_id,
//   //     key_secret: paymentKeys.key_secret, // Razorpay does NOT use this on frontend
//   //     amount: selectedPackage.amount * 100,
//   //     id:"order_LKsdf98asfa",
//   //     currency: "INR",
//   //     name: "GO Electronix",
//   //     description: selectedPackage.package_name,
//   //     handler: function (response) {
//   //       alert("Payment Successful 🎉");
//   //       console.log("Payment ID:", response.razorpay_payment_id);
//   //       console.log("Order ID:", response.razorpay_order_id);
//   //       console.log("Signature:", response.razorpay_signature);
//   //     },
//   //     prefill: {
//   //       name: authUser?.name || "",
//   //       email: authUser?.email || "",
//   //       contact: authUser?.mobile || "",
//   //     },
//   //     theme: { color: "#2563eb" },
//   //   };

//   //   const rzp = new window.Razorpay(options);
//   //   rzp.open();
//   // };

//   const uiStep =
//   role === 2 || role === 4
//     ? currentStep > 2
//       ? currentStep - 1
//       : currentStep
//     : currentStep;


//   const displayStep = isRetailer ? currentStep : uiStep;

//   const notesData = {
//   role: authUser?.role,
//   type: "onboarding",
//   user_code: authUser?.company_code,
//   user_id: authUser?.id,
//   name: authUser?.business_name,
//   company_id: authUser?.company_id,
//   zoho_id: authUser?.zoho_id || null,
//   invoice_id: null,
// };

//   const handlePayment = () => {
//   if (!selectedPackage) return;

//   if (!paymentKeys.key_id) {
//     alert("Payment keys not loaded!");
//     return;
//   }

//   const options = {
//     key: paymentKeys.key_id,
//     amount: selectedPackage.amount * 100, 
//     currency: "INR",
//     name: "GO Electronix",
//     description: selectedPackage.package_name,
//     notes: notesData,

//     handler: async function (response) {
//   setPaymentCompleted(true);
//   setPaymentSaving(true); // 🔒 FULL PAGE LOCK

//   const payload = {
//     company_id: authUser?.company_id,
//     user_id: authUser?.id,
//     payment_id: response.razorpay_payment_id,
//     amount: selectedPackage.amount,
//     status: response,
//     payment_date: new Date().toISOString().slice(0, 19).replace("T", " "),
//     customer_id: zohoId || authUser?.zoho_id || authUser?.id,
//     payment_from: "WARRANTY",
//     notes: selectedPackage.package_name,
//     role: authUser?.role,
//   };

//   try {
//     const res = await fetch(`${BASE_URL}zoho/create-online-payment`, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify(payload),
//     });

//     const data = await res.json();

//     if (!res.ok) {
//       toast.error("Payment saved but server rejected callback!");
//       return;
//     }

//     toast.success("Payment Successful & Saved in Zoho 🎉");
//     setIsPaymentSuccess(true);
//   } catch (err) {
//     console.error(err);
//     toast.error("Payment succeeded but failed to update Zoho!");
//   } finally {
//     setPaymentSaving(false); // 🔓 UNLOCK PAGE
//   }
// },


//       prefill: {
//         name: authUser?.name || "",
//         email: authUser?.contact_email || "",
//         contact: authUser?.contact_phone || "",
//       },

//       theme: { color: "#2563eb" },
//     };

//     const rzp = new window.Razorpay(options);
//     rzp.open();
//   };


//   // const handlePaymentSuccess = async () => {
//   //   const payload = {
//   //     retailer_id: authUser?.id,
//   //     status: "payment_done",
//   //     package_id: selectedPackage.id,
//   //   };

//   //   await postStepUpdate(payload, "Payment Step");
//   // };

//   useEffect(() => {
//     if (currentStep === 2) fetchPackages();
//   }, [currentStep]);

//   const fetchPackages = async () => {
//     try {
//       setLoading(true);
//       const res = await fetch(`${BASE_URL}packages`);
//       const data = await res.json();
//       setPackages(data || []);
//     } catch (err) {
//       toast.error("Failed to load packages");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (
//       !loading &&
//       packages.length > 0 &&
//       authUser?.leads?.length > 0 &&
//       !selectedPackage  // <-- Prevent overwriting user selection
//     ) {
//       const assignedPackageId = authUser.leads[0].package_id;
//       const foundPackage = packages.find(p => p.id === assignedPackageId);

//       if (foundPackage) setSelectedPackage(foundPackage);
//     }
//   }, [loading, packages, authUser, selectedPackage]);

//   const handleUpload = async () => {
//   if (!form.bankProofFile || !form.bankProofType) {
//     toast.error("Please select file and type");
//     return;
//   }

//   try {
//     setUploading(true); // start loading

//     const formData = new FormData();
//     formData.append("flag", form.bankProofType);
//     formData.append("file", form.bankProofFile);
//     formData.append("email", form.email);

//     const res = await fetch(`${BASE_URL}user/upload-file`, {
//       method: "POST",
//       body: formData,
//     });

//     const data = await res.json();

//     if (data.status) {
//       toast.success("File uploaded successfully!");
//       setIsUploaded(true);
//     } else {
//       toast.error(data.message || "Upload failed");
//     }
//   } catch (error) {
//     console.error(error);
//     toast.error("Something went wrong.");
//   } finally {
//     setUploading(false); // stop loading
//   }
// };

//   const fetchAgreement = async () => {
//     try {
//       const response = await fetch(`${BASE_URL}agreement/${role}/${id}`, {
//         method: "GET",
//         headers: {
//           "Content-Type": "application/json",
//           // Authorization: `Bearer ${token}`,/ // include only if API needs it
//         },
//       });

//       const data = await response.json();

//       if (data?.status && data?.download_url) {
//         setAgreementUrl(data.download_url);
//       } else {
//         toast.error("Failed to fetch agreement.");
//       }
//     } catch (err) {
//       console.error(err);
//       toast.error("Server error while fetching agreement.");
//     }
//   };

//   useEffect(() => {
//     if (currentStep === 6 && !agreementUrl) {
//       fetchAgreement();
//     }
//   }, [currentStep]);

//   const handleAgreementCheck = (checked) => {
//     handleChange("agreed", checked);

//     if (checked && hasScrolledToBottom) {
//       updateField("esignVerified", 1);
//     } else {
//       updateField("esignVerified", 0);
//     }
//   };

//   useEffect(() => {
//     if (bankResponse?.name_at_bank && !form.authorisedName) {
//       updateField("authorisedName", bankResponse.name_at_bank);
//     }
//   }, [bankResponse]);

//   const handleEsignClick = async () => {
//     const link = await verifyAadhaar();

//     if (link) {
//       window.open(
//         link,
//         "_blank",
//         "width=600,height=900,resizable=yes,scrollbars=yes"
//       );
//     }
//   };

  

//   // ---------------- Render ----------------
//   return (
//     <>
//       {paymentSaving && (
//         <FullPageLoader text="Saving payment details, please wait…" />
//       )}
//       <div className="space-y-6">
//         {/* STEP 1 : EMAIL + PHONE VERIFICATION */}
//         {uiStep === 1 && (
//           <section className="space-y-8">
//             {/* ---------------- Store Address ---------------- */}
//             <div className="space-y-4">
//               <h2 className="text-lg font-semibold text-slate-900">Store Address</h2>
//               <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
//                 <InputField
//                   label="State"
//                   value={form.state}
//                   onChange={(value) => handleChange("state", value)}
//                   placeholder="Enter state"
//                 />
//                 <InputField
//                   label="District"
//                   value={form.district}
//                   onChange={(value) => handleChange("district", value)}
//                   placeholder="Enter district"
//                 />
//                 <InputField
//                   label="City"
//                   value={form.city}
//                   onChange={(value) => handleChange("city", value)}
//                   placeholder="Enter city"
//                 />
//                 <InputField
//                   label="Pincode"
//                   required
//                   value={form.pincode}
//                   onChange={(value) => handleChange("pincode", value)}
//                   placeholder="Enter pincode"
//                 />
//               </div>

//               <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                 <InputField
//                   label="Address Line 1"
//                   required
//                   value={form.address_line1}
//                   onChange={(value) => handleChange("address_line1", value)}
//                   placeholder="Shop / Building / Street"
//                 />
//                 <InputField
//                   label="Address Line 2"
//                   value={form.address_line2}
//                   onChange={(value) => handleChange("address_line2", value)}
//                   placeholder="Landmark (Optional)"
//                 />
//               </div>
//             </div>

//             {/* ---------------- Contact Verification ---------------- */}
//             <div className="space-y-4">
//               <h2 className="text-lg font-semibold text-slate-900">Verify Email & Phone</h2>

//               {/* EMAIL */}
//               <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-end">
//                 {emailVerified ? (
//                 <div className="col-span-4 md:col-span-1 flex flex-col gap-2 p-2 bg-green-50 border border-green-300 rounded-md">
//                     <p className="text-green-700 font-medium">
//                         ✔ Email Verified: <span className="font-semibold">{form.email}</span>
//                       </p>
//                     </div>
//                 ) : (
//                   <>
//                     <InputField
//                       label="Email"
//                       required
//                       value={form.email}
//                       onChange={(value) => handleEmailChange(value)}
//                       placeholder="Enter your email"
//                       error={errors.email}
//                     />

//                     {/* ⏳ UPDATED BUTTON WITH TIMER */}
//                     <button
//                       onClick={sendEmailOtp}
//                       disabled={resendEmailTimer > 0}
//                       className={`h-[42px] md:w-[120px] rounded-lg text-sm text-white transition
//                       ${resendEmailTimer > 0 ? "bg-gray-400 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700"}`}
//                     >
//                       {resendEmailTimer > 0
//                         ? `Resend in ${Math.floor(resendEmailTimer / 60)}:${String(resendEmailTimer % 60).padStart(2, "0")}`
//                         : emailOtpSent
//                         ? "Resend OTP"
//                         : "Send OTP"}
//                     </button>

//                     {emailOtpSent && (
//                       <>
//                         <InputField
//                           label="Email OTP"
//                           value={emailOtp}
//                           onChange={(v) => setEmailOtp(v)}
//                           placeholder="Enter OTP"
//                         />
//                         <button
//                           onClick={verifyEmailOtp}
//                           className="h-[42px] md:w-[120px] bg-green-600 text-white rounded-lg text-sm"
//                         >
//                           Verify
//                         </button>
//                       </>
//                     )}
//                   </>
//                 )}

//               </div>
//               {/* {emailVerified && <p className="text-green-600 text-sm">✔ Email verified successfully</p>} */}

//               {/* PHONE */}
//               <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-end">
//                 {!phoneVerified && (
//                 <InputField
//                   label="Phone"
//                   required
//                   value={form.phone}
//                   onChange={(value) => handleChange("phone", value)}
//                   placeholder="Enter phone number"
//                   error={errors.phone}
//                 />
//                 )}
//                 {/* If phone already verified */}
//                 {phoneVerified ? (
//                   <div className="col-span-4 md:col-span-1 flex flex-col gap-2 p-2 bg-green-50 border border-green-300 rounded-md">
//                     <p className="text-green-700 font-medium">
//                       ✔ Phone verified successfully : <span className="font-semibold">{form.phone}</span>
//                     </p>
//                   </div>
//                 ) : (
//                   <>
//                     {!phoneVerified && (
//                       <button
//                         onClick={sendPhoneOtp}
//                         disabled={!emailVerified || resendTimer > 0 || sendingOtp}
//                         className={`h-[42px] md:w-[120px] rounded-lg text-sm text-white
//                           ${!emailVerified || resendTimer > 0 || sendingOtp ? "bg-gray-300 cursor-not-allowed" : "bg-blue-600"}`}
//                       >
//                         {sendingOtp
//                           ? "Sending..."
//                           : resendTimer > 0
//                           ? `Resend in ${Math.floor(resendTimer / 60)}:${String(resendTimer % 60).padStart(2, "0")}`
//                           : phoneOtpSent
//                           ? "Resend OTP"
//                           : "Send OTP"}
//                       </button>
//                     )}
//                     {phoneOtpSent && !phoneVerified && (
//                       <InputField
//                         label="Phone OTP"
//                         value={phoneOtp}
//                         onChange={(v) => {
//                           setPhoneOtp(v);
//                           localStorage.setItem("phoneOtp", v); // persist typed OTP
//                         }}
//                         placeholder="Enter OTP"
//                       />

//                     )}
//                     {phoneOtpSent && !phoneVerified && (
//                       <button
//                         onClick={verifyPhoneOtp}
//                         disabled={verifyingOtp}
//                         className={`h-[42px] md:w-[120px] rounded-lg text-sm text-white
//                           ${verifyingOtp ? "bg-gray-300 cursor-not-allowed" : "bg-green-600"}`}
//                       >
//                         {verifyingOtp ? "Verifying..." : "Verify"}
//                       </button>

//                     )}
//                   </>
//                 )}
//               </div>

//               {/* {phoneVerified && <p className="text-green-600 text-sm">✔ Phone verified successfully</p>} */}
//             </div>
//           </section>
//         )}

//         {/* STEP 2 - Payment */}
//         {isRetailer && uiStep === 2 && (
//           <section className="p-4">
//             <h2 className="text-lg font-semibold text-slate-900 mb-4 text-left">
//               Choose Your Package
//             </h2>

//             {loading || keyLoading ? (
//               <RegularLoader />
//             ) : (
//               <>
//                 {packages.length === 0 && (
//                   <p className="text-center text-red-600">No packages available.</p>
//                 )}

//                 {packages.length > 0 && (
//                   <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-3 max-h-[70vh] overflow-y-auto">

//                     {packages.map((pkg) => (
//                       <div
//                         key={pkg.id}
//                         onClick={() => setSelectedPackage(pkg)}
//                         className={`cursor-pointer border rounded-xl p-4 shadow-sm transition duration-200 
//                           ${
//                             selectedPackage?.id === pkg.id
//                               ? "border-blue-600 bg-blue-50"
//                               : "border-gray-300 hover:border-blue-400 hover:bg-blue-50"
//                           }
//                         `}
//                       >
                        
//                         {authUser?.leads?.[0]?.package_id === pkg.id && (
//                           <span className="text-[10px] ml-2 text-blue-600 font-semibold">(Assigned)</span>
//                         )}
//                         {/* Title */}
//                         <h4 className="text-lg font-semibold text-gray-800">
//                           {pkg.package_name}
//                           <span className="text-blue-700"> (₹{pkg.amount})</span>
//                         </h4>

//                         {/* Validity */}
//                         <p className="text-xs text-gray-500">Validity: {pkg.validity_days} Days</p>

//                         {/* Badge Section */}
//                         {pkg.badge && (
//                           <div className="mt-3 p-2 rounded-lg border border-gray-200">

//                             <span className="text-xs font-semibold bg-blue-200 text-blue-800 px-2 py-1 rounded">
//                               {pkg.badge.name}
//                             </span>

//                             <p className="text-xs text-gray-700 mt-2">
//                               {pkg.badge.description}
//                             </p>

//                             <div className="text-xs text-gray-700 mt-2 space-y-1">
//                               <p><span className="font-semibold">Eligibility:</span> {pkg.badge.eligibility} Users</p>
//                               <p><span className="font-semibold">Benefits:</span> {pkg.badge.benefits}% Extra</p>
//                             </div>

//                           </div>
//                         )}
//                       </div>
//                     ))}
//                   </div>
//                 )}

//                 {/* Payment Button Centered */}
//                 <div className="flex justify-center mt-6">
//                   <button
//                     disabled={!selectedPackage || paymentCompleted || paymentSaving}
//                     onClick={handlePayment}
//                     className={`px-6 py-2.5 rounded-lg text-sm font-medium transition
//                       ${
//                         !selectedPackage || paymentCompleted || paymentSaving
//                           ? "bg-slate-300 text-slate-500 cursor-not-allowed"
//                           : "bg-blue-600 text-white hover:bg-blue-700"
//                       }`}
//                   >
//                     {paymentSaving
//                       ? "Saving payment..."
//                       : paymentCompleted
//                       ? "Payment Completed ✔"
//                       : selectedPackage
//                       ? `Proceed to Pay ₹${selectedPackage.amount}`
//                       : "Select a Package to Continue"}
//                   </button>
//                 </div>
//               </>
//             )}
//           </section>
//         )}

//         {!isRetailer && uiStep === 2 && (
//           <section className="p-4">
//             <h2 className="text-lg font-semibold text-slate-900 mb-4 text-left">
//               Choose Your Package
//             </h2>

//             {loading || keyLoading ? (
//               <RegularLoader />
//             ) : (
//               <>
//                 {packages.length === 0 && (
//                   <p className="text-center text-red-600">No packages available.</p>
//                 )}

//                 {packages.length > 0 && (
//                   <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-3 max-h-[70vh] overflow-y-auto">

//                     {packages.map((pkg) => (
//                       <div
//                         key={pkg.id}
//                         onClick={() => setSelectedPackage(pkg)}
//                         className={`cursor-pointer border rounded-xl p-4 shadow-sm transition duration-200 
//                           ${
//                             selectedPackage?.id === pkg.id
//                               ? "border-blue-600 bg-blue-50"
//                               : "border-gray-300 hover:border-blue-400 hover:bg-blue-50"
//                           }
//                         `}
//                       >
                        
//                         {authUser?.leads?.[0]?.package_id === pkg.id && (
//                           <span className="text-[10px] ml-2 text-blue-600 font-semibold">(Assigned)</span>
//                         )}
//                         {/* Title */}
//                         <h4 className="text-lg font-semibold text-gray-800">
//                           {pkg.package_name}
//                           <span className="text-blue-700"> (₹{pkg.amount})</span>
//                         </h4>

//                         {/* Validity */}
//                         <p className="text-xs text-gray-500">Validity: {pkg.validity_days} Days</p>

//                         {/* Badge Section */}
//                         {pkg.badge && (
//                           <div className="mt-3 p-2 rounded-lg border border-gray-200">

//                             <span className="text-xs font-semibold bg-blue-200 text-blue-800 px-2 py-1 rounded">
//                               {pkg.badge.name}
//                             </span>

//                             <p className="text-xs text-gray-700 mt-2">
//                               {pkg.badge.description}
//                             </p>

//                             <div className="text-xs text-gray-700 mt-2 space-y-1">
//                               <p><span className="font-semibold">Eligibility:</span> {pkg.badge.eligibility} Users</p>
//                               <p><span className="font-semibold">Benefits:</span> {pkg.badge.benefits}% Extra</p>
//                             </div>

//                           </div>
//                         )}
//                       </div>
//                     ))}
//                   </div>
//                 )}

//                 {/* Payment Button Centered */}
//                 <div className="flex justify-center mt-6">
//                   <button
//                     disabled={!selectedPackage || paymentCompleted || paymentSaving}
//                     onClick={handlePayment}
//                     className={`px-6 py-2.5 rounded-lg text-sm font-medium transition
//                       ${
//                         !selectedPackage || paymentCompleted || paymentSaving
//                           ? "bg-slate-300 text-slate-500 cursor-not-allowed"
//                           : "bg-blue-600 text-white hover:bg-blue-700"
//                       }`}
//                   >
//                     {paymentSaving
//                       ? "Saving payment..."
//                       : paymentCompleted
//                       ? "Payment Completed ✔"
//                       : selectedPackage
//                       ? `Proceed to Pay ₹${selectedPackage.amount}`
//                       : "Select a Package to Continue"}
//                   </button>
//                 </div>
//               </>
//             )}
//           </section>
//         )}

//         {/* ------- The rest of your steps remain UNCHANGED ------- */}

//         {isRetailer && uiStep === 3 && (
//           <section>
//             <h2 className="text-lg font-semibold text-slate-900 mb-4">
//               Authorized Person PAN Verification
//             </h2>

//             <div className="grid gap-4 md:grid-cols-2">
//               <InputField
//                 label="PAN Number"
//                 value={form.panNumber}
//                 disabled={form.panVerified} // ✅ disable if already verified
//                 readOnly={form.panVerified}
//                 className={`${form.panVerified ? "bg-gray-100 text-gray-500 cursor-not-allowed" : ""}`}
//                 onChange={(val) => !form.panVerified && updateField("panNumber", val.toUpperCase())}
//                 onBlur={() => validateField("panNumber", form.panNumber)}
//                 placeholder="ABCDE1234F"
//                 error={errors.panNumber}
//               />

//               <div className="flex items-end">
//                 <button
//                   onClick={verifyPAN}
//                   disabled={
//                     form.panVerified || // ✅ already verified
//                     !form.panNumber ||
//                     !isValidPAN(form.panNumber) ||
//                     loading
//                   }
//                   className={`px-4 py-2 rounded-lg transition text-white w-full md:w-auto
//                     ${form.panVerified ? "bg-green-600 cursor-default" : "bg-blue-600 hover:bg-blue-700 disabled:bg-gray-400"}
//                   `}
//                 >
//                   {form.panVerified ? "Verified ✓" : loading ? "Verifying..." : "Verify PAN"}
//                 </button>
//               </div>
//             </div>

//             {/* PAN verification message */}
//             {panMessage && (
//               <p className={`text-xs mt-2 font-medium ${form.panVerified ? "text-green-600" : "text-red-500"}`}>
//                 {panMessage}
//               </p>
//             )}

//             {/* Show verified PAN details if available */}
//             {form.panVerified && panApiResponse && (
//               <div className="mt-6 border rounded-lg p-4 bg-green-50">
//                 <h3 className="text-md font-semibold text-green-700 mb-3">
//                   PAN Details Verified ✓
//                 </h3>

//                 <div className="grid md:grid-cols-2 gap-3 text-sm">
//                   <p><strong>PAN:</strong> {panApiResponse.pan}</p>
//                   <p><strong>Name:</strong> {panApiResponse.name_pan_card}</p>
//                   <p><strong>Gender:</strong> {panApiResponse.gender}</p>
//                   <p><strong>DOB:</strong> {panApiResponse.date_of_birth}</p>
//                   <p><strong>Mobile:</strong> {panApiResponse.mobile_number}</p>
//                   <p><strong>Email:</strong> {panApiResponse.email}</p>
//                   <p><strong>Aadhaar Linked:</strong> {panApiResponse.aadhaar_linked ? "Yes" : "No"}</p>
//                   <p><strong>City:</strong> {panApiResponse.address?.city}</p>
//                   <p><strong>State:</strong> {panApiResponse.address?.state}</p>
//                   <p><strong>Pincode:</strong> {panApiResponse.address?.pincode}</p>
//                   <p><strong>Type:</strong> {panApiResponse.type}</p>
//                 </div>

//                 <p className="mt-2 text-xs text-gray-600">
//                   <strong>Full Address:</strong> {panApiResponse.address?.full_address}
//                 </p>
//               </div>
//             )}
//           </section>
//         )}

//         {uiStep === (isRetailer ? 4 : 3) && (
//           <section>
//             <h2 className="text-lg font-semibold text-slate-900 mb-4">GST details</h2>
//             <div className="grid gap-4 md:grid-cols-2">
//               <SelectField
//                 label="GST Type"
//                 required
//                 value={form.gstTreatment}
//                 onChange={(value) => handleChange("gstTreatment", value)}
//                 options={[
//                   { value: "registered", label: "Registered" },
//                   { value: "unregistered", label: "Unregistered" },
//                 ]}
//                 error={errors.gstTreatment}
//               />


//               <InputField
//                 label={form.gstTreatment === "unregistered" ? "PAN Number" : "GSTIN"}
//                 required
//                 value={form.gstin}
//                 readOnly={form.gstTreatment === "unregistered"}
//                 onChange={(value) => handleChange("gstin", value)}
//                 placeholder={
//                   form.gstTreatment === "unregistered"
//                     ? "PAN auto-filled"
//                     : "22AAAAA0000A1Z5"
//                 }
//               />


//             </div>

//             {gstVerified && gstResponse && (
//               <div className="mt-4 grid gap-4 md:grid-cols-3">
//                 <InputField
//                   label="Business Legal Name"
//                   value={form.businessName}
//                   readOnly
//                 />

//                 <InputField
//                   label="Trade Name"
//                   value={form.tradeName}
//                   readOnly
//                 />

//                 <InputField
//                   label="Taxpayer Type"
//                   value={form.taxpayerType}
//                   readOnly
//                 />
//               </div>
//             )}


//             {form.gstTreatment === "registered" && (
//               <button
//                 type="button"
//                 onClick={verifyGST}
//                 disabled={gstVerified || gstLoading}
//                 className={`mt-2 px-4 py-2 rounded-lg text-sm text-white
//                   ${gstVerified ? "bg-green-600" : "bg-blue-600 hover:bg-blue-700"}
//                 `}
//               >
//                 {gstVerified ? "Verified ✓" : gstLoading ? "Verifying..." : "Verify GST"}
//               </button>
//             )}


//             {gstVerified && gstResponse && (
//               <div className="mt-4 border rounded-lg p-4 bg-green-50 text-sm">
//                 <h3 className="font-semibold text-green-700 mb-2">
//                   GST Details Verified ✓
//                 </h3>

//                 <div className="grid md:grid-cols-2 gap-2">
//                   <p><strong>GSTIN:</strong> {gstResponse.GSTIN}</p>
//                   <p><strong>Status:</strong> {gstResponse.gst_in_status}</p>
//                   <p><strong>Taxpayer Type:</strong> {gstResponse.taxpayer_type}</p>
//                   <p><strong>Legal Name:</strong> {gstResponse.legal_name_of_business}</p>
//                   <p><strong>Trade Name:</strong> {gstResponse.trade_name_of_business}</p>
//                   <p><strong>Registration Date:</strong> {gstResponse.date_of_registration}</p>
//                   <p><strong>State Jurisdiction:</strong> {gstResponse.state_jurisdiction}</p>
//                   <p><strong>Center Jurisdiction:</strong> {gstResponse.center_jurisdiction}</p>
//                 </div>

//                 {/* Address */}
//                 <div className="mt-3">
//                   <p className="font-semibold">Principal Place of Business</p>
//                   <p className="text-gray-700">
//                     {gstResponse.principal_place_address}
//                   </p>
//                 </div>

//                 {/* Nature of Business */}
//                 {Array.isArray(gstResponse.nature_of_business_activities) && (
//                   <div className="mt-3">
//                     <p className="font-semibold">Nature of Business</p>
//                     <ul className="list-disc ml-5 text-gray-700">
//                       {gstResponse.nature_of_business_activities.map((item, idx) => (
//                         <li key={idx}>{item}</li>
//                       ))}
//                     </ul>
//                   </div>
//                 )}
//               </div>
//             )}
//           </section>
//         )}

//         {uiStep === (isRetailer ? 5 : 4) && (
//           <section>
//             <h2 className="text-lg font-semibold text-slate-900 mb-4">
//               Bank account details
//             </h2>

//             <div className="grid gap-4 md:grid-cols-3">
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">
//                   Account Type
//                 </label>
//                 <select
//                   className="border rounded-lg p-2 w-full"
//                   value={form.accountType}
//                   onChange={(e) => handleChange("accountType", e.target.value)}
//                   // disabled={!!form.accountType} // optional read-only if already present
//                 >
//                   <option value="">Select Account Type</option>
//                   <option value="current">Current</option>
//                   <option value="saving">Saving</option>
//                 </select>
//               </div>

//               <InputField
//                 label="Account Number"
//                 required
//                 value={form.accountNumber}
//                 onChange={(value) => handleChange("accountNumber", value)}
//                 placeholder="Enter account number"
//                 error={errors.accountNumber}
//                 readOnly={bankVerified} // optional
//               />

//               <InputField
//                 label="IFSC Code"
//                 required
//                 value={form.ifsc}
//                 onChange={(value) => handleChange("ifsc", value)}
//                 placeholder="e.g. HDFC0001234"
//                 error={errors.ifsc}
//                 readOnly={bankVerified} // optional
//               />
//             </div>

//             {bankVerified && bankResponse && (
//               <div className="grid gap-4 md:grid-cols-3 mt-4">
//                 <InputField
//                   label="Branch Name"
//                   value={form.branchname}
//                   readOnly
//                 />

//                 <InputField
//                   label="Bank Name"
//                   value={form.bankName}
//                   readOnly
//                 />

//                 <InputField
//                   label="Authorized Person Name"
//                   value={form.authorisedName}
//                   readOnly
//                 />
//               </div>
//             )}
            
//             {/* <div className="grid gap-4 md:grid-cols-2 mt-6">
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-1">
//                   Upload Proof (Select One)
//                 </label>
//                 <select
//                   className="border rounded-lg p-2 w-full"
//                   value={form.bankProofType}
//                   onChange={(e) => handleChange("bankProofType", e.target.value)}
//                 >
//                   <option value="">Select Document Type</option>
//                   <option value="passbook">Passbook Photo</option>
//                   <option value="cheque">Cancelled Cheque</option>
//                 </select>
//               </div>

//               {form.bankProofType && (
//                 <div className="p-4 border border-gray-300 rounded-lg">
//                   <p className="text-sm text-gray-600 mb-3">
//                     Upload:{" "}
//                     <span className="font-semibold">
//                       {form.bankProofType === "passbook" ? "Passbook Photo" : "Cancelled Cheque"}
//                     </span>
//                   </p>

//                   <div className="flex items-center gap-3 mt-2">
//                     <input
//                       type="file"
//                       accept="image/*,application/pdf"
//                       onChange={(e) => handleChange("bankProofFile", e.target.files[0])}
//                       className="w-full text-sm"
//                     />
//                     <BlueButton
//                       onClick={handleUpload}
//                       disabled={
//                         !form.bankProofFile ||
//                         !form.bankProofType ||
//                         uploading ||
//                         isUploaded   // ⬅️ disabled after success
//                       }
//                     >
//                       {isUploaded ? "Uploaded" : uploading ? "Uploading..." : "Upload"}
//                     </BlueButton>


//                   </div>

//                   {form.bankProofFile && (
//                     <p className="text-green-600 text-sm mt-2">
//                       File selected: {form.bankProofFile.name}
//                     </p>
//                   )}
//                 </div>
//               )}

//             </div> */}

//             <button
//               type="button"
//               onClick={verifyBankAccount}
//               disabled={bankVerified || bankLoading}
//               className={`mt-5 px-4 py-2 rounded-lg text-sm text-white
//                 ${bankVerified ? "bg-green-600" : "bg-blue-600 hover:bg-blue-700"}
//               `}
//             >
//               {bankVerified ? "Verified ✓" : bankLoading ? "Verifying..." : "Verify Account"}
//             </button>

//             {bankVerified && bankResponse && (
//               <div className="mt-4 border rounded-lg p-4 bg-green-50 text-sm">
//                 <h3 className="font-semibold text-green-700 mb-2">
//                   Bank Account Verified ✓
//                 </h3>

//                 <div className="grid md:grid-cols-2 gap-2">
//                   <p><strong>Account Status:</strong> {bankResponse.account_status}</p>
//                   <p><strong>Bank Name:</strong> {bankResponse.bank_name}</p>
//                   <p><strong>Branch:</strong> {bankResponse.branch}</p>
//                   <p><strong>City:</strong> {bankResponse.city}</p>
//                   <p><strong>IFSC:</strong> {bankResponse.ifsc_details?.ifsc}</p>
//                   <p><strong>MICR:</strong> {bankResponse.micr}</p>
//                   <p><strong>UTR:</strong> {bankResponse.utr}</p>
//                   <p><strong>Name at Bank:</strong> {bankResponse.name_at_bank}</p>
//                 </div>
//               </div>
//             )}

//           </section>
//         )}

//         {uiStep === (isRetailer ? 6 : 5) && (
//           <section>
//             <h2 className="text-lg font-semibold text-slate-900 mb-4">
//               Sign User Agreement
//             </h2>

//             {agreementUrl ? (
//               <div className="flex justify-center min-h-screen bg-white">
//                 <div className="bg-slate-50 border p-2 rounded-xl text-xs text-slate-600 flex flex-col gap-3 max-w-[800px] w-full items-center shadow-md">
//                   <div
//                     ref={scrollRef}
//                     onScroll={handleScroll}
//                     className="border rounded-xl bg-white shadow-inner p-2 w-full h-[700px] overflow-y-auto"
//                   >
//                     <iframe
//                       src={`https://docs.google.com/viewer?url=${agreementUrl}&embedded=true`}
//                       title="Agreement PDF"
//                       className="w-full h-[1400px]"
//                     />
//                   </div>

//                   <a
//                     href={agreementUrl}
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="text-blue-600 underline font-medium text-sm"
//                   >
//                     Download Agreement PDF
//                   </a>
//                 </div>
//               </div>
//             ) : (
//               <RegularLoader />
//             )}

//             {/* Agreement Checkbox */}
//             <label className="mt-4 flex items-start gap-2">
//               <input
//                 type="checkbox"
//                 className="mt-1 w-4 h-4"
//                 checked={form.agreed}
//                 disabled={!hasScrolledToBottom}
//                 onChange={(e) => handleAgreementCheck(e.target.checked)}
//               />
//               <span
//                 className={`text-sm ${
//                   !hasScrolledToBottom ? "text-gray-400" : "text-slate-700"
//                 }`}
//               >
//                 I agree to the user agreement.
//               </span>
//             </label>

//             {!hasScrolledToBottom && (
//               <p className="text-xs text-red-500 mt-1">
//                 Scroll to the bottom to enable agreement.
//               </p>
//             )}
//           </section>
//         )}

//         {/* {currentStep === 7 && (
//             <section className="flex justify-center">
//               <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white/80 shadow-sm backdrop-blur p-6 flex flex-col items-center gap-5">

                
//                 {!form.aadhaarVerified && (
//                   <>
                    
//                     <div className="flex items-center gap-3 w-full">
//                       <div className="shrink-0 rounded-xl p-3 bg-gradient-to-br from-sky-500/10 to-indigo-500/10">
//                         <img
//                           src={esign}
//                           alt="Aadhaar e-Sign"
//                           className="w-10 h-10 object-contain"
//                         />
//                       </div>
//                       <div className="flex-1">
//                         <h2 className="text-base md:text-lg font-semibold text-slate-900">
//                           Aadhaar e-Sign Verification
//                         </h2>
//                         <p className="text-xs text-slate-500">
//                           Enter the last 4 digits of your Aadhaar. We’ll open a secure e-Sign window.
//                         </p>
//                       </div>
//                     </div>

                  
//                     <div className="mt-2 flex justify-center w-full">
//                       <div className="flex gap-2">
//                         {Array.from({ length: 4 }).map((_, idx) => (
//                           <input
//                             key={idx}
//                             ref={(el) => (aadhaarInputsRef.current[idx] = el)}
//                             inputMode="numeric"
//                             pattern="[0-9]*"
//                             type="text"
//                             maxLength={1}
//                             value={form?.aadhaarLast4?.[idx] || ""}
//                             onChange={(e) => handleAadhaarBoxChange(idx, e.target.value)}
//                             onKeyDown={(e) => handleAadhaarKeyDown(idx, e)}
//                             disabled={form.aadhaarVerified}
//                             className="w-12 h-12 text-center text-lg font-semibold rounded-xl border border-slate-300 bg-white focus:outline-none focus:ring-2 focus:ring-sky-400 disabled:bg-slate-100"
//                           />
//                         ))}
//                       </div>
//                     </div>
//                   </>
//                 )}

                
//                 <div className="min-h-[18px] text-center text-xs">
//                   {aadhaarError ? (
//                     <span className="text-red-600">{aadhaarError}</span>
//                   ) : form.aadhaarVerified || aadhaarStatus === "success" ? (
//                     <>
//                   <div className="w-full max-w-md rounded-2xl shadow-sm p-6 flex flex-col items-center gap-5">
//                       <img
//                         src={verifiedimg} // make sure this points to your verified.avif file
//                         alt="e-Sign Verified"
//                         className="w-40 h-40 object-contain bg-transparent"
//                       />

//                     </div>


//                     <span className="text-green-600">Verified ✅ e-Sign completed</span>
//                     </>
                    
//                   ) : aadhaarStatus === "verifying" ? (
//                     <span className="text-slate-500">
//                       Waiting for you to complete e-Sign in the popup...
//                     </span>
//                   ) : (
//                     <span className="text-slate-500">
//                       We’ll redirect you to a secure UIDAI-compliant e-Sign partner.
//                     </span>
//                   )}
//                 </div>

              
//                 {!form.aadhaarVerified && (
//                   <button
//                     type="button"
//                     onClick={verifyAadhaar}
//                     disabled={
//                       !aadhaarValid ||
//                       form.aadhaarVerified ||
//                       aadhaarStatus === "loading" ||
//                       aadhaarStatus === "verifying"
//                     }
//                     className="w-full max-w-xs rounded-xl py-2.5 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 disabled:bg-slate-400"
//                   >
//                     {form.aadhaarVerified ? "e-Sign Verified" : "Verify & Open e-Sign"}
//                   </button>
//                 )}

//                 {!form.aadhaarVerified && (
//                 <p className="text-[11px] text-center text-slate-500">
//                   By continuing, you consent to Aadhaar-based e-Sign for this agreement.
//                 </p>
//                 )}
//               </div>
//             </section>
//           )} */}

//         {displayStep === 7 && (
//           <section className="flex justify-center">
//             <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white/80 shadow-sm backdrop-blur p-6 flex flex-col items-center gap-5">

//               {/* Only show header & input boxes if NOT verified */}
//               {!form.aadhaarVerified && (
//                 <>
//                   {/* Header */}
//                   <div className="flex items-center gap-3 w-full">
//                     <div className="shrink-0 rounded-xl p-3 bg-gradient-to-br from-sky-500/10 to-indigo-500/10">
//                       <img
//                         src={esign}
//                         alt="Aadhaar e-Sign"
//                         className="w-10 h-10 object-contain"
//                       />
//                     </div>
//                     <div className="flex-1">
//                       <h2 className="text-base md:text-lg font-semibold text-slate-900">
//                         Aadhaar e-Sign Verification
//                       </h2>
//                       <p className="text-xs text-slate-500">
//                         Enter the last 4 digits of your Aadhaar. We’ll open a secure e-Sign window.
//                       </p>
//                     </div>
//                   </div>

//                   {/* 4 Input Boxes */}
//                   <div className="mt-2 flex justify-center w-full">
//                     <div className="flex gap-2">
//                       {Array.from({ length: 4 }).map((_, idx) => (
//                         <input
//                           key={idx}
//                           ref={(el) => (aadhaarInputsRef.current[idx] = el)}
//                           inputMode="numeric"
//                           pattern="[0-9]*"
//                           type="text"
//                           maxLength={1}
//                           value={form?.aadhaarLast4?.[idx] || ""}
//                           onChange={(e) => handleAadhaarBoxChange(idx, e.target.value)}
//                           onKeyDown={(e) => handleAadhaarKeyDown(idx, e)}
//                           disabled={form.aadhaarVerified}
//                           className="w-12 h-12 text-center text-lg font-semibold rounded-xl border border-slate-300 bg-white focus:outline-none focus:ring-2 focus:ring-sky-400 disabled:bg-slate-100"
//                         />
//                       ))}
//                     </div>
//                   </div>
//                 </>
//               )}

//               {/* Helper / Error / Success */}
//               <div className="min-h-[18px] text-center text-xs">

//                 {/* 🔵 Loader for get-esign-status */}
//                 {esignStatusLoading && (
//                   <div className="flex justify-center items-center gap-2 text-blue-600 py-2">
//                     <svg className="w-4 h-4 animate-spin" viewBox="0 0 24 24">
//                       <circle
//                         className="opacity-25"
//                         cx="12"
//                         cy="12"
//                         r="10"
//                         stroke="currentColor"
//                         strokeWidth="4"
//                       ></circle>
//                       <path
//                         className="opacity-75"
//                         fill="currentColor"
//                         d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
//                       ></path>
//                     </svg>
//                     Checking e-Sign status...
//                   </div>
//                 )}

//                 {/* 🔻 Hide all other messages when loader is running */}
//                 {!esignStatusLoading && (
//                   <>
//                     {aadhaarError ? (
//                       <span className="text-red-600">{aadhaarError}</span>
//                     ) : form.aadhaarVerified || aadhaarStatus === "success" ? (
//                       <>
//                         <div className="w-full max-w-md rounded-2xl shadow-sm p-6 flex flex-col items-center gap-5">
//                           <img
//                             src={verifiedimg}
//                             alt="e-Sign Verified"
//                             className="w-40 h-40 object-contain bg-transparent"
//                           />
//                         </div>
//                         <span className="text-green-600">
//                           Verified ✅ e-Sign completed
//                         </span>
//                       </>
//                     ) : aadhaarStatus === "verifying" ? (
//                       <span className="text-slate-500">
//                         Waiting for you to complete e-Sign in the popup...
//                       </span>
//                     ) : (
//                       <span className="text-slate-500">
//                         We’ll redirect you to a secure UIDAI-compliant e-Sign partner.
//                       </span>
//                     )}
//                   </>
//                 )}
//               </div>

//               {/* Button */}
//               {!form.aadhaarVerified && (
//                 <button
//                   type="button"
//                   onClick={verifyAadhaar}
//                   disabled={
//                     !aadhaarValid ||
//                     aadhaarStatus === "loading" ||
//                     aadhaarStatus === "verifying" ||
//                     esignStatusLoading
//                   }
//                   className="w-full max-w-xs rounded-xl py-2.5 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 disabled:bg-slate-400"
//                 >
//                   {esignStatusLoading
//                     ? "Checking Status..."
//                     : form.aadhaarVerified
//                     ? "e-Sign Verified"
//                     : "Verify & Open e-Sign"}
//                 </button>
//               )}

//               {/* Small note */}
//               {!form.aadhaarVerified && (
//                 <p className="text-[11px] text-center text-slate-500">
//                   By continuing, you consent to Aadhaar-based e-Sign for this agreement.
//                 </p>
//               )}
//             </div>
//           </section>
//         )}
//       </div>
//     </>
//   );
// }



// import { useEffect, useRef, useState } from "react";
// import InputField from "./InputField";
// import SelectField from "./SelectField";
// import toast from "react-hot-toast";
// import RegularLoader from "../Loader/RegularLoader";
// import BlueButton from "../Common/BlueButton";
// import { APPID, BASE_URL, SecretKey, SWAGGER_URL } from "../../config/api";
// import esign from "../../asset/images/esign.webp";
// import verifiedimg from "../../asset/images/verified.avif";

// export default function FormBody({ currentStep, form, updateField, selectedPackage, setSelectedPackage,panApiResponse, setPanApiResponse, verifyAadhaar, aadhaarStatus, setAadhaarStatus, setForm, esignStatusLoading, setIsPaymentSuccess, gstVerified,
//   setGstVerified, gstResponse, setGstResponse,bankVerified, setBankVerified, bankResponse, setBankResponse, }) {
//   const isUnregistered = form.gstTreatment === "unregistered";

//   const [errors, setErrors] = useState({});
//   const [emailOtpSent, setEmailOtpSent] = useState(false);
//   const [emailVerified, setEmailVerified] = useState(false);
//   const [phoneOtpSent, setPhoneOtpSent] = useState(false);
//   const [phoneVerified, setPhoneVerified] = useState(false);
//   const [emailOtp, setEmailOtp] = useState("");
//   const [phoneOtp, setPhoneOtp] = useState("");
//   const [packages, setPackages] = useState([]);
//   // const [selectedPackage, setSelectedPackage] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const authUser = JSON.parse(localStorage.getItem("authUserData") || "{}");
//   const id = authUser?.id;
//   const role = authUser?.role;
//   const [agreementUrl, setAgreementUrl] = useState(null);
//   const [hasScrolledToBottom, setHasScrolledToBottom] = useState(false);
//   const [panMessage, setPanMessage] = useState("");
//   // const [aadhaarStatus, setAadhaarStatus] = useState("idle"); // idle | loading | verifying | success | error
//   const [aadhaarError, setAadhaarError] = useState("");
//   const esignPopupRef = useRef(null);
//   const esignPollRef = useRef(null);
//   const aadhaarInputsRef = useRef([]);

//   const [isUploaded, setIsUploaded] = useState(false);

//   const [resendEmailTimer, setResendEmailTimer] = useState(0);

//   const [sendingOtp, setSendingOtp] = useState(false);
//   const [resendTimer, setResendTimer] = useState(0); // seconds
//   const [verifyingOtp, setVerifyingOtp] = useState(false);
//   const [uploading, setUploading] = useState(false);

//   const [paymentKeys, setPaymentKeys] = useState({
//     key_id: "",
//     key_secret: ""
//   });
//   const [keyLoading, setKeyLoading] = useState(false);
//   const [paymentCompleted, setPaymentCompleted] = useState(false);
//   const [gstLoading, setGstLoading] = useState(false);
//   const [bankLoading, setBankLoading] = useState(false);



//   const fetchPaymentKeys = async () => {
//   try {
//     setKeyLoading(true);

//     const res = await fetch(`${BASE_URL}payment/keys`);
//     const data = await res.json();

//     if (Array.isArray(data) && data.length > 0) {
//       setPaymentKeys({
//         key_id: data[0].key_id,
//         key_secret: data[0].key_secret
//       });
//     } else {
//       console.error("Invalid keys response", data);
//     }
//   } catch (err) {
//     console.error("Failed to fetch payment keys", err);
//   } finally {
//     setKeyLoading(false);
//   }
// };


//   useEffect(() => {
//   if (currentStep === 2) {
//     fetchPaymentKeys();
//   }
// }, [currentStep]);




//    const handleAadhaarBoxChange = (idx, value) => {
//     const digit = value.replace(/\D/g, "").slice(0, 1);

//     const chars = (form.aadhaarLast4 || "").split("");
//     while (chars.length < 4) chars.push("");
//     chars[idx] = digit;

//     const joined = chars.join("");
//     updateField("aadhaarLast4", joined);

//     if (digit && aadhaarInputsRef.current[idx + 1]) {
//       aadhaarInputsRef.current[idx + 1].focus();
//     }
//   };

//   const handleAadhaarKeyDown = (idx, e) => {
//     if (e.key === "Backspace" && !form.aadhaarLast4?.[idx]) {
//       if (aadhaarInputsRef.current[idx - 1]) {
//         aadhaarInputsRef.current[idx - 1].focus();
//       }
//     }
//     if (e.key === "ArrowLeft" && aadhaarInputsRef.current[idx - 1]) {
//       aadhaarInputsRef.current[idx - 1].focus();
//     }
//     if (e.key === "ArrowRight" && aadhaarInputsRef.current[idx + 1]) {
//       aadhaarInputsRef.current[idx + 1].focus();
//     }
//   };

//   const aadhaarValid =
//     form.aadhaarLast4 &&
//     form.aadhaarLast4.length === 4 &&
//     /^\d{4}$/.test(form.aadhaarLast4);

//   // NOTE: update verifyAadhaar() to accept last4 and return eSign URL (Promise<string>)
//   // const handleEsignClick = async () => {
//   //   if (!aadhaarValid) {
//   //     toast.error("Enter valid last 4 digits of Aadhaar");
//   //     return;
//   //   }

//   //   setAadhaarError("");
//   //   setAadhaarStatus("loading");

//   //   try {
//   //     // 👇 You must update verifyAadhaar to:
//   //     // async function verifyAadhaar(last4) { ... return esignUrl }
//   //     const esignUrl = await verifyAadhaar(form.aadhaarLast4);

//   //     if (!esignUrl) {
//   //       throw new Error("Invalid e-Sign link from server");
//   //     }

//   //     setAadhaarStatus("verifying");
//   //     openEsignPopup(esignUrl);
//   //   } catch (err) {
//   //     console.error(err);
//   //     setAadhaarStatus("error");
//   //     setAadhaarError(err?.message || "Failed to start e-Sign");
//   //     toast.error("Unable to start e-Sign");
//   //   }
//   // };

//   const cleanupEsignPopup = () => {
//     if (esignPollRef.current) {
//       clearInterval(esignPollRef.current);
//       esignPollRef.current = null;
//     }
//     if (esignPopupRef.current && !esignPopupRef.current.closed) {
//       try {
//         esignPopupRef.current.close();
//       } catch (e) {
//         console.error(e);
//       }
//     }
//     esignPopupRef.current = null;
//   };

//   const openEsignPopup = (url) => {
//     const w = 460;
//     const h = 640;
//     const dualScreenLeft =
//       window.screenLeft !== undefined ? window.screenLeft : window.screenX;
//     const dualScreenTop =
//       window.screenTop !== undefined ? window.screenTop : window.screenY;
//     const width =
//       window.innerWidth ||
//       document.documentElement.clientWidth ||
//       window.screen.width;
//     const height =
//       window.innerHeight ||
//       document.documentElement.clientHeight ||
//       window.screen.height;

//     const left = width / 2 - w / 2 + dualScreenLeft;
//     const top = height / 2 - h / 2 + dualScreenTop;

//     const features = `scrollbars=yes,resizable=yes,width=${w},height=${h},top=${top},left=${left}`;
//     esignPopupRef.current = window.open(url, "esignPopup", features);

//     // Fallback polling – if popup closed manually
//     esignPollRef.current = setInterval(() => {
//       if (!esignPopupRef.current || esignPopupRef.current.closed) {
//         clearInterval(esignPollRef.current);
//         esignPollRef.current = null;
//         esignPopupRef.current = null;

//         // Only reset state if we were waiting
//         if (aadhaarStatus === "verifying") {
//           setAadhaarStatus("idle");
//         }
//       } else {
//         // OPTIONAL: if your success page is same-origin and has /esign-success in URL
//         try {
//           const href = esignPopupRef.current.location.href || "";
//           if (href.includes("esign-success")) {
//             cleanupEsignPopup();
//             setAadhaarStatus("success");
//             updateField("aadhaarVerified", true);
//             toast.success("e-Sign verified successfully");
//           }
//         } catch {
//           // Cross-origin during provider flow – ignore
//         }
//       }
//     }, 800);
//   };

//   // Listen for postMessage from success page
//   useEffect(() => {
//     const handler = (e) => {
//       // In production, replace "*" with your exact origin and check e.origin
//       if (e?.data?.type === "ESIGN_SUCCESS") {
//         cleanupEsignPopup();
//         setAadhaarStatus("success");
//         updateField("aadhaarVerified", true);
//         toast.success("e-Sign verified successfully");
//       }
//       if (e?.data?.type === "ESIGN_CANCELLED") {
//         cleanupEsignPopup();
//         setAadhaarStatus("idle");
//         toast.error("e-Sign cancelled");
//       }
//     };

//     window.addEventListener("message", handler);
//     return () => window.removeEventListener("message", handler);
//   }, []);

//   const scrollRef = useRef(null);

//   const handleScroll = () => {
//     const el = scrollRef.current;
//     if (!el) return;

//     if (el.scrollTop + el.clientHeight >= el.scrollHeight - 5) {
//       setHasScrolledToBottom(true);
//     }
//   };

//   // Prefill form fields from localStorage on mount
//   useEffect(() => {
//     const storedUser = localStorage.getItem("authUserData");
//     if (storedUser) {
//       try {
//         const user = JSON.parse(storedUser);

//         updateField("address_line1", user.address_line1 || "");
//         updateField("address_line2", user.address_line2 || "");
//         updateField("state", user.state || "");
//         updateField("district", user.district || "");
//         updateField("city", user.city || "");
//         updateField("pincode", user.pincode || "");
//         updateField("email", user.contact_email || "");
//         updateField("phone", user.contact_phone || "");
//       } catch (err) {
//         console.error("Invalid session user data", err);
//       }
//     }
//   }, []);

//   // ---------------- Email + Phone OTP Logic ----------------
//   const sendEmailOtp = async () => {
//   const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

//   if (!form.email || !emailRegex.test(form.email)) {
//     setErrors(prev => ({ ...prev, email: "Enter a valid email address" }));
//     toast.error("Invalid email format");
//     return;
//   }

//   const storedUser = localStorage.getItem("authUserData");
//   const user = storedUser ? JSON.parse(storedUser) : null;
//   const userId = user?.id;

//   if (!userId) {
//     toast.error("User session not found");
//     return;
//   }

//   try {
//     const response = await fetch(`${BASE_URL}send-welcome-email/${userId}`, {
//       method: "GET",
//       cache: "no-store",
//     });

//     const result = await response.json();
//     console.log("API Response:", result);

//     if (result?.status) {
//       setEmailOtpSent(true);
//       localStorage.setItem("emailOtpSent", "true");

//       // ⏱️ Start 5 min timer for resend
//       const endTime = Date.now() + 5 * 60 * 1000;
//       localStorage.setItem("resendEmailOtpEndTime", endTime);
//       setResendEmailTimer(5 * 60); // seconds

//       toast.success("Email OTP sent successfully!");
//     } else {
//       toast.error("Failed to send email OTP");
//     }
//   } catch (error) {
//     console.error(error);
//     toast.error("Something went wrong. Try again!");
//   }
// };

//   useEffect(() => {
//     const storedEndTime = localStorage.getItem("resendEmailOtpEndTime");
//     if (storedEndTime) {
//       const remaining = Math.floor((storedEndTime - Date.now()) / 1000);
//       if (remaining > 0) setResendEmailTimer(remaining);
//       else localStorage.removeItem("resendEmailOtpEndTime");
//     }
//   }, []);

//   useEffect(() => {
//     if (resendEmailTimer <= 0) return;

//     const interval = setInterval(() => {
//       setResendEmailTimer(prev => {
//         if (prev <= 1) {
//           clearInterval(interval);
//           localStorage.removeItem("resendEmailOtpEndTime");
//           return 0;
//         }
//         return prev - 1;
//       });
//     }, 1000);

//     return () => clearInterval(interval);
//   }, [resendEmailTimer]);


//  const verifyEmailOtp = async () => {
//     try {
//       const authUser = JSON.parse(localStorage.getItem("authUserData") || "{}");

//       const role = Number(authUser.role);
//       const userId = authUser.id;

//       // ✅ role-based company_id rule
//       const companyId =
//         role === 2
//           ? 1
//           : authUser.company_id || authUser.id;

//       const res = await fetch(`${BASE_URL}verify-email-otp`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           email: form.email,
//           otp: emailOtp,
//           user_id: userId,
//           company_id: companyId,
//         }),
//       });

//       const data = await res.json();

//       if (data?.status) {
//         setEmailVerified(true);
//         localStorage.setItem("emailVerified", "true");
//         localStorage.setItem("verifiedEmail", form.email);

//         toast.success("Email Verified Successfully");
//       } else {
//         toast.error(data?.message || "Invalid OTP");
//       }
//     } catch (err) {
//       console.error(err);
//       toast.error("Something went wrong!");
//     }
//   };


//   useEffect(() => {
//     const savedEmailOtpSent = localStorage.getItem("emailOtpSent");
//     const savedEmailVerified = localStorage.getItem("emailVerified");
//     const savedEmail = localStorage.getItem("verifiedEmail");

//     if (savedEmailOtpSent === "true") setEmailOtpSent(true);
//     if (savedEmailVerified === "true") setEmailVerified(true);

//     if (savedEmail) {
//       setForm(prev => ({ ...prev, email: savedEmail }));
//     }
//   }, []);
  
//   // Automatically mark email as verified if user logged in with verified email
//   useEffect(() => {
//     const storedUser = localStorage.getItem("authUserData");
//     if (storedUser) {
//       try {
//         const user = JSON.parse(storedUser);

//         if (user.is_mail_verified === 1) {
//           setEmailVerified(true);
//           localStorage.setItem("emailVerified", "true");
//           localStorage.setItem("verifiedEmail", user.contact_email || "");
//           setForm(prev => ({
//             ...prev,
//             email: user.contact_email || "",
//           }));
//         }
//       } catch (err) {
//         console.error("Error parsing authUserData", err);
//       }
//     }
//   }, []);

//   const handleEmailChange = (value) => {
//     handleChange("email", value);

//     // Reset stored status if email changes
//     localStorage.removeItem("emailOtpSent");
//     localStorage.removeItem("emailVerified");
//     localStorage.removeItem("verifiedEmail");

//     setEmailOtpSent(false);
//     setEmailVerified(false);
//     setEmailOtp("");
//   };

//   const sendPhoneOtp = async () => {
//   if (!form.phone) return;

//   try {
//     setSendingOtp(true);

//     const response = await fetch(`${BASE_URL}send-wa-otp`, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ contact_phone: form.phone, company_id: authUser.id }),
//     });
//     const result = await response.json();

//     if (response.ok) {
//       setPhoneOtpSent(true);
//       localStorage.setItem("phoneOtpSent", "true");
//       toast.success("Phone OTP sent successfully!");

//       // Start 10 min timer
//       const endTime = Date.now() + 5 * 60 * 1000;
//       localStorage.setItem("resendOtpEndTime", endTime);
//       setResendTimer(5 * 60); // in seconds
//     } else {
//       toast.error(result.message || "Failed to send OTP");
//     }
//   } catch (error) {
//     toast.error("Failed to send OTP");
//   } finally {
//     setSendingOtp(false);
//   }
// };

//   useEffect(() => {
//   const storedEndTime = localStorage.getItem("resendOtpEndTime");
//   if (storedEndTime) {
//     const remaining = Math.floor((storedEndTime - Date.now()) / 1000);
//     if (remaining > 0) setResendTimer(remaining);
//     else localStorage.removeItem("resendOtpEndTime");
//   }
// }, []);

//   useEffect(() => {
//     if (resendTimer <= 0) return;

//     const interval = setInterval(() => {
//       setResendTimer(prev => {
//         if (prev <= 1) {
//           clearInterval(interval);
//           localStorage.removeItem("resendOtpEndTime");
//           return 0;
//         }
//         return prev - 1;
//       });
//     }, 1000);

//     return () => clearInterval(interval);
//   }, [resendTimer]);

//   const verifyPhoneOtp = async () => {
//     if (!phoneOtp) {
//       toast.error("Enter OTP");
//       return;
//     }

//     try {
//       setVerifyingOtp(true);

//       const response = await fetch(`${BASE_URL}verify-wa-otp`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ contact_phone: form.phone, otp: phoneOtp }),
//       });
//       const result = await response.json();

//       if (!response.ok) throw new Error(result.message);

//       setPhoneVerified(true);
//       localStorage.setItem("phoneVerified", "true");
//       localStorage.removeItem("phoneOtp");
//       localStorage.removeItem("phoneOtpSent");

//       toast.success("Phone Verified Successfully!");
//     } catch (error) {
//       toast.error(error.message || "Invalid OTP");
//     } finally {
//       setVerifyingOtp(false);
//     }
//   };

//   useEffect(() => {
//     const storedPhoneSent = localStorage.getItem("phoneOtpSent");
//     const storedPhoneVerified = localStorage.getItem("phoneVerified");
//     const storedPhoneOtp = localStorage.getItem("phoneOtp");

//     if (storedPhoneSent === "true") setPhoneOtpSent(true);
//     if (storedPhoneVerified === "true") setPhoneVerified(true);
//     if (storedPhoneOtp) setPhoneOtp(storedPhoneOtp);
//   }, []);

//   // Automatically mark phone as verified if user logged in with verified phone
//   useEffect(() => {
//     const storedUser = localStorage.getItem("authUserData");
//     if (storedUser) {
//       try {
//         const user = JSON.parse(storedUser);

//         if (user.is_wa_verified === 1) {
//           setPhoneVerified(true);
//           localStorage.setItem("phoneVerified", "true");
//           localStorage.setItem("verifiedPhone", user.contact_phone || "");
//           setForm(prev => ({
//             ...prev,
//             phone: user.contact_phone || "",
//           }));
//         }
//       } catch (err) {
//         console.error("Error parsing authUserData", err);
//       }
//     }
//   }, []);

//   // ---------------- Validation ----------------
//   const validateField = (field, value, isUnregistered = false) => {
//   let error = "";

//   switch (field) {
//     case "email":
//       if (!value) error = "Email is required";
//       else {
//         const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//         if (!emailRegex.test(value)) error = "Invalid email format";
//       }
//       break;

//     case "phone":
//       if (!value) error = "Phone is required";
//       else {
//         const phoneRegex = /^[6-9][0-9]{9}$/;
//         if (!phoneRegex.test(value)) error = "Invalid phone number format";
//       }
//       break;

//     case "panNumber": 
//       if (!value) error = "Enter PAN Number";
//       else {
//         const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
//         if (!panRegex.test(value)) error = "Invalid PAN format (e.g. ABCDE1234F)";
//       }
//       break;

//     case "gstTreatment":
//       if (!value) error = "Select GST treatment";
//       break;

//     case "gstin":
//       if (!value) {
//         error = isUnregistered ? "Enter PAN number" : "Enter GSTIN / UIN";
//       } else {
//         if (isUnregistered) {
//           const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
//           if (!panRegex.test(value)) error = "Invalid PAN format";
//         } else {
//           const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/;
//           if (!gstRegex.test(value)) error = "Invalid GSTIN format";
//         }
//       }
//       break;

//     case "businessName":
//       if (!value) error = "Enter legal business name";
//       break;

//     case "accountNumber":
//       if (!value) error = "Enter account number";
//       break;

//     case "ifsc":
//       if (!value) error = "Enter IFSC code";
//       else {
//         const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
//         if (!ifscRegex.test(value)) error = "Invalid IFSC format";
//       }
//       break;

//     case "bankName":
//       if (!value) error = "Enter bank name";
//       break;

//     case "authorisedName":
//       if (!value) error = "Authorised person is required";
//       break;

//     case "agreed":
//       if (!value) error = "You must accept the agreement to continue";
//       break;

//     default:
//       break;
//   }

//   setErrors((prev) => ({ ...prev, [field]: error }));
//   return error === "";
// };

// // ---------------- PAN VALIDATION FUNCTION ----------------
// const isValidPAN = (pan) => {
//   const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
//   return panRegex.test(pan);
// };

//   useEffect(() => {
//     const sessionData = localStorage.getItem("authUserData");
//     if (!sessionData) return;

//     const user = JSON.parse(sessionData);

//     if (Number(user?.pan_verified) === 1) {
//       const panFromSession =
//         user?.pan_number ||
//         user?.pan ||
//         (user?.pan_json ? JSON.parse(user.pan_json)?.pan : "");

//       setForm(prev => ({
//         ...prev,
//         panNumber: panFromSession,
//         panVerified: true,
//       }));

//       if (user?.pan_json) {
//         setPanApiResponse(JSON.parse(user.pan_json));
//       }
//     }
//   }, []);


// // ---------------- PAN VERIFY API CALL ----------------
//   const verifyPAN = async () => {
//     if (!form.panNumber) return;
//     if (!isValidPAN(form.panNumber)) {
//       validateField("panNumber", form.panNumber);
//       return;
//     }

//     try {
//       setLoading(true);

//       const payload = {
//         pan: form.panNumber,
//         verification_id: authUser?.company_code,
//         name: authUser?.contact_person,
//       };

//       const response = await fetch(`${SWAGGER_URL}/Cashfree/pan-advance`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           AppId: APPID,
//           SecretKey: SecretKey,
//         },
//         body: JSON.stringify(payload),
//       });

//       const data = await response.json();

//       if (response.ok && data?.status === "VALID") {

//         updateField("panVerified", true);

//         // 🔥 store full response in parent onboarding
//         setPanApiResponse(data);

//         toast.success(data?.message || "PAN Verified Successfully!");
//       } else {
//         toast.error(data?.message || "Verification Failed.");
//       }
//     } catch (error) {
//       toast.error("Something went wrong.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//   const sessionData = localStorage.getItem("authUserData");
//   if (sessionData) {
//     const user = JSON.parse(sessionData);

//     // Pre-fill GST / Business details
//     setForm(prev => ({
//       ...prev,
//       gstTreatment: user.business_type || "",       // regular, composition, unregistered
//       gstin: user.gst || user.pan || "",         // GSTIN or PAN if unregistered
//       businessName: user.business_name || "",
//       tradeName: user.trade_name || "",
//     }));
//   }
// }, []);

// useEffect(() => {
//   const sessionData = localStorage.getItem("authUserData");
//   if (!sessionData) return;

//   const user = JSON.parse(sessionData);

//   // ---------------- UNREGISTERED ----------------
//   if (form.gstTreatment === "unregistered") {
//     setForm(prev => ({
//       ...prev,
//       gstin: prev.panNumber || "",
//     }));

//     setGstVerified(true); // no verification needed
//     setGstResponse(null);
//     return;
//   }

//   // ---------------- REGISTERED ----------------
//   if (form.gstTreatment === "registered") {
//     // ✅ If GST already verified in session → auto restore
//     if (user?.gst_verified === 1 && user?.gst_json) {
//       const gstData = JSON.parse(user.gst_json);

//       setGstVerified(true);
//       setGstResponse(gstData);

//       setForm(prev => ({
//         ...prev,
//         gstin: user.gst,
//         businessName: user.business_name,
//         tradeName: user.trade_name,
//         taxpayerType: gstData.taxpayer_type || "",
//       }));
//     } else {
//       // ❌ Only reset if NOT verified earlier
//       setGstVerified(false);
//       setGstResponse(null);

//       setForm(prev => ({
//         ...prev,
//         gstin: "",
//         businessName: "",
//         tradeName: "",
//         taxpayerType: "",
//       }));
//     }
//   }
// }, [form.gstTreatment]);




// const verifyGST = async () => {
//   if (!form.gstin) {
//     toast.error("Enter GSTIN and Business Name");
//     return;
//   }

//   try {
//     setGstLoading(true);

//     const res = await fetch(`${SWAGGER_URL}/Cashfree/gstin-verify`, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         AppId: APPID,
//         SecretKey: SecretKey,
//       },
//       body: JSON.stringify({
//         gstin: form.gstin,
//         name: form.businessName,
//       }),
//     });

//     const data = await res.json();

//     if (res.ok && data?.valid === true && data?.message === "GSTIN Exists") {
//       toast.success("GST Verified Successfully");

//       setGstVerified(true);
//       setGstResponse(data);

//       // 🔥 Auto-fill names from GST
//       setForm(prev => ({
//         ...prev,
//         gstin: data.GSTIN,
//         businessName: data.legal_name_of_business,
//         tradeName: data.trade_name_of_business || "",
//         taxpayerType: data.taxpayer_type || "",
//       }));
//     } else {
//       toast.error(data?.message || "GST Verification Failed");
//       setGstVerified(false);
//     }

//   } catch (err) {
//     toast.error("GST verification failed");
//   } finally {
//     setGstLoading(false);
//   }
// };

// const verifyBankAccount = async () => {
//   if (!form.accountNumber || !form.ifsc) {
//     toast.error("Enter account number and IFSC");
//     return;
//   }

//   try {
//     setBankLoading(true);

//     const res = await fetch(`${SWAGGER_URL}/Cashfree/bank-verify-v2`, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         AppId: APPID,
//         SecretKey: SecretKey,
//       },
//       body: JSON.stringify({
//         bank_account: form.accountNumber,
//         ifsc: form.ifsc,
//         name: form.businessName,
//         phone: form.phone,
//       }),
//     });

//     const data = await res.json();

//     if (res.ok && data.account_status_code === "ACCOUNT_IS_VALID") {
//       toast.success("Bank account verified successfully");

//       setBankVerified(true);
//       setBankResponse(data);

//       // 🔥 Autofill
//       setForm(prev => ({
//         ...prev,
//         bankName: data.bank_name || data.ifsc_details?.bank || "",
//         branchname: data.branch || data.ifsc_details?.branch || "",
//         ifsc: data.ifsc_details?.ifsc || prev.ifsc,
//       }));
//     } else {
//       toast.error("Enter valid account details");
//       setBankVerified(false);
//       setBankResponse(null);
//     }
//   } catch (err) {
//     toast.error("Bank verification failed");
//   } finally {
//     setBankLoading(false);
//   }
// };



// useEffect(() => {
//   if (form.gstTreatment === "unregistered" && form.panNumber) {
//     setForm(prev => ({
//       ...prev,
//       gstin: form.panNumber,
//     }));
//     setGstVerified(true); // no verification needed
//   }
// }, [form.gstTreatment, form.panNumber]);

// useEffect(() => {
//   const sessionData = localStorage.getItem("authUserData");
//   if (!sessionData) return;

//   const user = JSON.parse(sessionData);

//   if (user?.gst_verified === 1 && user?.gst_json) {
//     setGstVerified(true);
//     setGstResponse(JSON.parse(user.gst_json));

//     setForm(prev => ({
//       ...prev,
//       gstin: user.gst,
//       businessName: user.business_name,
//       tradeName: user.trade_name,
//     }));
//   }
// }, []);


//   useEffect(() => {
//   const sessionData = localStorage.getItem("authUserData");
//   if (!sessionData) return;

//   const user = JSON.parse(sessionData);

//   if (user?.bank_verified === 1 && user?.bank_json) {
//     const bankData = JSON.parse(user.bank_json);

//     setBankVerified(true);
//     setBankResponse(bankData);

//     setForm(prev => ({
//       ...prev,
//       accountNumber: user.account_no,
//       ifsc: user.ifsc_code,
//       bankName: user.bank_name,
//       branchname: user.branch_name,
//     }));
//   }
// }, []);



// useEffect(() => {
//   const sessionData = localStorage.getItem("authUserData");
//   if (sessionData) {
//     const user = JSON.parse(sessionData);

//     setForm(prev => ({
//       ...prev,
//       accountType: user.account_type || "",
//       accountNumber: user.account_no || "",
//       ifsc: user.ifsc_code || "",
//       branchname: user.branch_name || "",
//       bankName: user.bank_name || "",
//       authorisedName: user.business_name || "",
//       // Optional: you can pre-fill bankProofType if you store it
//     }));
//   }
// }, []);



//   const handleChange = (field, value) => {
//     if (field === "gstin" || field === "ifsc") value = value.toUpperCase();

//     // 🔥 Autofill logic: when business name is entered, set authorisedName same
//     if (field === "businessName") {
//       updateField("authorisedName", value);
//     }

//     updateField(field, value);
//     validateField(field, value);
//   };


//   // const handlePayment = () => {
//   //   if (!selectedPackage) return;

//   //   if (!paymentKeys.key_id) {
//   //     alert("Payment keys not loaded!");
//   //     return;
//   //   }

//   //   const options = {
//   //     key: paymentKeys.key_id,
//   //     key_secret: paymentKeys.key_secret, // Razorpay does NOT use this on frontend
//   //     amount: selectedPackage.amount * 100,
//   //     id:"order_LKsdf98asfa",
//   //     currency: "INR",
//   //     name: "GO Electronix",
//   //     description: selectedPackage.package_name,
//   //     handler: function (response) {
//   //       alert("Payment Successful 🎉");
//   //       console.log("Payment ID:", response.razorpay_payment_id);
//   //       console.log("Order ID:", response.razorpay_order_id);
//   //       console.log("Signature:", response.razorpay_signature);
//   //     },
//   //     prefill: {
//   //       name: authUser?.name || "",
//   //       email: authUser?.email || "",
//   //       contact: authUser?.mobile || "",
//   //     },
//   //     theme: { color: "#2563eb" },
//   //   };

//   //   const rzp = new window.Razorpay(options);
//   //   rzp.open();
//   // };

//   const uiStep =
//   role === 2 || role === 4
//     ? currentStep > 2
//       ? currentStep - 1
//       : currentStep
//     : currentStep;

//   const handlePayment = () => {
//   if (!selectedPackage) return;

//   if (!paymentKeys.key_id) {
//     alert("Payment keys not loaded!");
//     return;
//   }

//   const options = {
//     key: paymentKeys.key_id,
//     amount: selectedPackage.amount * 100, 
//     currency: "INR",
//     name: "GO Electronix",
//     description: selectedPackage.package_name,

//     handler: async function (response) {
//       const paymentId = response.razorpay_payment_id;
//       const orderId = response.razorpay_order_id;
//       const signature = response.razorpay_signature;

//       console.log("Payment Success:", response);

//       // Disable button after payment success
//       setPaymentCompleted(true);

//       // ---------- SESSION DATA ----------
//       const company_id = authUser?.company_id;
//       const lead_id = authUser?.leads?.[0]?.lead_code;
//       const zoho_id = authUser?.zoho_id;
//       const role = authUser?.role;
//       const payload = {
//         company_id,
//         lead_id,
//         payment_id: paymentId,
//         amount: selectedPackage.amount,
//         status: response,
//         payment_date: new Date().toISOString().slice(0, 19).replace("T", " "),
//         customer_id: zoho_id,
//         payment_from: "WARRANTY",
//         notes: selectedPackage.package_name,
//         role,
//       };

//       try {
//         const res = await fetch(`${BASE_URL}zoho/create-online-payment`, {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(payload),
//         });

//         const data = await res.json();
//         console.log("Callback Response:", data);

//         if (!res.ok) {
//           toast.error("Payment saved but server rejected callback!");
//           return;
//         }

//         toast.success("Payment Successful & Saved in Zoho 🎉");
//         // ✅ mark payment success in parent (RetailerOnboarding)
//         setIsPaymentSuccess(true);

//       } catch (err) {
//         console.error(err);
//         toast.error("Payment succeeded but failed to update Zoho!");
//       }
//     },


//       prefill: {
//         name: authUser?.name || "",
//         email: authUser?.contact_email || "",
//         contact: authUser?.contact_phone || "",
//       },

//       theme: { color: "#2563eb" },
//     };

//     const rzp = new window.Razorpay(options);
//     rzp.open();
//   };


//   // const handlePaymentSuccess = async () => {
//   //   const payload = {
//   //     retailer_id: authUser?.id,
//   //     status: "payment_done",
//   //     package_id: selectedPackage.id,
//   //   };

//   //   await postStepUpdate(payload, "Payment Step");
//   // };

//   useEffect(() => {
//     if (currentStep === 2) fetchPackages();
//   }, [currentStep]);

//   const fetchPackages = async () => {
//     try {
//       setLoading(true);
//       const res = await fetch(`${BASE_URL}packages`);
//       const data = await res.json();
//       setPackages(data || []);
//     } catch (err) {
//       toast.error("Failed to load packages");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (
//       !loading &&
//       packages.length > 0 &&
//       authUser?.leads?.length > 0 &&
//       !selectedPackage  // <-- Prevent overwriting user selection
//     ) {
//       const assignedPackageId = authUser.leads[0].package_id;
//       const foundPackage = packages.find(p => p.id === assignedPackageId);

//       if (foundPackage) setSelectedPackage(foundPackage);
//     }
//   }, [loading, packages, authUser, selectedPackage]);

//   const handleUpload = async () => {
//   if (!form.bankProofFile || !form.bankProofType) {
//     toast.error("Please select file and type");
//     return;
//   }

//   try {
//     setUploading(true); // start loading

//     const formData = new FormData();
//     formData.append("flag", form.bankProofType);
//     formData.append("file", form.bankProofFile);
//     formData.append("email", form.email);

//     const res = await fetch(`${BASE_URL}user/upload-file`, {
//       method: "POST",
//       body: formData,
//     });

//     const data = await res.json();

//     if (data.status) {
//       toast.success("File uploaded successfully!");
//       setIsUploaded(true);
//     } else {
//       toast.error(data.message || "Upload failed");
//     }
//   } catch (error) {
//     console.error(error);
//     toast.error("Something went wrong.");
//   } finally {
//     setUploading(false); // stop loading
//   }
// };

//   const fetchAgreement = async () => {
//     try {
//       const response = await fetch(`${BASE_URL}agreement/${role}/${id}`, {
//         method: "GET",
//         headers: {
//           "Content-Type": "application/json",
//           // Authorization: `Bearer ${token}`,/ // include only if API needs it
//         },
//       });

//       const data = await response.json();

//       if (data?.status && data?.download_url) {
//         setAgreementUrl(data.download_url);
//       } else {
//         toast.error("Failed to fetch agreement.");
//       }
//     } catch (err) {
//       console.error(err);
//       toast.error("Server error while fetching agreement.");
//     }
//   };

//   useEffect(() => {
//     if (currentStep === 6 && !agreementUrl) {
//       fetchAgreement();
//     }
//   }, [currentStep]);

//   const handleAgreementCheck = (checked) => {
//     handleChange("agreed", checked);

//     if (checked && hasScrolledToBottom) {
//       updateField("esignVerified", 1);
//     } else {
//       updateField("esignVerified", 0);
//     }
//   };

//   useEffect(() => {
//     if (bankResponse?.name_at_bank && !form.authorisedName) {
//       updateField("authorisedName", bankResponse.name_at_bank);
//     }
//   }, [bankResponse]);

//   const handleEsignClick = async () => {
//     const link = await verifyAadhaar();

//     if (link) {
//       window.open(
//         link,
//         "_blank",
//         "width=600,height=900,resizable=yes,scrollbars=yes"
//       );
//     }
//   };



//   // ---------------- Render ----------------
//   return (
//     <div className="space-y-6">
//       {/* STEP 1 : EMAIL + PHONE VERIFICATION */}
//       {currentStep === 1 && (
//         <section className="space-y-8">
//           {/* ---------------- Store Address ---------------- */}
//           <div className="space-y-4">
//             <h2 className="text-lg font-semibold text-slate-900">Store Address</h2>
//             <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
//               <InputField
//                 label="State"
//                 value={form.state}
//                 onChange={(value) => handleChange("state", value)}
//                 placeholder="Enter state"
//               />
//               <InputField
//                 label="District"
//                 value={form.district}
//                 onChange={(value) => handleChange("district", value)}
//                 placeholder="Enter district"
//               />
//               <InputField
//                 label="City"
//                 value={form.city}
//                 onChange={(value) => handleChange("city", value)}
//                 placeholder="Enter city"
//               />
//               <InputField
//                 label="Pincode"
//                 required
//                 value={form.pincode}
//                 onChange={(value) => handleChange("pincode", value)}
//                 placeholder="Enter pincode"
//               />
//             </div>

//             <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//               <InputField
//                 label="Address Line 1"
//                 required
//                 value={form.address_line1}
//                 onChange={(value) => handleChange("address_line1", value)}
//                 placeholder="Shop / Building / Street"
//               />
//               <InputField
//                 label="Address Line 2"
//                 value={form.address_line2}
//                 onChange={(value) => handleChange("address_line2", value)}
//                 placeholder="Landmark (Optional)"
//               />
//             </div>
//           </div>

//           {/* ---------------- Contact Verification ---------------- */}
//           <div className="space-y-4">
//             <h2 className="text-lg font-semibold text-slate-900">Verify Email & Phone</h2>

//             {/* EMAIL */}
//             <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-end">
//               {emailVerified ? (
//                <div className="col-span-4 md:col-span-1 flex flex-col gap-2 p-2 bg-green-50 border border-green-300 rounded-md">
//                   <p className="text-green-700 font-medium">
//                       ✔ Email Verified: <span className="font-semibold">{form.email}</span>
//                     </p>
//                   </div>
//               ) : (
//                 <>
//                   <InputField
//                     label="Email"
//                     required
//                     value={form.email}
//                     onChange={(value) => handleEmailChange(value)}
//                     placeholder="Enter your email"
//                     error={errors.email}
//                   />

//                   {/* ⏳ UPDATED BUTTON WITH TIMER */}
//                   <button
//                     onClick={sendEmailOtp}
//                     disabled={resendEmailTimer > 0}
//                     className={`h-[42px] md:w-[120px] rounded-lg text-sm text-white transition
//                     ${resendEmailTimer > 0 ? "bg-gray-400 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700"}`}
//                   >
//                     {resendEmailTimer > 0
//                       ? `Resend in ${Math.floor(resendEmailTimer / 60)}:${String(resendEmailTimer % 60).padStart(2, "0")}`
//                       : emailOtpSent
//                       ? "Resend OTP"
//                       : "Send OTP"}
//                   </button>

//                   {emailOtpSent && (
//                     <>
//                       <InputField
//                         label="Email OTP"
//                         value={emailOtp}
//                         onChange={(v) => setEmailOtp(v)}
//                         placeholder="Enter OTP"
//                       />
//                       <button
//                         onClick={verifyEmailOtp}
//                         className="h-[42px] md:w-[120px] bg-green-600 text-white rounded-lg text-sm"
//                       >
//                         Verify
//                       </button>
//                     </>
//                   )}
//                 </>
//               )}

//             </div>
//             {/* {emailVerified && <p className="text-green-600 text-sm">✔ Email verified successfully</p>} */}

//             {/* PHONE */}
//             <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-end">
//               {!phoneVerified && (
//               <InputField
//                 label="Phone"
//                 required
//                 value={form.phone}
//                 onChange={(value) => handleChange("phone", value)}
//                 placeholder="Enter phone number"
//                 error={errors.phone}
//               />
//               )}
//               {/* If phone already verified */}
//               {phoneVerified ? (
//                 <div className="col-span-4 md:col-span-1 flex flex-col gap-2 p-2 bg-green-50 border border-green-300 rounded-md">
//                   <p className="text-green-700 font-medium">
//                     ✔ Phone verified successfully : <span className="font-semibold">{form.phone}</span>
//                   </p>
//                 </div>
//               ) : (
//                 <>
//                   {!phoneVerified && (
//                     <button
//                       onClick={sendPhoneOtp}
//                       disabled={!emailVerified || resendTimer > 0 || sendingOtp}
//                       className={`h-[42px] md:w-[120px] rounded-lg text-sm text-white
//                         ${!emailVerified || resendTimer > 0 || sendingOtp ? "bg-gray-300 cursor-not-allowed" : "bg-blue-600"}`}
//                     >
//                       {sendingOtp
//                         ? "Sending..."
//                         : resendTimer > 0
//                         ? `Resend in ${Math.floor(resendTimer / 60)}:${String(resendTimer % 60).padStart(2, "0")}`
//                         : phoneOtpSent
//                         ? "Resend OTP"
//                         : "Send OTP"}
//                     </button>
//                   )}
//                   {phoneOtpSent && !phoneVerified && (
//                     <InputField
//                       label="Phone OTP"
//                       value={phoneOtp}
//                       onChange={(v) => {
//                         setPhoneOtp(v);
//                         localStorage.setItem("phoneOtp", v); // persist typed OTP
//                       }}
//                       placeholder="Enter OTP"
//                     />

//                   )}
//                   {phoneOtpSent && !phoneVerified && (
//                     <button
//                       onClick={verifyPhoneOtp}
//                       disabled={verifyingOtp}
//                       className={`h-[42px] md:w-[120px] rounded-lg text-sm text-white
//                         ${verifyingOtp ? "bg-gray-300 cursor-not-allowed" : "bg-green-600"}`}
//                     >
//                       {verifyingOtp ? "Verifying..." : "Verify"}
//                     </button>

//                   )}
//                 </>
//               )}
//             </div>

//             {/* {phoneVerified && <p className="text-green-600 text-sm">✔ Phone verified successfully</p>} */}
//           </div>
//         </section>
//       )}

//       {/* STEP 2 - Payment */}
//       {uiStep === 2 && role === 5 && (
//         <section className="p-4">
//           <h2 className="text-lg font-semibold text-slate-900 mb-4 text-left">
//             Choose Your Package
//           </h2>

//           {loading || keyLoading ? (
//             <RegularLoader />
//           ) : (
//             <>
//               {packages.length === 0 && (
//                 <p className="text-center text-red-600">No packages available.</p>
//               )}

//               {packages.length > 0 && (
//                 <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-3 max-h-[70vh] overflow-y-auto">

//                   {packages.map((pkg) => (
//                     <div
//                       key={pkg.id}
//                       onClick={() => setSelectedPackage(pkg)}
//                       className={`cursor-pointer border rounded-xl p-4 shadow-sm transition duration-200 
//                         ${
//                           selectedPackage?.id === pkg.id
//                             ? "border-blue-600 bg-blue-50"
//                             : "border-gray-300 hover:border-blue-400 hover:bg-blue-50"
//                         }
//                       `}
//                     >
                      
//                       {authUser?.leads?.[0]?.package_id === pkg.id && (
//                         <span className="text-[10px] ml-2 text-blue-600 font-semibold">(Assigned)</span>
//                       )}
//                       {/* Title */}
//                       <h4 className="text-lg font-semibold text-gray-800">
//                         {pkg.package_name}
//                         <span className="text-blue-700"> (₹{pkg.amount})</span>
//                       </h4>

//                       {/* Validity */}
//                       <p className="text-xs text-gray-500">Validity: {pkg.validity_days} Days</p>

//                       {/* Badge Section */}
//                       {pkg.badge && (
//                         <div className="mt-3 p-2 rounded-lg border border-gray-200">

//                           <span className="text-xs font-semibold bg-blue-200 text-blue-800 px-2 py-1 rounded">
//                             {pkg.badge.name}
//                           </span>

//                           <p className="text-xs text-gray-700 mt-2">
//                             {pkg.badge.description}
//                           </p>

//                           <div className="text-xs text-gray-700 mt-2 space-y-1">
//                             <p><span className="font-semibold">Eligibility:</span> {pkg.badge.eligibility} Users</p>
//                             <p><span className="font-semibold">Benefits:</span> {pkg.badge.benefits}% Extra</p>
//                           </div>

//                         </div>
//                       )}
//                     </div>
//                   ))}
//                 </div>
//               )}

//               {/* Payment Button Centered */}
//               <div className="flex justify-center mt-6">
//                 <button
//                   disabled={!selectedPackage || paymentCompleted}
//                   onClick={handlePayment}
//                   className={`px-6 py-2.5 rounded-lg text-sm font-medium transition
//                     ${
//                       !selectedPackage || paymentCompleted
//                         ? "bg-slate-300 text-slate-500 cursor-not-allowed"
//                         : "bg-blue-600 text-white hover:bg-blue-700"
//                     }`}
//                 >
//                   {paymentCompleted
//                     ? "Payment Completed ✔"
//                     : selectedPackage
//                     ? `Proceed to Pay ₹${selectedPackage.amount}`
//                     : "Select a Package to Continue"}
//                 </button>
//               </div>
//             </>
//           )}
//         </section>
//       )}

//       {/* ------- The rest of your steps remain UNCHANGED ------- */}

//       {((uiStep === 2 && role !== 5) || (uiStep === 3 && role === 5)) && (
//         <section>
//           <h2 className="text-lg font-semibold text-slate-900 mb-4">
//             Authorized Person PAN Verification
//           </h2>

//           <div className="grid gap-4 md:grid-cols-2">
//             <InputField
//               label="PAN Number"
//               value={form.panNumber}
//               disabled={form.panVerified} // ✅ disable if already verified
//               readOnly={form.panVerified}
//               className={`${form.panVerified ? "bg-gray-100 text-gray-500 cursor-not-allowed" : ""}`}
//               onChange={(val) => !form.panVerified && updateField("panNumber", val.toUpperCase())}
//               onBlur={() => validateField("panNumber", form.panNumber)}
//               placeholder="ABCDE1234F"
//               error={errors.panNumber}
//             />

//             <div className="flex items-end">
//               <button
//                 onClick={verifyPAN}
//                 disabled={
//                   form.panVerified || // ✅ already verified
//                   !form.panNumber ||
//                   !isValidPAN(form.panNumber) ||
//                   loading
//                 }
//                 className={`px-4 py-2 rounded-lg transition text-white w-full md:w-auto
//                   ${form.panVerified ? "bg-green-600 cursor-default" : "bg-blue-600 hover:bg-blue-700 disabled:bg-gray-400"}
//                 `}
//               >
//                 {form.panVerified ? "Verified ✓" : loading ? "Verifying..." : "Verify PAN"}
//               </button>
//             </div>
//           </div>

//           {/* PAN verification message */}
//           {panMessage && (
//             <p className={`text-xs mt-2 font-medium ${form.panVerified ? "text-green-600" : "text-red-500"}`}>
//               {panMessage}
//             </p>
//           )}

//           {/* Show verified PAN details if available */}
//           {form.panVerified && panApiResponse && (
//             <div className="mt-6 border rounded-lg p-4 bg-green-50">
//               <h3 className="text-md font-semibold text-green-700 mb-3">
//                 PAN Details Verified ✓
//               </h3>

//               <div className="grid md:grid-cols-2 gap-3 text-sm">
//                 <p><strong>PAN:</strong> {panApiResponse.pan}</p>
//                 <p><strong>Name:</strong> {panApiResponse.name_pan_card}</p>
//                 <p><strong>Gender:</strong> {panApiResponse.gender}</p>
//                 <p><strong>DOB:</strong> {panApiResponse.date_of_birth}</p>
//                 <p><strong>Mobile:</strong> {panApiResponse.mobile_number}</p>
//                 <p><strong>Email:</strong> {panApiResponse.email}</p>
//                 <p><strong>Aadhaar Linked:</strong> {panApiResponse.aadhaar_linked ? "Yes" : "No"}</p>
//                 <p><strong>City:</strong> {panApiResponse.address?.city}</p>
//                 <p><strong>State:</strong> {panApiResponse.address?.state}</p>
//                 <p><strong>Pincode:</strong> {panApiResponse.address?.pincode}</p>
//                 <p><strong>Type:</strong> {panApiResponse.type}</p>
//               </div>

//               <p className="mt-2 text-xs text-gray-600">
//                 <strong>Full Address:</strong> {panApiResponse.address?.full_address}
//               </p>
//             </div>
//           )}
//         </section>
//       )}

//       {uiStep === 3 && (
//         <section>
//           <h2 className="text-lg font-semibold text-slate-900 mb-4">GST details</h2>
//           <div className="grid gap-4 md:grid-cols-2">
//             <SelectField
//               label="GST Type"
//               required
//               value={form.gstTreatment}
//               onChange={(value) => handleChange("gstTreatment", value)}
//               options={[
//                 { value: "registered", label: "Registered" },
//                 { value: "unregistered", label: "Unregistered" },
//               ]}
//               error={errors.gstTreatment}
//             />


//             <InputField
//               label={form.gstTreatment === "unregistered" ? "PAN Number" : "GSTIN"}
//               required
//               value={form.gstin}
//               readOnly={form.gstTreatment === "unregistered"}
//               onChange={(value) => handleChange("gstin", value)}
//               placeholder={
//                 form.gstTreatment === "unregistered"
//                   ? "PAN auto-filled"
//                   : "22AAAAA0000A1Z5"
//               }
//             />


//           </div>

//           {gstVerified && gstResponse && (
//             <div className="mt-4 grid gap-4 md:grid-cols-3">
//               <InputField
//                 label="Business Legal Name"
//                 value={form.businessName}
//                 readOnly
//               />

//               <InputField
//                 label="Trade Name"
//                 value={form.tradeName}
//                 readOnly
//               />

//               <InputField
//                 label="Taxpayer Type"
//                 value={form.taxpayerType}
//                 readOnly
//               />
//             </div>
//           )}


//           {form.gstTreatment === "registered" && (
//             <button
//               type="button"
//               onClick={verifyGST}
//               disabled={gstVerified || gstLoading}
//               className={`mt-2 px-4 py-2 rounded-lg text-sm text-white
//                 ${gstVerified ? "bg-green-600" : "bg-blue-600 hover:bg-blue-700"}
//               `}
//             >
//               {gstVerified ? "Verified ✓" : gstLoading ? "Verifying..." : "Verify GST"}
//             </button>
//           )}


//           {gstVerified && gstResponse && (
//             <div className="mt-4 border rounded-lg p-4 bg-green-50 text-sm">
//               <h3 className="font-semibold text-green-700 mb-2">
//                 GST Details Verified ✓
//               </h3>

//               <div className="grid md:grid-cols-2 gap-2">
//                 <p><strong>GSTIN:</strong> {gstResponse.GSTIN}</p>
//                 <p><strong>Status:</strong> {gstResponse.gst_in_status}</p>
//                 <p><strong>Taxpayer Type:</strong> {gstResponse.taxpayer_type}</p>
//                 <p><strong>Legal Name:</strong> {gstResponse.legal_name_of_business}</p>
//                 <p><strong>Trade Name:</strong> {gstResponse.trade_name_of_business}</p>
//                 <p><strong>Registration Date:</strong> {gstResponse.date_of_registration}</p>
//                 <p><strong>State Jurisdiction:</strong> {gstResponse.state_jurisdiction}</p>
//                 <p><strong>Center Jurisdiction:</strong> {gstResponse.center_jurisdiction}</p>
//               </div>

//               {/* Address */}
//               <div className="mt-3">
//                 <p className="font-semibold">Principal Place of Business</p>
//                 <p className="text-gray-700">
//                   {gstResponse.principal_place_address}
//                 </p>
//               </div>

//               {/* Nature of Business */}
//               {Array.isArray(gstResponse.nature_of_business_activities) && (
//                 <div className="mt-3">
//                   <p className="font-semibold">Nature of Business</p>
//                   <ul className="list-disc ml-5 text-gray-700">
//                     {gstResponse.nature_of_business_activities.map((item, idx) => (
//                       <li key={idx}>{item}</li>
//                     ))}
//                   </ul>
//                 </div>
//               )}
//             </div>
//           )}
//         </section>
//       )}

//       {uiStep === 4 && (
//         <section>
//           <h2 className="text-lg font-semibold text-slate-900 mb-4">
//             Bank account details
//           </h2>

//           <div className="grid gap-4 md:grid-cols-3">
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 Account Type
//               </label>
//               <select
//                 className="border rounded-lg p-2 w-full"
//                 value={form.accountType}
//                 onChange={(e) => handleChange("accountType", e.target.value)}
//                 // disabled={!!form.accountType} // optional read-only if already present
//               >
//                 <option value="">Select Account Type</option>
//                 <option value="current">Current</option>
//                 <option value="saving">Saving</option>
//               </select>
//             </div>

//             <InputField
//               label="Account Number"
//               required
//               value={form.accountNumber}
//               onChange={(value) => handleChange("accountNumber", value)}
//               placeholder="Enter account number"
//               error={errors.accountNumber}
//               readOnly={bankVerified} // optional
//             />

//             <InputField
//               label="IFSC Code"
//               required
//               value={form.ifsc}
//               onChange={(value) => handleChange("ifsc", value)}
//               placeholder="e.g. HDFC0001234"
//               error={errors.ifsc}
//               readOnly={bankVerified} // optional
//             />
//           </div>

//           {bankVerified && bankResponse && (
//             <div className="grid gap-4 md:grid-cols-3 mt-4">
//               <InputField
//                 label="Branch Name"
//                 value={form.branchname}
//                 readOnly
//               />

//               <InputField
//                 label="Bank Name"
//                 value={form.bankName}
//                 readOnly
//               />

//               <InputField
//                 label="Authorized Person Name"
//                 value={form.authorisedName}
//                 readOnly
//               />
//             </div>
//           )}
          
//           <div className="grid gap-4 md:grid-cols-2 mt-6">
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 Upload Proof (Select One)
//               </label>
//               <select
//                 className="border rounded-lg p-2 w-full"
//                 value={form.bankProofType}
//                 onChange={(e) => handleChange("bankProofType", e.target.value)}
//               >
//                 <option value="">Select Document Type</option>
//                 <option value="passbook">Passbook Photo</option>
//                 <option value="cheque">Cancelled Cheque</option>
//               </select>
//             </div>

//             {form.bankProofType && (
//               <div className="p-4 border border-gray-300 rounded-lg">
//                 <p className="text-sm text-gray-600 mb-3">
//                   Upload:{" "}
//                   <span className="font-semibold">
//                     {form.bankProofType === "passbook" ? "Passbook Photo" : "Cancelled Cheque"}
//                   </span>
//                 </p>

//                 <div className="flex items-center gap-3 mt-2">
//                   <input
//                     type="file"
//                     accept="image/*,application/pdf"
//                     onChange={(e) => handleChange("bankProofFile", e.target.files[0])}
//                     className="w-full text-sm"
//                   />
//                   <BlueButton
//                     onClick={handleUpload}
//                     disabled={
//                       !form.bankProofFile ||
//                       !form.bankProofType ||
//                       uploading ||
//                       isUploaded   // ⬅️ disabled after success
//                     }
//                   >
//                     {isUploaded ? "Uploaded" : uploading ? "Uploading..." : "Upload"}
//                   </BlueButton>


//                 </div>

//                 {form.bankProofFile && (
//                   <p className="text-green-600 text-sm mt-2">
//                     File selected: {form.bankProofFile.name}
//                   </p>
//                 )}
//               </div>
//             )}

//           </div>

//           <button
//             type="button"
//             onClick={verifyBankAccount}
//             disabled={bankVerified || bankLoading}
//             className={`mt-5 px-4 py-2 rounded-lg text-sm text-white
//               ${bankVerified ? "bg-green-600" : "bg-blue-600 hover:bg-blue-700"}
//             `}
//           >
//             {bankVerified ? "Verified ✓" : bankLoading ? "Verifying..." : "Verify Account"}
//           </button>

//           {bankVerified && bankResponse && (
//             <div className="mt-4 border rounded-lg p-4 bg-green-50 text-sm">
//               <h3 className="font-semibold text-green-700 mb-2">
//                 Bank Account Verified ✓
//               </h3>

//               <div className="grid md:grid-cols-2 gap-2">
//                 <p><strong>Account Status:</strong> {bankResponse.account_status}</p>
//                 <p><strong>Bank Name:</strong> {bankResponse.bank_name}</p>
//                 <p><strong>Branch:</strong> {bankResponse.branch}</p>
//                 <p><strong>City:</strong> {bankResponse.city}</p>
//                 <p><strong>IFSC:</strong> {bankResponse.ifsc_details?.ifsc}</p>
//                 <p><strong>MICR:</strong> {bankResponse.micr}</p>
//                 <p><strong>UTR:</strong> {bankResponse.utr}</p>
//                 <p><strong>Name at Bank:</strong> {bankResponse.name_at_bank}</p>
//               </div>
//             </div>
//           )}

//         </section>
//       )}

//       {uiStep === 5 && (
//         <section>
//           <h2 className="text-lg font-semibold text-slate-900 mb-4">
//             Sign User Agreement
//           </h2>

//           {agreementUrl ? (
//             <div className="flex justify-center min-h-screen bg-white">
//               <div className="bg-slate-50 border p-2 rounded-xl text-xs text-slate-600 flex flex-col gap-3 max-w-[800px] w-full items-center shadow-md">
//                 <div
//                   ref={scrollRef}
//                   onScroll={handleScroll}
//                   className="border rounded-xl bg-white shadow-inner p-2 w-full h-[700px] overflow-y-auto"
//                 >
//                   <iframe
//                     src={`https://docs.google.com/viewer?url=${agreementUrl}&embedded=true`}
//                     title="Agreement PDF"
//                     className="w-full h-[1400px]"
//                   />
//                 </div>

//                 <a
//                   href={agreementUrl}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="text-blue-600 underline font-medium text-sm"
//                 >
//                   Download Agreement PDF
//                 </a>
//               </div>
//             </div>
//           ) : (
//             <RegularLoader />
//           )}

//           {/* Agreement Checkbox */}
//           <label className="mt-4 flex items-start gap-2">
//             <input
//               type="checkbox"
//               className="mt-1 w-4 h-4"
//               checked={form.agreed}
//               disabled={!hasScrolledToBottom}
//               onChange={(e) => handleAgreementCheck(e.target.checked)}
//             />
//             <span
//               className={`text-sm ${
//                 !hasScrolledToBottom ? "text-gray-400" : "text-slate-700"
//               }`}
//             >
//               I agree to the user agreement.
//             </span>
//           </label>

//           {!hasScrolledToBottom && (
//             <p className="text-xs text-red-500 mt-1">
//               Scroll to the bottom to enable agreement.
//             </p>
//           )}
//         </section>
//       )}

//        {/* {currentStep === 7 && (
//           <section className="flex justify-center">
//             <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white/80 shadow-sm backdrop-blur p-6 flex flex-col items-center gap-5">

              
//               {!form.aadhaarVerified && (
//                 <>
                  
//                   <div className="flex items-center gap-3 w-full">
//                     <div className="shrink-0 rounded-xl p-3 bg-gradient-to-br from-sky-500/10 to-indigo-500/10">
//                       <img
//                         src={esign}
//                         alt="Aadhaar e-Sign"
//                         className="w-10 h-10 object-contain"
//                       />
//                     </div>
//                     <div className="flex-1">
//                       <h2 className="text-base md:text-lg font-semibold text-slate-900">
//                         Aadhaar e-Sign Verification
//                       </h2>
//                       <p className="text-xs text-slate-500">
//                         Enter the last 4 digits of your Aadhaar. We’ll open a secure e-Sign window.
//                       </p>
//                     </div>
//                   </div>

                 
//                   <div className="mt-2 flex justify-center w-full">
//                     <div className="flex gap-2">
//                       {Array.from({ length: 4 }).map((_, idx) => (
//                         <input
//                           key={idx}
//                           ref={(el) => (aadhaarInputsRef.current[idx] = el)}
//                           inputMode="numeric"
//                           pattern="[0-9]*"
//                           type="text"
//                           maxLength={1}
//                           value={form?.aadhaarLast4?.[idx] || ""}
//                           onChange={(e) => handleAadhaarBoxChange(idx, e.target.value)}
//                           onKeyDown={(e) => handleAadhaarKeyDown(idx, e)}
//                           disabled={form.aadhaarVerified}
//                           className="w-12 h-12 text-center text-lg font-semibold rounded-xl border border-slate-300 bg-white focus:outline-none focus:ring-2 focus:ring-sky-400 disabled:bg-slate-100"
//                         />
//                       ))}
//                     </div>
//                   </div>
//                 </>
//               )}

              
//               <div className="min-h-[18px] text-center text-xs">
//                 {aadhaarError ? (
//                   <span className="text-red-600">{aadhaarError}</span>
//                 ) : form.aadhaarVerified || aadhaarStatus === "success" ? (
//                   <>
//                  <div className="w-full max-w-md rounded-2xl shadow-sm p-6 flex flex-col items-center gap-5">
//                     <img
//                       src={verifiedimg} // make sure this points to your verified.avif file
//                       alt="e-Sign Verified"
//                       className="w-40 h-40 object-contain bg-transparent"
//                     />

//                   </div>


//                   <span className="text-green-600">Verified ✅ e-Sign completed</span>
//                   </>
                  
//                 ) : aadhaarStatus === "verifying" ? (
//                   <span className="text-slate-500">
//                     Waiting for you to complete e-Sign in the popup...
//                   </span>
//                 ) : (
//                   <span className="text-slate-500">
//                     We’ll redirect you to a secure UIDAI-compliant e-Sign partner.
//                   </span>
//                 )}
//               </div>

             
//               {!form.aadhaarVerified && (
//                 <button
//                   type="button"
//                   onClick={verifyAadhaar}
//                   disabled={
//                     !aadhaarValid ||
//                     form.aadhaarVerified ||
//                     aadhaarStatus === "loading" ||
//                     aadhaarStatus === "verifying"
//                   }
//                   className="w-full max-w-xs rounded-xl py-2.5 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 disabled:bg-slate-400"
//                 >
//                   {form.aadhaarVerified ? "e-Sign Verified" : "Verify & Open e-Sign"}
//                 </button>
//               )}

//               {!form.aadhaarVerified && (
//               <p className="text-[11px] text-center text-slate-500">
//                 By continuing, you consent to Aadhaar-based e-Sign for this agreement.
//               </p>
//               )}
//             </div>
//           </section>
//         )} */}

//       {uiStep === 6 && (
//         <section className="flex justify-center">
//           <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white/80 shadow-sm backdrop-blur p-6 flex flex-col items-center gap-5">

//             {/* Only show header & input boxes if NOT verified */}
//             {!form.aadhaarVerified && (
//               <>
//                 {/* Header */}
//                 <div className="flex items-center gap-3 w-full">
//                   <div className="shrink-0 rounded-xl p-3 bg-gradient-to-br from-sky-500/10 to-indigo-500/10">
//                     <img
//                       src={esign}
//                       alt="Aadhaar e-Sign"
//                       className="w-10 h-10 object-contain"
//                     />
//                   </div>
//                   <div className="flex-1">
//                     <h2 className="text-base md:text-lg font-semibold text-slate-900">
//                       Aadhaar e-Sign Verification
//                     </h2>
//                     <p className="text-xs text-slate-500">
//                       Enter the last 4 digits of your Aadhaar. We’ll open a secure e-Sign window.
//                     </p>
//                   </div>
//                 </div>

//                 {/* 4 Input Boxes */}
//                 <div className="mt-2 flex justify-center w-full">
//                   <div className="flex gap-2">
//                     {Array.from({ length: 4 }).map((_, idx) => (
//                       <input
//                         key={idx}
//                         ref={(el) => (aadhaarInputsRef.current[idx] = el)}
//                         inputMode="numeric"
//                         pattern="[0-9]*"
//                         type="text"
//                         maxLength={1}
//                         value={form?.aadhaarLast4?.[idx] || ""}
//                         onChange={(e) => handleAadhaarBoxChange(idx, e.target.value)}
//                         onKeyDown={(e) => handleAadhaarKeyDown(idx, e)}
//                         disabled={form.aadhaarVerified}
//                         className="w-12 h-12 text-center text-lg font-semibold rounded-xl border border-slate-300 bg-white focus:outline-none focus:ring-2 focus:ring-sky-400 disabled:bg-slate-100"
//                       />
//                     ))}
//                   </div>
//                 </div>
//               </>
//             )}

//             {/* Helper / Error / Success */}
//             <div className="min-h-[18px] text-center text-xs">

//               {/* 🔵 Loader for get-esign-status */}
//               {esignStatusLoading && (
//                 <div className="flex justify-center items-center gap-2 text-blue-600 py-2">
//                   <svg className="w-4 h-4 animate-spin" viewBox="0 0 24 24">
//                     <circle
//                       className="opacity-25"
//                       cx="12"
//                       cy="12"
//                       r="10"
//                       stroke="currentColor"
//                       strokeWidth="4"
//                     ></circle>
//                     <path
//                       className="opacity-75"
//                       fill="currentColor"
//                       d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
//                     ></path>
//                   </svg>
//                   Checking e-Sign status...
//                 </div>
//               )}

//               {/* 🔻 Hide all other messages when loader is running */}
//               {!esignStatusLoading && (
//                 <>
//                   {aadhaarError ? (
//                     <span className="text-red-600">{aadhaarError}</span>
//                   ) : form.aadhaarVerified || aadhaarStatus === "success" ? (
//                     <>
//                       <div className="w-full max-w-md rounded-2xl shadow-sm p-6 flex flex-col items-center gap-5">
//                         <img
//                           src={verifiedimg}
//                           alt="e-Sign Verified"
//                           className="w-40 h-40 object-contain bg-transparent"
//                         />
//                       </div>
//                       <span className="text-green-600">
//                         Verified ✅ e-Sign completed
//                       </span>
//                     </>
//                   ) : aadhaarStatus === "verifying" ? (
//                     <span className="text-slate-500">
//                       Waiting for you to complete e-Sign in the popup...
//                     </span>
//                   ) : (
//                     <span className="text-slate-500">
//                       We’ll redirect you to a secure UIDAI-compliant e-Sign partner.
//                     </span>
//                   )}
//                 </>
//               )}
//             </div>

//             {/* Button */}
//             {!form.aadhaarVerified && (
//               <button
//                 type="button"
//                 onClick={verifyAadhaar}
//                 disabled={
//                   !aadhaarValid ||
//                   aadhaarStatus === "loading" ||
//                   aadhaarStatus === "verifying" ||
//                   esignStatusLoading
//                 }
//                 className="w-full max-w-xs rounded-xl py-2.5 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 disabled:bg-slate-400"
//               >
//                 {esignStatusLoading
//                   ? "Checking Status..."
//                   : form.aadhaarVerified
//                   ? "e-Sign Verified"
//                   : "Verify & Open e-Sign"}
//               </button>
//             )}

//             {/* Small note */}
//             {!form.aadhaarVerified && (
//               <p className="text-[11px] text-center text-slate-500">
//                 By continuing, you consent to Aadhaar-based e-Sign for this agreement.
//               </p>
//             )}
//           </div>
//         </section>
//       )}
//     </div>
//   );
// }

// **************************************************************Working Code with payment***************************************************************************

// import { useEffect, useRef, useState } from "react";
// import InputField from "./InputField";
// import SelectField from "./SelectField";
// import toast from "react-hot-toast";
// import RegularLoader from "../Loader/RegularLoader";
// import BlueButton from "../Common/BlueButton";
// import { APPID, BASE_URL, SecretKey, SWAGGER_URL } from "../../config/api";
// import esign from "../../asset/images/esign.webp";
// import verifiedimg from "../../asset/images/verified.avif";

// export default function FormBody({ currentStep, form, updateField, selectedPackage, setSelectedPackage,panApiResponse, setPanApiResponse, verifyAadhaar, aadhaarStatus, setAadhaarStatus, setForm, esignStatusLoading, setIsPaymentSuccess,gstVerified,
//   setGstVerified, gstResponse, setGstResponse,bankVerified, setBankVerified, bankResponse, setBankResponse, }) {
//   const isUnregistered = form.gstTreatment === "unregistered";

//   const [errors, setErrors] = useState({});
//   const [emailOtpSent, setEmailOtpSent] = useState(false);
//   const [emailVerified, setEmailVerified] = useState(false);
//   const [phoneOtpSent, setPhoneOtpSent] = useState(false);
//   const [phoneVerified, setPhoneVerified] = useState(false);
//   const [emailOtp, setEmailOtp] = useState("");
//   const [phoneOtp, setPhoneOtp] = useState("");
//   const [packages, setPackages] = useState([]);
//   // const [selectedPackage, setSelectedPackage] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const authUser = JSON.parse(localStorage.getItem("authUserData") || "{}");
//   const id = authUser?.id;
//   const role = authUser?.role;
//   const [agreementUrl, setAgreementUrl] = useState(null);
//   const [hasScrolledToBottom, setHasScrolledToBottom] = useState(false);
//   const [panMessage, setPanMessage] = useState("");
//   // const [aadhaarStatus, setAadhaarStatus] = useState("idle"); // idle | loading | verifying | success | error
//   const [aadhaarError, setAadhaarError] = useState("");
//   const esignPopupRef = useRef(null);
//   const esignPollRef = useRef(null);
//   const aadhaarInputsRef = useRef([]);

//   const [isUploaded, setIsUploaded] = useState(false);

//   const [resendEmailTimer, setResendEmailTimer] = useState(0);

//   const [sendingOtp, setSendingOtp] = useState(false);
//   const [resendTimer, setResendTimer] = useState(0); // seconds
//   const [verifyingOtp, setVerifyingOtp] = useState(false);
//   const [uploading, setUploading] = useState(false);

//   const [paymentKeys, setPaymentKeys] = useState({
//     key_id: "",
//     key_secret: ""
//   });
//   const [keyLoading, setKeyLoading] = useState(false);
//   const [paymentCompleted, setPaymentCompleted] = useState(false);

//   const [gstLoading, setGstLoading] = useState(false);
//   const [bankLoading, setBankLoading] = useState(false);

//   const fetchPaymentKeys = async () => {
//   try {
//     setKeyLoading(true);

//     const res = await fetch(`${BASE_URL}payment/keys`);
//     const data = await res.json();

//     if (Array.isArray(data) && data.length > 0) {
//       setPaymentKeys({
//         key_id: data[0].key_id,
//         key_secret: data[0].key_secret
//       });
//     } else {
//       console.error("Invalid keys response", data);
//     }
//   } catch (err) {
//     console.error("Failed to fetch payment keys", err);
//   } finally {
//     setKeyLoading(false);
//   }
// };

//   useEffect(() => {
//   if (currentStep === 2) {
//     fetchPaymentKeys();
//   }
// }, [currentStep]);

//    const handleAadhaarBoxChange = (idx, value) => {
//     const digit = value.replace(/\D/g, "").slice(0, 1);

//     const chars = (form.aadhaarLast4 || "").split("");
//     while (chars.length < 4) chars.push("");
//     chars[idx] = digit;

//     const joined = chars.join("");
//     updateField("aadhaarLast4", joined);

//     if (digit && aadhaarInputsRef.current[idx + 1]) {
//       aadhaarInputsRef.current[idx + 1].focus();
//     }
//   };

//   const handleAadhaarKeyDown = (idx, e) => {
//     if (e.key === "Backspace" && !form.aadhaarLast4?.[idx]) {
//       if (aadhaarInputsRef.current[idx - 1]) {
//         aadhaarInputsRef.current[idx - 1].focus();
//       }
//     }
//     if (e.key === "ArrowLeft" && aadhaarInputsRef.current[idx - 1]) {
//       aadhaarInputsRef.current[idx - 1].focus();
//     }
//     if (e.key === "ArrowRight" && aadhaarInputsRef.current[idx + 1]) {
//       aadhaarInputsRef.current[idx + 1].focus();
//     }
//   };

//   const aadhaarValid =
//     form.aadhaarLast4 &&
//     form.aadhaarLast4.length === 4 &&
//     /^\d{4}$/.test(form.aadhaarLast4);

//   // NOTE: update verifyAadhaar() to accept last4 and return eSign URL (Promise<string>)
//   // const handleEsignClick = async () => {
//   //   if (!aadhaarValid) {
//   //     toast.error("Enter valid last 4 digits of Aadhaar");
//   //     return;
//   //   }

//   //   setAadhaarError("");
//   //   setAadhaarStatus("loading");

//   //   try {
//   //     // 👇 You must update verifyAadhaar to:
//   //     // async function verifyAadhaar(last4) { ... return esignUrl }
//   //     const esignUrl = await verifyAadhaar(form.aadhaarLast4);

//   //     if (!esignUrl) {
//   //       throw new Error("Invalid e-Sign link from server");
//   //     }

//   //     setAadhaarStatus("verifying");
//   //     openEsignPopup(esignUrl);
//   //   } catch (err) {
//   //     console.error(err);
//   //     setAadhaarStatus("error");
//   //     setAadhaarError(err?.message || "Failed to start e-Sign");
//   //     toast.error("Unable to start e-Sign");
//   //   }
//   // };

//   const cleanupEsignPopup = () => {
//     if (esignPollRef.current) {
//       clearInterval(esignPollRef.current);
//       esignPollRef.current = null;
//     }
//     if (esignPopupRef.current && !esignPopupRef.current.closed) {
//       try {
//         esignPopupRef.current.close();
//       } catch (e) {
//         console.error(e);
//       }
//     }
//     esignPopupRef.current = null;
//   };

//   const openEsignPopup = (url) => {
//     const w = 460;
//     const h = 640;
//     const dualScreenLeft =
//       window.screenLeft !== undefined ? window.screenLeft : window.screenX;
//     const dualScreenTop =
//       window.screenTop !== undefined ? window.screenTop : window.screenY;
//     const width =
//       window.innerWidth ||
//       document.documentElement.clientWidth ||
//       window.screen.width;
//     const height =
//       window.innerHeight ||
//       document.documentElement.clientHeight ||
//       window.screen.height;

//     const left = width / 2 - w / 2 + dualScreenLeft;
//     const top = height / 2 - h / 2 + dualScreenTop;

//     const features = `scrollbars=yes,resizable=yes,width=${w},height=${h},top=${top},left=${left}`;
//     esignPopupRef.current = window.open(url, "esignPopup", features);

//     // Fallback polling – if popup closed manually
//     esignPollRef.current = setInterval(() => {
//       if (!esignPopupRef.current || esignPopupRef.current.closed) {
//         clearInterval(esignPollRef.current);
//         esignPollRef.current = null;
//         esignPopupRef.current = null;

//         // Only reset state if we were waiting
//         if (aadhaarStatus === "verifying") {
//           setAadhaarStatus("idle");
//         }
//       } else {
//         // OPTIONAL: if your success page is same-origin and has /esign-success in URL
//         try {
//           const href = esignPopupRef.current.location.href || "";
//           if (href.includes("esign-success")) {
//             cleanupEsignPopup();
//             setAadhaarStatus("success");
//             updateField("aadhaarVerified", true);
//             toast.success("e-Sign verified successfully");
//           }
//         } catch {
//           // Cross-origin during provider flow – ignore
//         }
//       }
//     }, 800);
//   };

//   // Listen for postMessage from success page
//   useEffect(() => {
//     const handler = (e) => {
//       // In production, replace "*" with your exact origin and check e.origin
//       if (e?.data?.type === "ESIGN_SUCCESS") {
//         cleanupEsignPopup();
//         setAadhaarStatus("success");
//         updateField("aadhaarVerified", true);
//         toast.success("e-Sign verified successfully");
//       }
//       if (e?.data?.type === "ESIGN_CANCELLED") {
//         cleanupEsignPopup();
//         setAadhaarStatus("idle");
//         toast.error("e-Sign cancelled");
//       }
//     };

//     window.addEventListener("message", handler);
//     return () => window.removeEventListener("message", handler);
//   }, []);

//   const scrollRef = useRef(null);

//   const handleScroll = () => {
//     const el = scrollRef.current;
//     if (!el) return;

//     if (el.scrollTop + el.clientHeight >= el.scrollHeight - 5) {
//       setHasScrolledToBottom(true);
//     }
//   };

//   // Prefill form fields from localStorage on mount
//   useEffect(() => {
//     const storedUser = localStorage.getItem("authUserData");
//     if (storedUser) {
//       try {
//         const user = JSON.parse(storedUser);

//         updateField("address_line1", user.address_line1 || "");
//         updateField("address_line2", user.address_line2 || "");
//         updateField("state", user.state || "");
//         updateField("district", user.district || "");
//         updateField("city", user.city || "");
//         updateField("pincode", user.pincode || "");
//         updateField("email", user.contact_email || "");
//         updateField("phone", user.contact_phone || "");
//       } catch (err) {
//         console.error("Invalid session user data", err);
//       }
//     }
//   }, []);

//   // ---------------- Email + Phone OTP Logic ----------------
//   const sendEmailOtp = async () => {
//   const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

//   if (!form.email || !emailRegex.test(form.email)) {
//     setErrors(prev => ({ ...prev, email: "Enter a valid email address" }));
//     toast.error("Invalid email format");
//     return;
//   }

//   const storedUser = localStorage.getItem("authUserData");
//   const user = storedUser ? JSON.parse(storedUser) : null;
//   const userId = user?.id;

//   if (!userId) {
//     toast.error("User session not found");
//     return;
//   }

//   try {
//     const response = await fetch(`${BASE_URL}send-welcome-email/${userId}`, {
//       method: "GET",
//       cache: "no-store",
//     });

//     const result = await response.json();
//     console.log("API Response:", result);

//     if (result?.status) {
//       setEmailOtpSent(true);
//       localStorage.setItem("emailOtpSent", "true");

//       // ⏱️ Start 5 min timer for resend
//       const endTime = Date.now() + 5 * 60 * 1000;
//       localStorage.setItem("resendEmailOtpEndTime", endTime);
//       setResendEmailTimer(5 * 60); // seconds

//       toast.success("Email OTP sent successfully!");
//     } else {
//       toast.error("Failed to send email OTP");
//     }
//   } catch (error) {
//     console.error(error);
//     toast.error("Something went wrong. Try again!");
//   }
// };

//   useEffect(() => {
//     const storedEndTime = localStorage.getItem("resendEmailOtpEndTime");
//     if (storedEndTime) {
//       const remaining = Math.floor((storedEndTime - Date.now()) / 1000);
//       if (remaining > 0) setResendEmailTimer(remaining);
//       else localStorage.removeItem("resendEmailOtpEndTime");
//     }
//   }, []);

//   useEffect(() => {
//     if (resendEmailTimer <= 0) return;

//     const interval = setInterval(() => {
//       setResendEmailTimer(prev => {
//         if (prev <= 1) {
//           clearInterval(interval);
//           localStorage.removeItem("resendEmailOtpEndTime");
//           return 0;
//         }
//         return prev - 1;
//       });
//     }, 1000);

//     return () => clearInterval(interval);
//   }, [resendEmailTimer]);


//  const verifyEmailOtp = async () => {
//     try {
//       const authUser = JSON.parse(localStorage.getItem("authUserData") || "{}");

//       const role = Number(authUser.role);
//       const userId = authUser.id;

//       // ✅ role-based company_id rule
//       const companyId =
//         role === 2
//           ? 1
//           : authUser.company_id || authUser.id;

//       const res = await fetch(`${BASE_URL}verify-email-otp`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           email: form.email,
//           otp: emailOtp,
//           user_id: userId,
//           company_id: companyId,
//         }),
//       });

//       const data = await res.json();

//       if (data?.status) {
//         setEmailVerified(true);
//         localStorage.setItem("emailVerified", "true");
//         localStorage.setItem("verifiedEmail", form.email);

//         toast.success("Email Verified Successfully");
//       } else {
//         toast.error(data?.message || "Invalid OTP");
//       }
//     } catch (err) {
//       console.error(err);
//       toast.error("Something went wrong!");
//     }
//   };


//   useEffect(() => {
//     const savedEmailOtpSent = localStorage.getItem("emailOtpSent");
//     const savedEmailVerified = localStorage.getItem("emailVerified");
//     const savedEmail = localStorage.getItem("verifiedEmail");

//     if (savedEmailOtpSent === "true") setEmailOtpSent(true);
//     if (savedEmailVerified === "true") setEmailVerified(true);

//     if (savedEmail) {
//       setForm(prev => ({ ...prev, email: savedEmail }));
//     }
//   }, []);
  
//   // Automatically mark email as verified if user logged in with verified email
//   useEffect(() => {
//     const storedUser = localStorage.getItem("authUserData");
//     if (storedUser) {
//       try {
//         const user = JSON.parse(storedUser);

//         if (user.is_mail_verified === 1) {
//           setEmailVerified(true);
//           localStorage.setItem("emailVerified", "true");
//           localStorage.setItem("verifiedEmail", user.contact_email || "");
//           setForm(prev => ({
//             ...prev,
//             email: user.contact_email || "",
//           }));
//         }
//       } catch (err) {
//         console.error("Error parsing authUserData", err);
//       }
//     }
//   }, []);

//   const handleEmailChange = (value) => {
//     handleChange("email", value);

//     // Reset stored status if email changes
//     localStorage.removeItem("emailOtpSent");
//     localStorage.removeItem("emailVerified");
//     localStorage.removeItem("verifiedEmail");

//     setEmailOtpSent(false);
//     setEmailVerified(false);
//     setEmailOtp("");
//   };

//   const sendPhoneOtp = async () => {
//   if (!form.phone) return;

//   try {
//     setSendingOtp(true);

//     const response = await fetch(`${BASE_URL}send-wa-otp`, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ contact_phone: form.phone, company_id: authUser.id }),
//     });
//     const result = await response.json();

//     if (response.ok) {
//       setPhoneOtpSent(true);
//       localStorage.setItem("phoneOtpSent", "true");
//       toast.success("Phone OTP sent successfully!");

//       // Start 10 min timer
//       const endTime = Date.now() + 5 * 60 * 1000;
//       localStorage.setItem("resendOtpEndTime", endTime);
//       setResendTimer(5 * 60); // in seconds
//     } else {
//       toast.error(result.message || "Failed to send OTP");
//     }
//   } catch (error) {
//     toast.error("Failed to send OTP");
//   } finally {
//     setSendingOtp(false);
//   }
// };

//   useEffect(() => {
//   const storedEndTime = localStorage.getItem("resendOtpEndTime");
//   if (storedEndTime) {
//     const remaining = Math.floor((storedEndTime - Date.now()) / 1000);
//     if (remaining > 0) setResendTimer(remaining);
//     else localStorage.removeItem("resendOtpEndTime");
//   }
// }, []);

//   useEffect(() => {
//     if (resendTimer <= 0) return;

//     const interval = setInterval(() => {
//       setResendTimer(prev => {
//         if (prev <= 1) {
//           clearInterval(interval);
//           localStorage.removeItem("resendOtpEndTime");
//           return 0;
//         }
//         return prev - 1;
//       });
//     }, 1000);

//     return () => clearInterval(interval);
//   }, [resendTimer]);

//   const verifyPhoneOtp = async () => {
//     if (!phoneOtp) {
//       toast.error("Enter OTP");
//       return;
//     }

//     try {
//       setVerifyingOtp(true);

//       const response = await fetch(`${BASE_URL}verify-wa-otp`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ contact_phone: form.phone, otp: phoneOtp }),
//       });
//       const result = await response.json();

//       if (!response.ok) throw new Error(result.message);

//       setPhoneVerified(true);
//       localStorage.setItem("phoneVerified", "true");
//       localStorage.removeItem("phoneOtp");
//       localStorage.removeItem("phoneOtpSent");

//       toast.success("Phone Verified Successfully!");
//     } catch (error) {
//       toast.error(error.message || "Invalid OTP");
//     } finally {
//       setVerifyingOtp(false);
//     }
//   };

//   useEffect(() => {
//     const storedPhoneSent = localStorage.getItem("phoneOtpSent");
//     const storedPhoneVerified = localStorage.getItem("phoneVerified");
//     const storedPhoneOtp = localStorage.getItem("phoneOtp");

//     if (storedPhoneSent === "true") setPhoneOtpSent(true);
//     if (storedPhoneVerified === "true") setPhoneVerified(true);
//     if (storedPhoneOtp) setPhoneOtp(storedPhoneOtp);
//   }, []);

//   // Automatically mark phone as verified if user logged in with verified phone
//   useEffect(() => {
//     const storedUser = localStorage.getItem("authUserData");
//     if (storedUser) {
//       try {
//         const user = JSON.parse(storedUser);

//         if (user.is_wa_verified === 1) {
//           setPhoneVerified(true);
//           localStorage.setItem("phoneVerified", "true");
//           localStorage.setItem("verifiedPhone", user.contact_phone || "");
//           setForm(prev => ({
//             ...prev,
//             phone: user.contact_phone || "",
//           }));
//         }
//       } catch (err) {
//         console.error("Error parsing authUserData", err);
//       }
//     }
//   }, []);

//   // ---------------- Validation ----------------
//   const validateField = (field, value, isUnregistered = false) => {
//   let error = "";

//   switch (field) {
//     case "email":
//       if (!value) error = "Email is required";
//       else {
//         const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//         if (!emailRegex.test(value)) error = "Invalid email format";
//       }
//       break;

//     case "phone":
//       if (!value) error = "Phone is required";
//       else {
//         const phoneRegex = /^[6-9][0-9]{9}$/;
//         if (!phoneRegex.test(value)) error = "Invalid phone number format";
//       }
//       break;

//     case "panNumber": 
//       if (!value) error = "Enter PAN Number";
//       else {
//         const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
//         if (!panRegex.test(value)) error = "Invalid PAN format (e.g. ABCDE1234F)";
//       }
//       break;

//     case "gstTreatment":
//       if (!value) error = "Select GST treatment";
//       break;

//     case "gstin":
//       if (!value) {
//         error = isUnregistered ? "Enter PAN number" : "Enter GSTIN / UIN";
//       } else {
//         if (isUnregistered) {
//           const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
//           if (!panRegex.test(value)) error = "Invalid PAN format";
//         } else {
//           const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/;
//           if (!gstRegex.test(value)) error = "Invalid GSTIN format";
//         }
//       }
//       break;

//     case "businessName":
//       if (!value) error = "Enter legal business name";
//       break;

//     case "accountNumber":
//       if (!value) error = "Enter account number";
//       break;

//     case "ifsc":
//       if (!value) error = "Enter IFSC code";
//       else {
//         const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
//         if (!ifscRegex.test(value)) error = "Invalid IFSC format";
//       }
//       break;

//     case "bankName":
//       if (!value) error = "Enter bank name";
//       break;

//     case "authorisedName":
//       if (!value) error = "Authorised person is required";
//       break;

//     case "agreed":
//       if (!value) error = "You must accept the agreement to continue";
//       break;

//     default:
//       break;
//   }

//   setErrors((prev) => ({ ...prev, [field]: error }));
//   return error === "";
// };

// // ---------------- PAN VALIDATION FUNCTION ----------------
// const isValidPAN = (pan) => {
//   const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
//   return panRegex.test(pan);
// };

//   useEffect(() => {
//     const sessionData = localStorage.getItem("authUserData");
//     if (sessionData) {
//       const user = JSON.parse(sessionData);
//       if (user.pan_verified) {
//         setForm(prev => ({ ...prev, panNumber: user.pan }));
//         setPanApiResponse(user.pan_json ? JSON.parse(user.pan_json) : null);
//         setForm(prev => ({ ...prev, panVerified: true }));
//       }
//     }
//   }, []);


// // ---------------- PAN VERIFY API CALL ----------------
//   const verifyPAN = async () => {
//     if (!form.panNumber) return;
//     if (!isValidPAN(form.panNumber)) {
//       validateField("panNumber", form.panNumber);
//       return;
//     }

//     try {
//       setLoading(true);

//       const payload = {
//         pan: form.panNumber,
//         verification_id: form.panNumber,
//         name: authUser?.contact_person,
//       };

//       const response = await fetch(`${SWAGGER_URL}/Cashfree/pan-advance`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           AppId: APPID,
//           SecretKey: SecretKey,
//         },
//         body: JSON.stringify(payload),
//       });

//       const data = await response.json();

//       if (response.ok && data?.status === "VALID") {

//         updateField("panVerified", true);

//         // 🔥 store full response in parent onboarding
//         setPanApiResponse(data);

//         toast.success(data?.message || "PAN Verified Successfully!");
//       } else {
//         toast.error(data?.message || "Verification Failed.");
//       }
//     } catch (error) {
//       toast.error("Something went wrong.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const verifyGST = async () => {
//   if (!form.gstin || !form.businessName) {
//     toast.error("Enter GSTIN and Business Name");
//     return;
//   }

//   try {
//     setGstLoading(true);

//     const res = await fetch(`${SWAGGER_URL}/Cashfree/gstin-verify`, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         AppId: APPID,
//         SecretKey: SecretKey,
//       },
//       body: JSON.stringify({
//         gstin: form.gstin,
//         name: form.businessName,
//       }),
//     });

//     const data = await res.json();

//     if (res.ok && data?.valid === true) {
//       toast.success("GST Verified Successfully");

//       setGstVerified(true);
//       setGstResponse(data);

//       setForm(prev => ({
//         ...prev,
//         gstin: data.GSTIN,
//         businessName: data.legal_name_of_business,
//         tradeName: data.trade_name_of_business || "",
//       }));
//     } else {
//       toast.error(data?.message || "GST Verification Failed");
//       setGstVerified(false);
//       setGstResponse(null);
//     }
//   } catch {
//     toast.error("GST verification failed");
//   } finally {
//     setGstLoading(false);
//   }
// };


// const verifyBankAccount = async () => {
//   if (!form.accountNumber || !form.ifsc) {
//     toast.error("Enter account number and IFSC");
//     return;
//   }

//   try {
//     setBankLoading(true);

//     const res = await fetch(`${SWAGGER_URL}/Cashfree/bank-verify-v2`, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         AppId: APPID,
//         SecretKey: SecretKey,
//       },
//       body: JSON.stringify({
//         bank_account: form.accountNumber,
//         ifsc: form.ifsc,
//         name: form.businessName,
//         phone: form.phone,
//       }),
//     });

//     const data = await res.json();

//     if (res.ok && data.account_status_code === "ACCOUNT_IS_VALID") {
//       toast.success("Bank account verified");

//       setBankVerified(true);
//       setBankResponse(data);

//       setForm(prev => ({
//         ...prev,
//         bankName: data.bank_name,
//         branchname: data.branch,
//         ifsc: data.ifsc_details?.ifsc || prev.ifsc,
//       }));
//     } else {
//       toast.error("Invalid bank details");
//       setBankVerified(false);
//       setBankResponse(null);
//     }
//   } catch {
//     toast.error("Bank verification failed");
//   } finally {
//     setBankLoading(false);
//   }
// };


// useEffect(() => {
//   const sessionData = localStorage.getItem("authUserData");
//   if (sessionData) {
//     const user = JSON.parse(sessionData);

//     // Pre-fill GST / Business details
//     setForm(prev => ({
//       ...prev,
//       gstTreatment: user.business_type || "",       // regular, composition, unregistered
//       gstin: user.gst || user.pan || "",         // GSTIN or PAN if unregistered
//       businessName: user.business_name || "",
//       tradeName: user.trade_name || "",
//     }));
//   }
// }, []);

// useEffect(() => {
//   if (form.gstTreatment === "unregistered" && form.panNumber) {
//     setForm(prev => ({
//       ...prev,
//       gstin: form.panNumber,
//     }));
//     setGstVerified(true); // no verification needed
//   }
// }, [form.gstTreatment, form.panNumber]);

// useEffect(() => {
//   const sessionData = localStorage.getItem("authUserData");
//   if (!sessionData) return;

//   const user = JSON.parse(sessionData);

//   if (user?.gst_verified === 1 && user?.gst_json) {
//     setGstVerified(true);
//     setGstResponse(JSON.parse(user.gst_json));

//     setForm(prev => ({
//       ...prev,
//       gstin: user.gst,
//       businessName: user.business_name,
//       tradeName: user.trade_name,
//     }));
//   }
// }, []);

// useEffect(() => {
//   const sessionData = localStorage.getItem("authUserData");
//   if (sessionData) {
//     const user = JSON.parse(sessionData);

//     setForm(prev => ({
//       ...prev,
//       accountType: user.account_type || "",
//       accountNumber: user.account_no || "",
//       ifsc: user.ifsc_code || "",
//       branchname: user.branch_name || "",
//       bankName: user.bank_name || "",
//       authorisedName: user.contact_person || "",
//       // Optional: you can pre-fill bankProofType if you store it
//     }));
//   }
// }, []);


//   useEffect(() => {
//     const sessionData = localStorage.getItem("authUserData");
//     if (!sessionData) return;

//     const user = JSON.parse(sessionData);

//     if (user?.bank_verified === 1 && user?.bank_json) {
//       const bankData = JSON.parse(user.bank_json);

//       setBankVerified(true);
//       setBankResponse(bankData);

//       setForm(prev => ({
//         ...prev,
//         accountNumber: user.account_no,
//         ifsc: user.ifsc_code,
//         bankName: user.bank_name,
//         branchname: user.branch_name,
//       }));
//     }
//   }, []);



//   const handleChange = (field, value) => {
//     if (field === "gstin" || field === "ifsc") value = value.toUpperCase();

//     // 🔥 Autofill logic: when business name is entered, set authorisedName same
//     if (field === "businessName") {
//       updateField("authorisedName", value);
//     }

//     updateField(field, value);
//     validateField(field, value);
//   };


//   // const handlePayment = () => {
//   //   if (!selectedPackage) return;

//   //   if (!paymentKeys.key_id) {
//   //     alert("Payment keys not loaded!");
//   //     return;
//   //   }

//   //   const options = {
//   //     key: paymentKeys.key_id,
//   //     key_secret: paymentKeys.key_secret, // Razorpay does NOT use this on frontend
//   //     amount: selectedPackage.amount * 100,
//   //     id:"order_LKsdf98asfa",
//   //     currency: "INR",
//   //     name: "GO Electronix",
//   //     description: selectedPackage.package_name,
//   //     handler: function (response) {
//   //       alert("Payment Successful 🎉");
//   //       console.log("Payment ID:", response.razorpay_payment_id);
//   //       console.log("Order ID:", response.razorpay_order_id);
//   //       console.log("Signature:", response.razorpay_signature);
//   //     },
//   //     prefill: {
//   //       name: authUser?.name || "",
//   //       email: authUser?.email || "",
//   //       contact: authUser?.mobile || "",
//   //     },
//   //     theme: { color: "#2563eb" },
//   //   };

//   //   const rzp = new window.Razorpay(options);
//   //   rzp.open();
//   // };


//   const handlePayment = () => {
//   if (!selectedPackage) return;

//   if (!paymentKeys.key_id) {
//     alert("Payment keys not loaded!");
//     return;
//   }

//   const options = {
//     key: paymentKeys.key_id,
//     amount: selectedPackage.amount * 100, 
//     currency: "INR",
//     name: "GO Electronix",
//     description: selectedPackage.package_name,

//     handler: async function (response) {
//       const paymentId = response.razorpay_payment_id;
//       const orderId = response.razorpay_order_id;
//       const signature = response.razorpay_signature;

//       console.log("Payment Success:", response);

//       // Disable button after payment success
//       setPaymentCompleted(true);

//       // ---------- SESSION DATA ----------
//       const company_id = authUser?.company_id;
//       const lead_id = authUser?.leads?.[0]?.lead_code;
//       const zoho_id = authUser?.zoho_id;
//       const role = authUser?.role;

//       const payload = {
//         company_id,
//         lead_id,
//         payment_id: paymentId,
//         amount: selectedPackage.amount,
//         status: response,
//         payment_date: new Date().toISOString().slice(0, 19).replace("T", " "),
//         customer_id: zoho_id,
//         payment_from: "WARRANTY",
//         notes: selectedPackage.package_name,
//         role,
//       };

//       try {
//         const res = await fetch(`${BASE_URL}zoho/create-online-payment`, {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(payload),
//         });

//         const data = await res.json();
//         console.log("Callback Response:", data);

//         if (!res.ok) {
//           toast.error("Payment saved but server rejected callback!");
//           return;
//         }

//         toast.success("Payment Successful & Saved in Zoho 🎉");
//         // ✅ mark payment success in parent (RetailerOnboarding)
//         setIsPaymentSuccess(true);

//       } catch (err) {
//         console.error(err);
//         toast.error("Payment succeeded but failed to update Zoho!");
//       }
//     },


//       prefill: {
//         name: authUser?.name || "",
//         email: authUser?.contact_email || "",
//         contact: authUser?.contact_phone || "",
//       },

//       theme: { color: "#2563eb" },
//     };

//     const rzp = new window.Razorpay(options);
//     rzp.open();
//   };


//   // const handlePaymentSuccess = async () => {
//   //   const payload = {
//   //     retailer_id: authUser?.id,
//   //     status: "payment_done",
//   //     package_id: selectedPackage.id,
//   //   };

//   //   await postStepUpdate(payload, "Payment Step");
//   // };

//   useEffect(() => {
//     if (currentStep === 2) fetchPackages();
//   }, [currentStep]);

//   const fetchPackages = async () => {
//     try {
//       setLoading(true);
//       const res = await fetch(`${BASE_URL}packages`);
//       const data = await res.json();
//       setPackages(data || []);
//     } catch (err) {
//       toast.error("Failed to load packages");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (
//       !loading &&
//       packages.length > 0 &&
//       authUser?.leads?.length > 0 &&
//       !selectedPackage  // <-- Prevent overwriting user selection
//     ) {
//       const assignedPackageId = authUser.leads[0].package_id;
//       const foundPackage = packages.find(p => p.id === assignedPackageId);

//       if (foundPackage) setSelectedPackage(foundPackage);
//     }
//   }, [loading, packages, authUser, selectedPackage]);

//   const handleUpload = async () => {
//   if (!form.bankProofFile || !form.bankProofType) {
//     toast.error("Please select file and type");
//     return;
//   }

//   try {
//     setUploading(true); // start loading

//     const formData = new FormData();
//     formData.append("flag", form.bankProofType);
//     formData.append("file", form.bankProofFile);
//     formData.append("email", form.email);

//     const res = await fetch(`${BASE_URL}user/upload-file`, {
//       method: "POST",
//       body: formData,
//     });

//     const data = await res.json();

//     if (data.status) {
//       toast.success("File uploaded successfully!");
//       setIsUploaded(true);
//     } else {
//       toast.error(data.message || "Upload failed");
//     }
//   } catch (error) {
//     console.error(error);
//     toast.error("Something went wrong.");
//   } finally {
//     setUploading(false); // stop loading
//   }
// };

//   const fetchAgreement = async () => {
//     try {
//       const response = await fetch(`${BASE_URL}agreement/${role}/${id}`, {
//         method: "GET",
//         headers: {
//           "Content-Type": "application/json",
//           // Authorization: `Bearer ${token}`,/ // include only if API needs it
//         },
//       });

//       const data = await response.json();

//       if (data?.status && data?.download_url) {
//         setAgreementUrl(data.download_url);
//       } else {
//         toast.error("Failed to fetch agreement.");
//       }
//     } catch (err) {
//       console.error(err);
//       toast.error("Server error while fetching agreement.");
//     }
//   };

//   useEffect(() => {
//     if (currentStep === 6 && !agreementUrl) {
//       fetchAgreement();
//     }
//   }, [currentStep]);

//   const handleAgreementCheck = (checked) => {
//     handleChange("agreed", checked);

//     if (checked && hasScrolledToBottom) {
//       updateField("esignVerified", 1);
//     } else {
//       updateField("esignVerified", 0);
//     }
//   };

//   useEffect(() => {
//     if (panApiResponse?.name_pan_card && !form.authorisedName) {
//       updateField("authorisedName", panApiResponse.name_pan_card);
//     }
//   }, [panApiResponse]);

//   const handleEsignClick = async () => {
//     const link = await verifyAadhaar();

//     if (link) {
//       window.open(
//         link,
//         "_blank",
//         "width=600,height=900,resizable=yes,scrollbars=yes"
//       );
//     }
//   };



//   // ---------------- Render ----------------
//   return (
//     <div className="space-y-6">
//       {/* STEP 1 : EMAIL + PHONE VERIFICATION */}
//       {currentStep === 1 && (
//         <section className="space-y-8">
//           {/* ---------------- Store Address ---------------- */}
//           <div className="space-y-4">
//             <h2 className="text-lg font-semibold text-slate-900">Store Address</h2>
//             <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
//               <InputField
//                 label="State"
//                 value={form.state}
//                 onChange={(value) => handleChange("state", value)}
//                 placeholder="Enter state"
//               />
//               <InputField
//                 label="District"
//                 value={form.district}
//                 onChange={(value) => handleChange("district", value)}
//                 placeholder="Enter district"
//               />
//               <InputField
//                 label="City"
//                 value={form.city}
//                 onChange={(value) => handleChange("city", value)}
//                 placeholder="Enter city"
//               />
//               <InputField
//                 label="Pincode"
//                 required
//                 value={form.pincode}
//                 onChange={(value) => handleChange("pincode", value)}
//                 placeholder="Enter pincode"
//               />
//             </div>

//             <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//               <InputField
//                 label="Address Line 1"
//                 required
//                 value={form.address_line1}
//                 onChange={(value) => handleChange("address_line1", value)}
//                 placeholder="Shop / Building / Street"
//               />
//               <InputField
//                 label="Address Line 2"
//                 value={form.address_line2}
//                 onChange={(value) => handleChange("address_line2", value)}
//                 placeholder="Landmark (Optional)"
//               />
//             </div>
//           </div>

//           {/* ---------------- Contact Verification ---------------- */}
//           <div className="space-y-4">
//             <h2 className="text-lg font-semibold text-slate-900">Verify Email & Phone</h2>

//             {/* EMAIL */}
//             <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-end">
//               {emailVerified ? (
//                <div className="col-span-4 md:col-span-1 flex flex-col gap-2 p-2 bg-green-50 border border-green-300 rounded-md">
//                   <p className="text-green-700 font-medium">
//                       ✔ Email Verified: <span className="font-semibold">{form.email}</span>
//                     </p>
//                   </div>
//               ) : (
//                 <>
//                   <InputField
//                     label="Email"
//                     required
//                     value={form.email}
//                     onChange={(value) => handleEmailChange(value)}
//                     placeholder="Enter your email"
//                     error={errors.email}
//                   />

//                   {/* ⏳ UPDATED BUTTON WITH TIMER */}
//                   <button
//                     onClick={sendEmailOtp}
//                     disabled={resendEmailTimer > 0}
//                     className={`h-[42px] md:w-[120px] rounded-lg text-sm text-white transition
//                     ${resendEmailTimer > 0 ? "bg-gray-400 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700"}`}
//                   >
//                     {resendEmailTimer > 0
//                       ? `Resend in ${Math.floor(resendEmailTimer / 60)}:${String(resendEmailTimer % 60).padStart(2, "0")}`
//                       : emailOtpSent
//                       ? "Resend OTP"
//                       : "Send OTP"}
//                   </button>

//                   {emailOtpSent && (
//                     <>
//                       <InputField
//                         label="Email OTP"
//                         value={emailOtp}
//                         onChange={(v) => setEmailOtp(v)}
//                         placeholder="Enter OTP"
//                       />
//                       <button
//                         onClick={verifyEmailOtp}
//                         className="h-[42px] md:w-[120px] bg-green-600 text-white rounded-lg text-sm"
//                       >
//                         Verify
//                       </button>
//                     </>
//                   )}
//                 </>
//               )}

//             </div>
//             {/* {emailVerified && <p className="text-green-600 text-sm">✔ Email verified successfully</p>} */}

//             {/* PHONE */}
//             <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-end">
//               {!phoneVerified && (
//               <InputField
//                 label="Phone"
//                 required
//                 value={form.phone}
//                 onChange={(value) => handleChange("phone", value)}
//                 placeholder="Enter phone number"
//                 error={errors.phone}
//               />
//               )}
//               {/* If phone already verified */}
//               {phoneVerified ? (
//                 <div className="col-span-4 md:col-span-1 flex flex-col gap-2 p-2 bg-green-50 border border-green-300 rounded-md">
//                   <p className="text-green-700 font-medium">
//                     ✔ Phone verified successfully : <span className="font-semibold">{form.phone}</span>
//                   </p>
//                 </div>
//               ) : (
//                 <>
//                   {!phoneVerified && (
//                     <button
//                       onClick={sendPhoneOtp}
//                       disabled={!emailVerified || resendTimer > 0 || sendingOtp}
//                       className={`h-[42px] md:w-[120px] rounded-lg text-sm text-white
//                         ${!emailVerified || resendTimer > 0 || sendingOtp ? "bg-gray-300 cursor-not-allowed" : "bg-blue-600"}`}
//                     >
//                       {sendingOtp
//                         ? "Sending..."
//                         : resendTimer > 0
//                         ? `Resend in ${Math.floor(resendTimer / 60)}:${String(resendTimer % 60).padStart(2, "0")}`
//                         : phoneOtpSent
//                         ? "Resend OTP"
//                         : "Send OTP"}
//                     </button>
//                   )}
//                   {phoneOtpSent && !phoneVerified && (
//                     <InputField
//                       label="Phone OTP"
//                       value={phoneOtp}
//                       onChange={(v) => {
//                         setPhoneOtp(v);
//                         localStorage.setItem("phoneOtp", v); // persist typed OTP
//                       }}
//                       placeholder="Enter OTP"
//                     />

//                   )}
//                   {phoneOtpSent && !phoneVerified && (
//                     <button
//                       onClick={verifyPhoneOtp}
//                       disabled={verifyingOtp}
//                       className={`h-[42px] md:w-[120px] rounded-lg text-sm text-white
//                         ${verifyingOtp ? "bg-gray-300 cursor-not-allowed" : "bg-green-600"}`}
//                     >
//                       {verifyingOtp ? "Verifying..." : "Verify"}
//                     </button>

//                   )}
//                 </>
//               )}
//             </div>

//             {/* {phoneVerified && <p className="text-green-600 text-sm">✔ Phone verified successfully</p>} */}
//           </div>
//         </section>
//       )}

//       {/* STEP 2 - Payment */}
//       {currentStep === 2 && (
//         <section className="p-4">
//           <h2 className="text-lg font-semibold text-slate-900 mb-4 text-left">
//             Choose Your Package
//           </h2>

//           {loading || keyLoading ? (
//             <RegularLoader />
//           ) : (
//             <>
//               {packages.length === 0 && (
//                 <p className="text-center text-red-600">No packages available.</p>
//               )}

//               {packages.length > 0 && (
//                 <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-3 max-h-[70vh] overflow-y-auto">

//                   {packages.map((pkg) => (
//                     <div
//                       key={pkg.id}
//                       onClick={() => setSelectedPackage(pkg)}
//                       className={`cursor-pointer border rounded-xl p-4 shadow-sm transition duration-200 
//                         ${
//                           selectedPackage?.id === pkg.id
//                             ? "border-blue-600 bg-blue-50"
//                             : "border-gray-300 hover:border-blue-400 hover:bg-blue-50"
//                         }
//                       `}
//                     >
                      
//                       {authUser?.leads?.[0]?.package_id === pkg.id && (
//                         <span className="text-[10px] ml-2 text-blue-600 font-semibold">(Assigned)</span>
//                       )}
//                       {/* Title */}
//                       <h4 className="text-lg font-semibold text-gray-800">
//                         {pkg.package_name}
//                         <span className="text-blue-700"> (₹{pkg.amount})</span>
//                       </h4>

//                       {/* Validity */}
//                       <p className="text-xs text-gray-500">Validity: {pkg.validity_days} Days</p>

//                       {/* Badge Section */}
//                       {pkg.badge && (
//                         <div className="mt-3 p-2 rounded-lg border border-gray-200">

//                           <span className="text-xs font-semibold bg-blue-200 text-blue-800 px-2 py-1 rounded">
//                             {pkg.badge.name}
//                           </span>

//                           <p className="text-xs text-gray-700 mt-2">
//                             {pkg.badge.description}
//                           </p>

//                           <div className="text-xs text-gray-700 mt-2 space-y-1">
//                             <p><span className="font-semibold">Eligibility:</span> {pkg.badge.eligibility} Users</p>
//                             <p><span className="font-semibold">Benefits:</span> {pkg.badge.benefits}% Extra</p>
//                           </div>

//                         </div>
//                       )}
//                     </div>
//                   ))}
//                 </div>
//               )}

//               {/* Payment Button Centered */}
//               <div className="flex justify-center mt-6">
//                 <button
//                   disabled={!selectedPackage || paymentCompleted}
//                   onClick={handlePayment}
//                   className={`px-6 py-2.5 rounded-lg text-sm font-medium transition
//                     ${
//                       !selectedPackage || paymentCompleted
//                         ? "bg-slate-300 text-slate-500 cursor-not-allowed"
//                         : "bg-blue-600 text-white hover:bg-blue-700"
//                     }`}
//                 >
//                   {paymentCompleted
//                     ? "Payment Completed ✔"
//                     : selectedPackage
//                     ? `Proceed to Pay ₹${selectedPackage.amount}`
//                     : "Select a Package to Continue"}
//                 </button>
//               </div>
//             </>
//           )}
//         </section>
//       )}

//       {/* ------- The rest of your steps remain UNCHANGED ------- */}

//       {currentStep === 3 && (
//         <section>
//           <h2 className="text-lg font-semibold text-slate-900 mb-4">
//             PAN Verification
//           </h2>

//           <div className="grid gap-4 md:grid-cols-2">
//             <InputField
//               label="PAN Number"
//               value={form.panNumber}
//               disabled={form.panVerified} // ✅ disable if already verified
//               readOnly={form.panVerified}
//               className={`${form.panVerified ? "bg-gray-100 text-gray-500 cursor-not-allowed" : ""}`}
//               onChange={(val) => !form.panVerified && updateField("panNumber", val.toUpperCase())}
//               onBlur={() => validateField("panNumber", form.panNumber)}
//               placeholder="ABCDE1234F"
//               error={errors.panNumber}
//             />

//             <div className="flex items-end">
//               <button
//                 onClick={verifyPAN}
//                 disabled={
//                   form.panVerified || // ✅ already verified
//                   !form.panNumber ||
//                   !isValidPAN(form.panNumber) ||
//                   loading
//                 }
//                 className={`px-4 py-2 rounded-lg transition text-white w-full md:w-auto
//                   ${form.panVerified ? "bg-green-600 cursor-default" : "bg-blue-600 hover:bg-blue-700 disabled:bg-gray-400"}
//                 `}
//               >
//                 {form.panVerified ? "Verified ✓" : loading ? "Verifying..." : "Verify PAN"}
//               </button>
//             </div>
//           </div>

//           {/* PAN verification message */}
//           {panMessage && (
//             <p className={`text-xs mt-2 font-medium ${form.panVerified ? "text-green-600" : "text-red-500"}`}>
//               {panMessage}
//             </p>
//           )}

//           {/* Show verified PAN details if available */}
//           {form.panVerified && panApiResponse && (
//             <div className="mt-6 border rounded-lg p-4 bg-green-50">
//               <h3 className="text-md font-semibold text-green-700 mb-3">
//                 PAN Details Verified ✓
//               </h3>

//               <div className="grid md:grid-cols-2 gap-3 text-sm">
//                 <p><strong>PAN:</strong> {panApiResponse.pan}</p>
//                 <p><strong>Name:</strong> {panApiResponse.name_pan_card}</p>
//                 <p><strong>Gender:</strong> {panApiResponse.gender}</p>
//                 <p><strong>DOB:</strong> {panApiResponse.date_of_birth}</p>
//                 <p><strong>Mobile:</strong> {panApiResponse.mobile_number}</p>
//                 <p><strong>Email:</strong> {panApiResponse.email}</p>
//                 <p><strong>Aadhaar Linked:</strong> {panApiResponse.aadhaar_linked ? "Yes" : "No"}</p>
//                 <p><strong>City:</strong> {panApiResponse.address?.city}</p>
//                 <p><strong>State:</strong> {panApiResponse.address?.state}</p>
//                 <p><strong>Pincode:</strong> {panApiResponse.address?.pincode}</p>
//                 <p><strong>Type:</strong> {panApiResponse.type}</p>
//               </div>

//               <p className="mt-2 text-xs text-gray-600">
//                 <strong>Full Address:</strong> {panApiResponse.address?.full_address}
//               </p>
//             </div>
//           )}
//         </section>
//       )}

//       {currentStep === 4 && (
//         <section>
//           <h2 className="text-lg font-semibold text-slate-900 mb-4">GST details</h2>
//           <div className="grid gap-4 md:grid-cols-2">
//             <SelectField
//               label="GST Treatment"
//               required
//               value={form.gstTreatment}
//               onChange={(value) => handleChange("gstTreatment", value)}
//               options={[
//                 { value: "regular", label: "Regular" },
//                 { value: "composition", label: "Composition" },
//                 { value: "unregistered", label: "Unregistered" },
//               ]}
//               error={errors.gstTreatment}
//             />

//             <InputField
//               label={form.gstTreatment === "unregistered" ? "PAN Number" : "GSTIN / UIN"}
//               required
//               value={form.gstin}
//               onChange={(value) => handleChange("gstin", value)}
//               placeholder={form.gstTreatment === "unregistered" ? "ABCDE1234F" : "22AAAAA0000A1Z5 (15 digits)"}
//               error={errors.gstin}
//               readOnly={!!form.gstin} // Optional: make read-only if already present
//             />
//           </div>

//           <div className="mt-4 grid gap-4 md:grid-cols-2">
//             <InputField
//               label="Business Legal Name"
//               required
//               value={form.businessName}
//               onChange={(value) => handleChange("businessName", value)}
//               placeholder="Exact legal name"
//               error={errors.businessName}
//               readOnly={!!form.businessName} // Optional
//             />

//             <InputField
//               label="Trade Name (Optional)"
//               value={form.tradeName}
//               onChange={(value) => handleChange("tradeName", value)}
//               placeholder="Trade name"
//               readOnly={!!form.tradeName} // Optional
//             />
//           </div>

//           {form.gstTreatment !== "unregistered" && (
//             <button
//               type="button"
//               onClick={verifyGST}
//               disabled={gstVerified || gstLoading}
//               className={`mt-3 px-4 py-2 rounded-lg text-sm text-white
//                 ${gstVerified ? "bg-green-600" : "bg-blue-600 hover:bg-blue-700"}
//               `}
//             >
//               {gstVerified ? "Verified ✓" : gstLoading ? "Verifying..." : "Verify GST"}
//             </button>
//           )}

//           {gstVerified && gstResponse && (
//             <div className="mt-4 border rounded-lg p-4 bg-green-50 text-sm">
//               <h3 className="font-semibold text-green-700 mb-2">
//                 GST Verified ✓
//               </h3>

//               <div className="grid md:grid-cols-2 gap-2">
//                 <p><strong>GSTIN:</strong> {gstResponse.GSTIN}</p>
//                 <p><strong>Status:</strong> {gstResponse.gst_in_status}</p>
//                 <p><strong>Legal Name:</strong> {gstResponse.legal_name_of_business}</p>
//                 <p><strong>Trade Name:</strong> {gstResponse.trade_name_of_business}</p>
//               </div>
//             </div>
//           )}

//         </section>
//       )}


//       {currentStep === 5 && (
//         <section>
//           <h2 className="text-lg font-semibold text-slate-900 mb-4">
//             Bank account details
//           </h2>

//           <div className="grid gap-4 md:grid-cols-3">
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 Account Type
//               </label>
//               <select
//                 className="border rounded-lg p-2 w-full"
//                 value={form.accountType}
//                 onChange={(e) => handleChange("accountType", e.target.value)}
//                 disabled={!!form.accountType} // optional read-only if already present
//               >
//                 <option value="">Select Account Type</option>
//                 <option value="current">Current</option>
//                 <option value="saving">Saving</option>
//               </select>
//             </div>

//             <InputField
//               label="Account Number"
//               required
//               value={form.accountNumber}
//               onChange={(value) => handleChange("accountNumber", value)}
//               placeholder="Enter account number"
//               error={errors.accountNumber}
//               readOnly={!!form.accountNumber} // optional
//             />

//             <InputField
//               label="IFSC Code"
//               required
//               value={form.ifsc}
//               onChange={(value) => handleChange("ifsc", value)}
//               placeholder="e.g. HDFC0001234"
//               error={errors.ifsc}
//               readOnly={!!form.ifsc} // optional
//             />
//           </div>

//           <div className="grid gap-4 md:grid-cols-3 mt-4">
//             <InputField
//               label="Branch Name"
//               required
//               value={form.branchname}
//               onChange={(value) => handleChange("branchname", value)}
//               placeholder="Branch name"
//               error={errors.branchname}
//               readOnly={!!form.branchname}
//             />
//             <InputField
//               label="Bank Name"
//               required
//               value={form.bankName}
//               onChange={(value) => handleChange("bankName", value)}
//               placeholder="Bank name"
//               error={errors.bankName}
//               readOnly={!!form.bankName}
//             />
//             <InputField
//               label="Authorised Person Name"
//               required
//               value={form.authorisedName}
//               onChange={(value) => handleChange("authorisedName", value)}
//               placeholder="Auto-filled"
//               error={errors.authorisedName}
//               readOnly={!!form.authorisedName}
//             />
//           </div>

//           <div className="grid gap-4 md:grid-cols-2 mt-6">
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-1">
//                 Upload Proof (Select One)
//               </label>
//               <select
//                 className="border rounded-lg p-2 w-full"
//                 value={form.bankProofType}
//                 onChange={(e) => handleChange("bankProofType", e.target.value)}
//               >
//                 <option value="">Select Document Type</option>
//                 <option value="passbook">Passbook Photo</option>
//                 <option value="cheque">Cancelled Cheque</option>
//               </select>
//             </div>

//             {form.bankProofType && (
//               <div className="p-4 border border-gray-300 rounded-lg">
//                 <p className="text-sm text-gray-600 mb-3">
//                   Upload:{" "}
//                   <span className="font-semibold">
//                     {form.bankProofType === "passbook" ? "Passbook Photo" : "Cancelled Cheque"}
//                   </span>
//                 </p>

//                 <div className="flex items-center gap-3 mt-2">
//                   <input
//                     type="file"
//                     accept="image/*,application/pdf"
//                     onChange={(e) => handleChange("bankProofFile", e.target.files[0])}
//                     className="w-full text-sm"
//                   />
//                   <BlueButton
//                     onClick={handleUpload}
//                     disabled={
//                       !form.bankProofFile ||
//                       !form.bankProofType ||
//                       uploading ||
//                       isUploaded   // ⬅️ disabled after success
//                     }
//                   >
//                     {isUploaded ? "Uploaded" : uploading ? "Uploading..." : "Upload"}
//                   </BlueButton>


//                 </div>

//                 {form.bankProofFile && (
//                   <p className="text-green-600 text-sm mt-2">
//                     File selected: {form.bankProofFile.name}
//                   </p>
//                 )}
//               </div>
//             )}
//           </div>

//           <button
//             type="button"
//             onClick={verifyBankAccount}
//             disabled={bankVerified || bankLoading}
//             className={`mt-5 px-4 py-2 rounded-lg text-sm text-white
//               ${bankVerified ? "bg-green-600" : "bg-blue-600 hover:bg-blue-700"}
//             `}
//           >
//             {bankVerified ? "Verified ✓" : bankLoading ? "Verifying..." : "Verify Account"}
//           </button>

//           {bankVerified && bankResponse && (
//             <div className="mt-4 border rounded-lg p-4 bg-green-50 text-sm">
//               <h3 className="font-semibold text-green-700 mb-2">
//                 Bank Account Verified ✓
//               </h3>

//               <div className="grid md:grid-cols-2 gap-2">
//                 <p><strong>Bank:</strong> {bankResponse.bank_name}</p>
//                 <p><strong>Branch:</strong> {bankResponse.branch}</p>
//                 <p><strong>IFSC:</strong> {bankResponse.ifsc_details?.ifsc}</p>
//                 <p><strong>Account Status:</strong> {bankResponse.account_status}</p>
//                 <p><strong>Name at Bank:</strong> {bankResponse.name_at_bank}</p>
//               </div>
//             </div>
//           )}

//         </section>
//       )}

//       {currentStep === 6 && (
//         <section>
//           <h2 className="text-lg font-semibold text-slate-900 mb-4">
//             Sign User Agreement
//           </h2>

//           {agreementUrl ? (
//             <div className="flex justify-center min-h-screen bg-white">
//               <div className="bg-slate-50 border p-2 rounded-xl text-xs text-slate-600 flex flex-col gap-3 max-w-[800px] w-full items-center shadow-md">
//                 <div
//                   ref={scrollRef}
//                   onScroll={handleScroll}
//                   className="border rounded-xl bg-white shadow-inner p-2 w-full h-[700px] overflow-y-auto"
//                 >
//                   <iframe
//                     src={`https://docs.google.com/viewer?url=${agreementUrl}&embedded=true`}
//                     title="Agreement PDF"
//                     className="w-full h-[1400px]"
//                   />
//                 </div>

//                 <a
//                   href={agreementUrl}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="text-blue-600 underline font-medium text-sm"
//                 >
//                   Download Agreement PDF
//                 </a>
//               </div>
//             </div>
//           ) : (
//             <RegularLoader />
//           )}

//           {/* Agreement Checkbox */}
//           <label className="mt-4 flex items-start gap-2">
//             <input
//               type="checkbox"
//               className="mt-1 w-4 h-4"
//               checked={form.agreed}
//               disabled={!hasScrolledToBottom}
//               onChange={(e) => handleAgreementCheck(e.target.checked)}
//             />
//             <span
//               className={`text-sm ${
//                 !hasScrolledToBottom ? "text-gray-400" : "text-slate-700"
//               }`}
//             >
//               I agree to the user agreement.
//             </span>
//           </label>

//           {!hasScrolledToBottom && (
//             <p className="text-xs text-red-500 mt-1">
//               Scroll to the bottom to enable agreement.
//             </p>
//           )}
//         </section>
//       )}

//        {/* {currentStep === 7 && (
//           <section className="flex justify-center">
//             <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white/80 shadow-sm backdrop-blur p-6 flex flex-col items-center gap-5">

              
//               {!form.aadhaarVerified && (
//                 <>
                  
//                   <div className="flex items-center gap-3 w-full">
//                     <div className="shrink-0 rounded-xl p-3 bg-gradient-to-br from-sky-500/10 to-indigo-500/10">
//                       <img
//                         src={esign}
//                         alt="Aadhaar e-Sign"
//                         className="w-10 h-10 object-contain"
//                       />
//                     </div>
//                     <div className="flex-1">
//                       <h2 className="text-base md:text-lg font-semibold text-slate-900">
//                         Aadhaar e-Sign Verification
//                       </h2>
//                       <p className="text-xs text-slate-500">
//                         Enter the last 4 digits of your Aadhaar. We’ll open a secure e-Sign window.
//                       </p>
//                     </div>
//                   </div>

                 
//                   <div className="mt-2 flex justify-center w-full">
//                     <div className="flex gap-2">
//                       {Array.from({ length: 4 }).map((_, idx) => (
//                         <input
//                           key={idx}
//                           ref={(el) => (aadhaarInputsRef.current[idx] = el)}
//                           inputMode="numeric"
//                           pattern="[0-9]*"
//                           type="text"
//                           maxLength={1}
//                           value={form?.aadhaarLast4?.[idx] || ""}
//                           onChange={(e) => handleAadhaarBoxChange(idx, e.target.value)}
//                           onKeyDown={(e) => handleAadhaarKeyDown(idx, e)}
//                           disabled={form.aadhaarVerified}
//                           className="w-12 h-12 text-center text-lg font-semibold rounded-xl border border-slate-300 bg-white focus:outline-none focus:ring-2 focus:ring-sky-400 disabled:bg-slate-100"
//                         />
//                       ))}
//                     </div>
//                   </div>
//                 </>
//               )}

              
//               <div className="min-h-[18px] text-center text-xs">
//                 {aadhaarError ? (
//                   <span className="text-red-600">{aadhaarError}</span>
//                 ) : form.aadhaarVerified || aadhaarStatus === "success" ? (
//                   <>
//                  <div className="w-full max-w-md rounded-2xl shadow-sm p-6 flex flex-col items-center gap-5">
//                     <img
//                       src={verifiedimg} // make sure this points to your verified.avif file
//                       alt="e-Sign Verified"
//                       className="w-40 h-40 object-contain bg-transparent"
//                     />

//                   </div>


//                   <span className="text-green-600">Verified ✅ e-Sign completed</span>
//                   </>
                  
//                 ) : aadhaarStatus === "verifying" ? (
//                   <span className="text-slate-500">
//                     Waiting for you to complete e-Sign in the popup...
//                   </span>
//                 ) : (
//                   <span className="text-slate-500">
//                     We’ll redirect you to a secure UIDAI-compliant e-Sign partner.
//                   </span>
//                 )}
//               </div>

             
//               {!form.aadhaarVerified && (
//                 <button
//                   type="button"
//                   onClick={verifyAadhaar}
//                   disabled={
//                     !aadhaarValid ||
//                     form.aadhaarVerified ||
//                     aadhaarStatus === "loading" ||
//                     aadhaarStatus === "verifying"
//                   }
//                   className="w-full max-w-xs rounded-xl py-2.5 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 disabled:bg-slate-400"
//                 >
//                   {form.aadhaarVerified ? "e-Sign Verified" : "Verify & Open e-Sign"}
//                 </button>
//               )}

//               {!form.aadhaarVerified && (
//               <p className="text-[11px] text-center text-slate-500">
//                 By continuing, you consent to Aadhaar-based e-Sign for this agreement.
//               </p>
//               )}
//             </div>
//           </section>
//         )} */}

//       {currentStep === 7 && (
//         <section className="flex justify-center">
//           <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white/80 shadow-sm backdrop-blur p-6 flex flex-col items-center gap-5">

//             {/* Only show header & input boxes if NOT verified */}
//             {!form.aadhaarVerified && (
//               <>
//                 {/* Header */}
//                 <div className="flex items-center gap-3 w-full">
//                   <div className="shrink-0 rounded-xl p-3 bg-gradient-to-br from-sky-500/10 to-indigo-500/10">
//                     <img
//                       src={esign}
//                       alt="Aadhaar e-Sign"
//                       className="w-10 h-10 object-contain"
//                     />
//                   </div>
//                   <div className="flex-1">
//                     <h2 className="text-base md:text-lg font-semibold text-slate-900">
//                       Aadhaar e-Sign Verification
//                     </h2>
//                     <p className="text-xs text-slate-500">
//                       Enter the last 4 digits of your Aadhaar. We’ll open a secure e-Sign window.
//                     </p>
//                   </div>
//                 </div>

//                 {/* 4 Input Boxes */}
//                 <div className="mt-2 flex justify-center w-full">
//                   <div className="flex gap-2">
//                     {Array.from({ length: 4 }).map((_, idx) => (
//                       <input
//                         key={idx}
//                         ref={(el) => (aadhaarInputsRef.current[idx] = el)}
//                         inputMode="numeric"
//                         pattern="[0-9]*"
//                         type="text"
//                         maxLength={1}
//                         value={form?.aadhaarLast4?.[idx] || ""}
//                         onChange={(e) => handleAadhaarBoxChange(idx, e.target.value)}
//                         onKeyDown={(e) => handleAadhaarKeyDown(idx, e)}
//                         disabled={form.aadhaarVerified}
//                         className="w-12 h-12 text-center text-lg font-semibold rounded-xl border border-slate-300 bg-white focus:outline-none focus:ring-2 focus:ring-sky-400 disabled:bg-slate-100"
//                       />
//                     ))}
//                   </div>
//                 </div>
//               </>
//             )}

//             {/* Helper / Error / Success */}
//             <div className="min-h-[18px] text-center text-xs">

//               {/* 🔵 Loader for get-esign-status */}
//               {esignStatusLoading && (
//                 <div className="flex justify-center items-center gap-2 text-blue-600 py-2">
//                   <svg className="w-4 h-4 animate-spin" viewBox="0 0 24 24">
//                     <circle
//                       className="opacity-25"
//                       cx="12"
//                       cy="12"
//                       r="10"
//                       stroke="currentColor"
//                       strokeWidth="4"
//                     ></circle>
//                     <path
//                       className="opacity-75"
//                       fill="currentColor"
//                       d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
//                     ></path>
//                   </svg>
//                   Checking e-Sign status...
//                 </div>
//               )}

//               {/* 🔻 Hide all other messages when loader is running */}
//               {!esignStatusLoading && (
//                 <>
//                   {aadhaarError ? (
//                     <span className="text-red-600">{aadhaarError}</span>
//                   ) : form.aadhaarVerified || aadhaarStatus === "success" ? (
//                     <>
//                       <div className="w-full max-w-md rounded-2xl shadow-sm p-6 flex flex-col items-center gap-5">
//                         <img
//                           src={verifiedimg}
//                           alt="e-Sign Verified"
//                           className="w-40 h-40 object-contain bg-transparent"
//                         />
//                       </div>
//                       <span className="text-green-600">
//                         Verified ✅ e-Sign completed
//                       </span>
//                     </>
//                   ) : aadhaarStatus === "verifying" ? (
//                     <span className="text-slate-500">
//                       Waiting for you to complete e-Sign in the popup...
//                     </span>
//                   ) : (
//                     <span className="text-slate-500">
//                       We’ll redirect you to a secure UIDAI-compliant e-Sign partner.
//                     </span>
//                   )}
//                 </>
//               )}
//             </div>

//             {/* Button */}
//             {!form.aadhaarVerified && (
//               <button
//                 type="button"
//                 onClick={verifyAadhaar}
//                 disabled={
//                   !aadhaarValid ||
//                   aadhaarStatus === "loading" ||
//                   aadhaarStatus === "verifying" ||
//                   esignStatusLoading
//                 }
//                 className="w-full max-w-xs rounded-xl py-2.5 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 disabled:bg-slate-400"
//               >
//                 {esignStatusLoading
//                   ? "Checking Status..."
//                   : form.aadhaarVerified
//                   ? "e-Sign Verified"
//                   : "Verify & Open e-Sign"}
//               </button>
//             )}

//             {/* Small note */}
//             {!form.aadhaarVerified && (
//               <p className="text-[11px] text-center text-slate-500">
//                 By continuing, you consent to Aadhaar-based e-Sign for this agreement.
//               </p>
//             )}
//           </div>
//         </section>
//       )}
//     </div>
//   );
// }
